<template>
  <div>
    <!-- Chargement -->
    <div v-if="loading" class="text-xs-center tf_loading">
      <v-progress-circular indeterminate class="primary--text" :size="100" :width="1"></v-progress-circular>
    </div>
    <div v-else class="mb-5">
      <v-container grid-list-lg>
        <v-layout row wrap justify-space-between>
          <!-- SELECTION DU SITE -->
          <v-flex xs6 sm4 md4 >
            <wz-select-one-site
            @update:site="updateSite"
            ></wz-select-one-site>
          </v-flex>

          <!-- BOTS -->
          <v-flex xs6 sm4 md4 v-if="(!isLevelFaq())">
            <!--
            <wz-select-bots
              :bots.sync="bot"
              :botsInit="$store.state._User.bots"
              :min="1"
              @reInitBots="reInitBots"
            ></wz-select-bots>
            -->
            <!--
            <wz-select-bots
              v-if="$store.state._Sites.siteSelected.DSK_BOT_ONOFF == '1'"
              :bot.sync="bot"
              :listeBots="$store.state._User.bots"
              :openFromExt="openListeChatbot"
              @closeListe="closeListe"
              @reInitBots="reInitBots"
            ></wz-select-bots>
            -->
            <div
              v-if="$store.state._Sites.siteSelected.DSK_BOT_ONOFF == '1'"
            >
            <wz-avatar 
              :username=JSON.parse($store.state._Sites.siteSelected.DSK_BOT_USER).user_name
              :src="`${domaine}/public/media/user/small/${JSON.parse($store.state._Sites.siteSelected.DSK_BOT_USER).user_id}_avatar.jpg`"
              size="35px"
            ></wz-avatar>
            {{ JSON.parse($store.state._Sites.siteSelected.DSK_BOT_USER).user_name }}
          </div>
          </v-flex>
        </v-layout>
      </v-container>

      <v-expansion-panel>
        <!-- PROMPS -->
        <v-expansion-panel-content >
          <template v-slot:header>
            <div>{{  $t('AIPromptSys') }}</div>
          </template>
          <v-card>
            <v-card-text class="pb-0">
              <div class="text-xs-right">
                <v-btn small @click="enhance('personality')" color="primary" dark>
                  Enhance with AI
                  <v-icon right>draw</v-icon>
                </v-btn>
                <v-btn small @click="version('personality')" color="primary" dark>
                  Historic
                  <v-icon right>rebase_edit</v-icon>
                </v-btn>
              </div>
            </v-card-text>
            <div v-if="loadingPrompt" class="text-xs-center tf_loading">
              <v-progress-circular indeterminate class="primary--text" :size="100" :width="1"></v-progress-circular>
            </div>
            <v-card-text v-else>
              <v-container>
                <!--- Personnalité -->
                <v-layout row wrap >
                  <v-flex xs12>
                    <h3 class="mb-0">{{  $t('AIPersonnality') }}</h3>
                    <v-textarea
                      v-model="prompt_personality"
                      :label="$t('AIPersonnalityDesc')"
                      counter
                      maxlength="500"
                    ></v-textarea>
                  </v-flex>
                </v-layout>

                <!--- Environnement -->
                <v-layout row wrap >
                  <v-flex xs12>
                    <h3 class="mb-0">{{  $t('AIEnviron') }}</h3>
                    <v-textarea
                      v-model="prompt_environment"
                      :label="$t('AIEnvironDesc')"
                      counter
                      maxlength="500"
                    ></v-textarea>
                  </v-flex>
                </v-layout>
                <!--- Objectif -->
                <v-layout row wrap >
                  <v-flex xs12>
                    <h3 class="mb-0">{{  $t('AIObjective') }}</h3>
                    <v-textarea
                      v-model="prompt_objectif"
                      :label="$t('AIObjectiveDesc')"
                      counter
                      maxlength="500"
                    ></v-textarea>
                  </v-flex>
                </v-layout>
                <!--- Ton et Communication -->
                <v-layout row wrap >
                  <v-flex xs12>
                    <h3 class="mb-0">{{  $t('AICommunication') }}</h3>
                    <v-textarea
                      v-model="prompt_communication"
                      :label="$t('AICommunicationDesc')"
                      counter
                      maxlength="500"
                    ></v-textarea>
                  </v-flex>
                </v-layout>
                <!--- Questions obligatoires -->
                <v-layout row wrap >
                  <v-flex xs12>
                    <h3 class="mb-0">{{  $t('AIQuestion') }}</h3>
                    <v-textarea
                      v-model="prompt_questions"
                      :label="$t('AIQuestionDesc')"
                      counter
                      maxlength="500"
                    ></v-textarea>
                  </v-flex>
                </v-layout>
                <!--- Règles à suivre -->
                <v-layout row wrap >
                  <v-flex xs12>
                    <h3 class="mb-0">{{  $t('AIRules') }}</h3>
                    <v-textarea
                      v-model="prompt_rules"
                      :label="$t('AIRulesDesc')"
                      counter
                      maxlength="500"
                    ></v-textarea>
                  </v-flex>
                </v-layout>
                <!--- Outils disponibles -->
                <v-layout row wrap >
                  <v-flex xs12>
                    <h3 class="mb-0">{{  $t('AITools') }}</h3>
                    <v-textarea
                      v-model="prompt_tools"
                      :label="$t('AIToolsDesc')"
                      counter
                      maxlength="500"
                    ></v-textarea>
                  </v-flex>
                </v-layout>
                <!--- Section personnalisée -->
                <v-layout row wrap >
                  <v-flex xs12>
                    <h3 class="mb-0">{{  $t('AICustom') }}</h3>
                    <v-textarea
                      v-model="prompt_custom"
                      :label="$t('AICustomDesc')"
                      counter
                      maxlength="5000"
					  rows="5"
					  auto-grow
                    ></v-textarea>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-text-field
                      v-model="prompt_name"
                      label="Que change cette version ?"
                      hint="Décrivez brièvement les modifications apportées — visible dans l'historique."
                      persistent-hint
                      maxlength="255"
                      counter
                    ></v-text-field>
                  </v-flex>
                </v-layout>

                <!--- prompt global -->
                <v-layout row wrap v-if="0">
                  <v-flex xs12>
                    <h3 class="mb-0">{{  $t('AiPromptGlobal') }}</h3>
                    <v-textarea
                      v-model="prompt"
                      :label="$t('AiPromptGlobalDesc')"
                      counter
					  disabled
                    ></v-textarea>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
		
        <!-- ACCUEIL -->
        <v-expansion-panel-content >
          <template v-slot:header>
            <div>{{  $t('AIAccueilBot') }}</div>
          </template>
          <v-card>
            <div v-if="loadingPrompt" class="text-xs-center tf_loading">
              <v-progress-circular indeterminate class="primary--text" :size="100" :width="1"></v-progress-circular>
            </div>
            <v-card-text v-else>
              <v-container>
                <!--- message d'accueil du chatbot -->
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-text-field
                      v-model="messageAccueil"
                      :label="$t('ADMessAcc')"
                      :placeholder="$t('ADMessAccExem')"
                    ></v-text-field>
                  </v-flex>
                </v-layout>


                <!--- Question 1 -->
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-text-field
                      v-model="questionAuto1"
                      :label="$t('AIQuestion1')"
                      :placeholder="$t('AIQuestion1Sample')"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <!--- Question 2 -->
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-text-field
                      v-model="questionAuto2"
                      :label="$t('AIQuestion2')"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <!--- Question 3 -->
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-text-field
                      v-model="questionAuto3"
                      :label="$t('AIQuestion3')"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <!--- Question 4 -->
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-text-field
                      v-model="questionAuto4"
                      :label="$t('AIQuestion4')"
                    ></v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout row wrap >
                  <!--- envoyer directement le message, ou non -->
                  <v-flex xs12>
                    <v-switch 
                      :label="comportment ? $t('AIQuestionClickChoicesSend'): $t('AIQuestionClickChoicesDisplay')"
                      light
                      v-model="comportment"
                      color="primary"
                      @change="switchComportment()"
                    ></v-switch>
                  </v-flex>
                </v-layout>
				
                <v-layout row wrap >
                  <!--- afficher la petite phrase au dessus -->
                  <v-flex xs12>
                    <v-switch 
                      :label="showEx ? $t('AIExempleShow') + ' ON' : $t('AIExempleShow') + ' OFF'"
                      light
                      v-model="showEx"
                      color="primary"
                      @change="switchExemple()"
                    ></v-switch>
                  </v-flex>
                </v-layout>

                <!--- exemple de dialogue utilisé dans le prompt de chat -->
                <!---<v-flex xs12 v-if="(!isLevelFaq())">
                  <h3 class="headline mb-0">{{ $t('AIExempChat')}}</h3>
                  <v-textarea
                    v-model="dialog"
                    :label="$t('AIExempChatTxt')"
                    :placeholder="$t('AIExempChatPH')"
                    counter
                    maxlength="1500"
                  ></v-textarea>
                </v-flex>-->
              </v-container>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
		
        <!-- Description/Parametres -->
        <v-expansion-panel-content >
          <template v-slot:header>
            <div>{{  $t('AIDescTitle') }}</div>
          </template>
          <v-card>
            <div v-if="loadingPrompt" class="text-xs-center tf_loading">
              <v-progress-circular indeterminate class="primary--text" :size="100" :width="1"></v-progress-circular>
            </div>
            <v-card-text v-else>
              <v-container>
                <!--- url du site à parser -->
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-text-field
                      v-model="parseUrl"
                      :label="$t('AIScanUrl')"
                      placeholder="www.website.com"
                    ></v-text-field>
                  </v-flex>
                </v-layout>

                <!--- element pour le parsing du contenu html -->
                <v-layout row wrap v-if="(!isLevelFaq())">
                  <v-flex md4 xs12>
                    <v-select
                      v-model="methodSelect"
                      :items="methodList"
                      label="méthode"
                      @change="changeModel"
                      disabled
                    ></v-select>
                  </v-flex>
                  <v-flex md8 xs12>
                    <v-text-field
                      v-model="parseElement"
                      :label="$t('AIScanHtml')"
                      placeholder=".className"
                      disabled
                    ></v-text-field>
                  </v-flex>
                </v-layout>

                <!--- option de réponde du bot -->
                <v-layout row wrap v-if="(!isLevelFaq())">
                  <v-flex md3 xs12>
                    <v-subheader class="pl-0">{{$t('AINumResSearch')}} : {{ sliderSearchResponse }}</v-subheader>
                    <v-slider
                      v-model="sliderSearchResponse"
                      thumb-label
                      step="1"
                      ticks="always"
                      :max="maxSearch"
                      :min="minSearch"
                    ></v-slider>
                  </v-flex>
                </v-layout>

                <v-layout row wrap v-if="(!isLevelFaq())">
                  <!--- instruction du prompt de recherche -->
                  <v-flex xs12 v-if="(!isLevelFaq())">
                    <h3 class="headline mb-0">{{ $t('AIPromptResSearch') }}</h3>
                    <v-textarea
                      v-model="promptSearch"
                      :label="$t('AIPromptResSearchTxt')"
                      counter
                      maxlength="5000"
                    ></v-textarea>
                  </v-flex>
                </v-layout>

                <v-layout row wrap v-if="(!isLevelFaq())">
                  <!--- selectionne automatiquement le premier produit du carrousel -->
                  <v-flex xs12>
                    <v-switch
                      v-model="productSelectAuto"
                      :label="$t('AIProdSelect')"
                    ></v-switch>
                  </v-flex>
                </v-layout>

              </v-container>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>

        <!-- parsing Selectif -->
        <v-expansion-panel-content
          :class="[ getPermissionsAdmin ? 'active' : 'hidden' ]"
        >
          <template v-slot:header>
            <div>{{ $t('AIParsPageTitle') }} ({{ parsingSelectif.length }})</div>
          </template>
          <v-card>
            <v-card-text>
              <v-container>
                <!--- element pour le parsing du contenu html -->
                <v-layout row wrap>
                  <!--- JSON pour les function_call -->
                  <v-flex xs12>
                    {{ $t('AIParsPageTxt') }}
                    <v-expansion-panel>
                      <v-expansion-panel-content
                        v-for="(parsing, i) in parsingSelectif"
                        :key="i"
                      >
                        <template v-slot:header>
                          <div><strong>{{parsing.name}}</strong></div>
                        </template>
                        <!--- element pour le parsing du contenu html -->
                        <v-card>
                          <v-card-text>
                            <v-layout row wrap>
                              <v-flex md3 xs6>
                                <v-text-field
                                  v-if="!parsing.default"
                                  v-model="parsing.name"
                                  :label="$t('AIParsPageUrl')"
                                  :placeholder="$t('AIParsPageUrl')"

                                ></v-text-field>
                                <v-text-field
                                  v-else
                                  v-model="parsing.name"
                                  :label="$t('AIParsPageDefaut')"
                                  disabled
                                ></v-text-field>
                              </v-flex>

                              <v-flex md3 xs6>
                                <v-select
                                  v-model="parsing.methode"
                                  :items="methodList"
                                  :label="$t('AIParsPageMethode')"

                                ></v-select>
                              </v-flex>
                              <v-flex md5 xs11>
                                <v-textarea
                                  v-model="parsing.elements"
                                  :label="$t('AIScanHtml')"
                                  :hint="$t('AIParsPageExem')"
                                  persistent-hint
                                  box
                                >
                                </v-textarea>
                              </v-flex>
                              <v-flex md1 xs1
                                v-if="!parsing.default"
                              >
                                <v-tooltip left >
                                  <template slot="activator">
                                    <v-btn
                                      flat
                                      icon
                                      color="red lighten-2"
                                      @click.native="delParsing(parsing)"
                                    >
                                      <v-icon>delete</v-icon>
                                    </v-btn>
                                  </template>
                                  <span>{{$t('AISuppParse')}}</span>
                                </v-tooltip>
                              </v-flex>

                              
                            </v-layout>
                          </v-card-text>
                        </v-card>
                        
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                    
                    <div >
                      <v-btn flat icon color="primary"
                        @click.native="addParsing"
                      >
                        <v-icon>add</v-icon>
                      </v-btn>
                      {{  $t('AIAddParse') }}
                    </div>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>

        <!-- Appel de fonction -->
        <v-expansion-panel-content
          :class="[ getPermissionsAdmin ? 'active' : 'hidden' ]"
        >
          <template v-slot:header>
            <div>{{  $t('AIFunctionTitle') }} ({{ fonctionsNum }}/9)</div>
          </template>
          <v-card>
            <v-card-text>
              <v-container>
                <!--- element pour le parsing du contenu html -->
                <v-layout row wrap>
                  <!--- JSON pour les function_call -->
                  <v-flex xs12>
                    {{  $t('AIFunctionContent') }}
                    <v-expansion-panel>
                      <v-expansion-panel-content
                        v-for="(fonction, i) in fonctions"
                        :key="i"
                      >

                        <template v-slot:header>
                          <div
                            :style="functionCallOnOff[i] ? 'opacity: 1' : 'opacity: 0.5'"
                          ><strong>{{fonction.name ? fonction.name : fonction.type}}</strong> : ({{ fonction.description }})</div>
                        </template>
                        <v-card>
                          <v-card-text>
                            <v-switch
                              v-model="functionCallOnOff[i]"
                              :label="`Tool ${i}: ${(functionCallOnOff[i] ? 'ON' : 'OFF')}`"
                            ></v-switch>
                            <v-textarea
                              v-if="i === 0"
                              v-model="function0"
                            ></v-textarea>
                            <v-textarea
                              v-else-if="i === 1"
                              v-model="function1"
                            ></v-textarea>
                            <v-textarea
                              v-else-if="i === 2"
                              v-model="function2"
                            ></v-textarea>
                            <v-textarea
                              v-else-if="i === 3"
                              v-model="function3"
                            ></v-textarea>
                            <v-textarea
                              v-else-if="i === 4"
                              v-model="function4"
                            ></v-textarea>
                            <v-textarea
                              v-else-if="i === 5"
                              v-model="function5"
                            ></v-textarea>
                            <v-textarea
                              v-else-if="i === 6"
                              v-model="function6"
                            ></v-textarea>
                            <v-textarea
                              v-else-if="i === 7"
                              v-model="function7"
                            ></v-textarea>
                            <v-textarea
                              v-else-if="i === 8"
                              v-model="function8"
                            ></v-textarea>
                          </v-card-text>
                        </v-card>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-card v-if="addFonctionsNum === 1 && fonctionsNum !== addFonctionsNum">
                      <v-card-text>
                        <v-textarea
                          v-model="function0"
                        ></v-textarea>
                      </v-card-text>
                    </v-card>
                    <v-card v-else-if="addFonctionsNum === 2 && fonctionsNum !== addFonctionsNum">
                      <v-card-text>
                        <v-textarea
                          v-model="function1"
                        ></v-textarea>
                      </v-card-text>
                    </v-card>
                    <v-card v-else-if="addFonctionsNum === 3 && fonctionsNum !== addFonctionsNum">
                      <v-card-text>
                        <v-textarea
                          v-model="function2"
                        ></v-textarea>
                      </v-card-text>
                    </v-card>
                    <v-card v-else-if="addFonctionsNum === 4 && fonctionsNum !== addFonctionsNum">
                      <v-card-text>
                        <v-textarea
                          v-model="function3"
                        ></v-textarea>
                      </v-card-text>
                    </v-card>
                    <v-card v-else-if="addFonctionsNum === 5 && fonctionsNum !== addFonctionsNum">
                      <v-card-text>
                        <v-textarea
                          v-model="function4"
                        ></v-textarea>
                      </v-card-text>
                    </v-card>
                    <v-card v-else-if="addFonctionsNum === 6 && fonctionsNum !== addFonctionsNum">
                      <v-card-text>
                        <v-textarea
                          v-model="function5"
                        ></v-textarea>
                      </v-card-text>
                    </v-card>
                    <v-card v-else-if="addFonctionsNum === 7 && fonctionsNum !== addFonctionsNum">
                      <v-card-text>
                        <v-textarea
                          v-model="function6"
                        ></v-textarea>
                      </v-card-text>
                    </v-card>
                    <v-card v-else-if="addFonctionsNum === 8 && fonctionsNum !== addFonctionsNum">
                      <v-card-text>
                        <v-textarea
                          v-model="function7"
                        ></v-textarea>
                      </v-card-text>
                    </v-card>
                    <v-card v-else-if="addFonctionsNum === 9 && fonctionsNum !== addFonctionsNum">
                      <v-card-text>
                        <v-textarea
                          v-model="function8"
                        ></v-textarea>
                      </v-card-text>
                    </v-card>

                    <div v-if="(addFonctionsNum - fonctionsNum) === 0 && fonctionsNum < 8 && addFonctionsNum < 8">
                      <v-btn flat icon color="primary"
                        @click.native="addFunction"
                      >
                        <v-icon>add</v-icon>
                      </v-btn>
                      {{ $t('AIAddFunction')}}
                    </div>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>

        <!-- Modèles LLM -->
        <v-expansion-panel-content
          :class="[ getPermissionsAdmin ? 'active' : 'hidden' ]"
        >
          <template v-slot:header>
            <div>{{  $t('AILLMTitle') }}</div>
          </template>
          <v-card>
            <div v-if="loadingPrompt" class="text-xs-center tf_loading">
              <v-progress-circular indeterminate class="primary--text" :size="100" :width="1"></v-progress-circular>
            </div>
            <v-card-text v-else>
              <v-container>
                <!--- element pour le parsing du contenu html -->
                <v-layout row wrap>
                  <v-flex md4 xs12>
                    <v-select
                      v-model="modelSelect"
                      :items="modelListObject"
                      item-text="name"
                      item-value="tokens"
                      :label="this.$t('AIModele')"
                      :hint="this.$t('AILLMTokenMax')+` ${modelSelect.tokens}`"
                      persistent-hint
                      return-object
                      @change="changeMethod"
                    ></v-select>
                  </v-flex>
                  <v-flex md4 xs12
                    v-if="isGptModel"
                  >
                    <v-select
                      v-model="APISelect"
                      :items="APIListObject"
                      item-text="name"
                      :label="this.$t('APIModele')"
                      persistent-hint
                      return-object
                      @change="changeMethod"
                    ></v-select>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex md3 xs12>
                    <v-subheader class="pl-0">{{ $t('AILLMResp') }} {{ sliderTokenResponse }}</v-subheader>
                    <v-slider
                      v-model="sliderTokenResponse"
                      thumb-label
                      step="10"
                      ticks="always"
                      :max="maxToken"
                      :min="minToken"
                    ></v-slider>
                  </v-flex> 
                  <v-flex md1></v-flex>
                  <!--- mise à jour auto par tache cron -->
                  <v-flex md3 xs12>
                    <v-switch
                      v-model="botStream"
                      :label="this.$t('AILLMStream')"
                    ></v-switch>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-subheader class="pl-0">{{ $t('AILLMTemp') }} {{ sliderTemp }}</v-subheader>
                    <v-slider
                      v-model="sliderTemp"
                      thumb-label
                      step="0.01"
                      ticks="always"
                      :max="maxTemp"
                      :min="minTemp"
                    ></v-slider>
                  </v-flex>
                </v-layout> 
              </v-container>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>

        <!-- Création des résumés des fiches produits -->
        <v-expansion-panel-content
          :class="[ getPermissions ? 'active' : 'hidden' ]"
        >
          <template v-slot:header>
            <div>{{ $t('AIResumeTitle')}}</div>
          </template>
          <v-card>
            <v-card-text>
              <v-layout row wrap justify-space-between>
                <!-- Prompte de créatyion de résumé -->
                <v-flex xs12>
                  <v-textarea
                    v-model="promptResume"
                    :label="this.$t('AIResumeContent')"
                    counter
                    maxlength="5000"
                  ></v-textarea>
                </v-flex>

                <v-flex xs2 v-if="products.length">
                  <v-btn
                    color="primary"
                    :loading="loadingResumePromptAPI"
                    :disabled="loadingResumePromptAPI || !selectedProduct.length"
                    @click.native="testPromptResumeAPI"
                  >
                    {{ $t('Test') }} api
                  </v-btn>
                </v-flex>

                <v-flex xs8 v-if="products.length">
                  <v-select
                    v-model="selectedProduct"
                    :items="products"
                    item-text="product"
                    item-value="product"
                    :hint="selectedProduct.product"
                    :label="this.$t('AIResumeApiID')"
                  ></v-select>
                </v-flex>
                <v-flex xs2 v-if="products.length"></v-flex>

                <v-flex xs2 v-if="urls.length">
                  <v-btn
                    color="primary"
                    :loading="loadingResumePrompt"
                    :disabled="loadingResumePrompt || !selectedUrl.length"
                    @click.native="testPromptResume"
                  >
                    {{ $t('Test') }} url
                  </v-btn>
                </v-flex>
                <v-flex xs8  v-if="urls.length">
                  <v-select
                    v-model="selectedUrl"
                    :items="urls"
                    item-text="url"
                    item-value="url"
                    :hint="selectedUrl.url"
                    :label="this.$t('AIResumeURL')"
                  ></v-select>

                  <br />

                  <div v-if="loadingResumePrompt || loadingResumePromptAPI" class="text-xs-center tf_loadingResume">
                    <v-progress-circular indeterminate class="primary--text" :size="100" :width="1"></v-progress-circular>
                  </div>
                  <div v-else>
                    <p>{{ $t('AIResume') }} <br><strong>{{ contentResume }}</strong></p>

                    <v-textarea
                      name="contentResumeKeys"
                      :label="this.$t('AIResumCritere')"
                      auto-grow
                      :value='contentResumeKeys'
                      readonly
                    >
                    </v-textarea>
                  </div> 
                </v-flex>
                <v-flex xs2></v-flex>

              </v-layout>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>

        <!-- produits utilisés pour le bot (API)-->
        <v-expansion-panel-content
          :class="[ getPermissionsAdmin ? 'active' : 'hidden' ]"
        >
          <template v-slot:header>
            <div>{{  $t('AIProdTitle') }} ({{ totalProduct }})</div>
          </template>
          <v-card>
            <v-card-text>
              <v-layout >
                <!-- Actions pour la selection -->
                <v-flex
                  shrink
                  style="width: 80px"
                >
                  <v-text-field
                    v-model="rangeSliderProduct[0]"
                    class="mt-0"
                    hide-details
                    single-line
                    type="number"
                  ></v-text-field>
                </v-flex>
                <v-flex class="px-3">
                  <v-range-slider
                    v-model="rangeSliderProduct"
                    :max="totalProduct"
                    :min="minSliderProduct"
                  ></v-range-slider>
                </v-flex>
                <v-flex
                  shrink
                  style="width: 80px"
                >
                  <v-text-field
                    v-model="rangeSliderProduct[1]"
                    class="mt-0"
                    hide-details
                    single-line
                    type="number"
                  ></v-text-field>
                </v-flex>

                <v-flex x12 sm2>
                  <div class="text-xs-right">
                    <v-btn
                      color="primary"
                      :loading="loadingData"
                      @click.native="loadProductsClient"
                    >
                      {{ $t('AIBtnReload') }}
                    </v-btn>
                  </div>
                </v-flex>
                </v-layout>
                <!-- Actions pour la selection -->
                <v-layout row wrap justify-space-between>
                <v-flex xs10 sm3>
                  <v-select
                    v-model="selectActionProduct"
                    :items="computedActionProduct"
                    item-text="text"
                    item-value="id"
                    :disabled="!selectedProducts.length"
                    :label="$t('actions')"
                    @change="actionsProduct()"
                  >
                  </v-select>
                </v-flex>
                <v-flex xs1>
                  <v-spacer></v-spacer>
                </v-flex>
                <!--- liste de toutes les url -->
                <v-flex xs6 sm3>
                    <v-text-field
                      v-model="search"
                      append-icon="search"
                      :label="$t('search')"
                      single-line
                      hide-details
                    ></v-text-field>
                </v-flex>
                <v-flex xs6 sm2>
                  <div class="text-xs-right">
                    <v-btn
                      color="primary"
                      :loading="loadingCheckSitemap"
                      @click.native="checkProduct"
                    >
                      {{ $t('searchUrl') }}
                    </v-btn>
                  </div>
                </v-flex>
                <v-flex xs6 sm2>
                  <div class="text-xs-right">
                    <v-btn
                      color="primary"
                      :loading="loadingStartEmbedding"
                      :disabled="!modifKeywordsProduct"
                      @click.native="startEmbeddingAPI"
                    >
                      {{ $t('startEmbedding') }}
                    </v-btn>
                  </div>
                </v-flex>
                <v-flex xs12>
                  <v-data-table
                    v-model="selectedProducts"
                    :headers="headersProduct"
                    :items="products"
                    :search="search"
                    item-key="product"
                    select-all
                    :loading="loadingData"
                    class="elevation-1"
                    :rows-per-page-items="[10, 25, 50, 100, 200, 500, 1000]"
                  >
                    <template v-slot:progress><v-progress-linear color="blue" indeterminate></v-progress-linear></template>
                    <template v-slot:items="props">
                      <td >
                        <v-checkbox
                          v-model="props.selected"
                          primary
                          hide-details
                        ></v-checkbox>
                      </td>
                      <td v-if="props.item && props.item.new" class="text-xs-left">{{ props.item.product }}</td>
                      <td v-else class="text-xs-left" @click.stop="openDialogUpdateKeywordProduct(props.item)">{{ props.item.product }}</td>

                      <td v-if="props.item && props.item.timestamp" class="text-xs-left">{{ props.item.timestamp }}</td>
                      <td v-else class="text-xs-left"> -- </td>

                      <td v-if="props.item && props.item.error" class="text-xs-left">
                        <v-tooltip left >
                          <template slot="activator">
                            <v-icon class="infos" color="red darken-2" dark >error</v-icon>
                          </template>
                          <span>{{$t('AIErrorSave')}}</span>
                        </v-tooltip>
                      </td>
                      <td v-else class="text-xs-left"></td>

                      <td v-if="props.item && props.item.new" class="text-xs-left">
                        <v-tooltip left >
                          <template slot="activator">
                            <v-icon class="infos" color="green darken-2" dark >add_circle</v-icon>
                          </template>
                          <span>{{$t('AINewAddURL')}}</span>
                        </v-tooltip>
                      </td>
                      <td v-else class="text-xs-left"></td>

                      <td v-if="props.item && props.item.updated" class="text-xs-left">
                        <v-tooltip left >
                          <template slot="activator">
                            <v-icon class="infos" color="orange darken-2" dark >update</v-icon>
                          </template>
                          <span>{{$t('AIModifKeys')}}</span>
                        </v-tooltip>
                      </td>
                      <td v-else class="text-xs-left"></td>

                      <td v-if="props.item && props.item.new" class="text-xs-center">
                        <!-- Editer -->
                        <v-tooltip left >
                          <template slot="activator">
                            <v-icon class="infos" color="grey lighten-1" dark>info_outline</v-icon>
                          </template>
                          <span>{{$t('AIKeyNotDispo')}}</span>
                        </v-tooltip>
                      </td>
                      <td v-else class="text-xs-center">
                        <!-- Editer -->
                        <v-tooltip left >
                          <template slot="activator">
                            <v-icon class="infos" color="black lighten-1" dark @click.stop="openDialogUpdateKeywordProduct(props.item)" >info_outline</v-icon>
                          </template>
                          <span>{{$t('AIKeyEdit')}}</span>
                        </v-tooltip>
                      </td>
                      <td class="text-xs-center">
                        <!-- Editer -->
                        <v-tooltip left >
                          <template slot="activator">
                            <a :href=props.item.url target="blank"><v-icon class="infos" color="black lighten-1" dark>remove_red_eye</v-icon></a>
                          </template>
                          <span>{{$t('AIseePage')}}</span>
                        </v-tooltip>
                      </td>
                      <td v-if="props.item && props.item.locked" class="text-xs-center">
                        <!-- verrouiller -->
                        <v-tooltip left >
                          <template slot="activator">
                            <v-icon small class="infos" color="black lighten-1" dark>lock</v-icon>
                          </template>
                          <span>{{$t('AIlockURL')}}</span>
                        </v-tooltip>
                      </td>

                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>

        <!-- produits utilisés pour le bot (URL)-->
        <v-expansion-panel-content
          :class="[ getPermissionsAdmin ? 'active' : 'hidden' ]"
        >
          <template v-slot:header>
            <div>{{  $t('AIProdURLTitle') }} ({{ totalURLProduct }})</div>
          </template>
          <v-card>
            <v-card-text>
              <v-layout >
                <!-- Actions pour la selection -->
                <v-flex
                  shrink
                  style="width: 80px"
                >
                  <v-text-field
                    v-model="rangeSliderURLProduct[0]"
                    class="mt-0"
                    hide-details
                    single-line
                    type="number"
                  ></v-text-field>
                </v-flex>
                <v-flex class="px-3">
                  <v-range-slider
                    v-model="rangeSliderURLProduct"
                    :max="totalURLProduct"
                    :min="minSliderURLProduct"
                  ></v-range-slider>
                </v-flex>
                <v-flex
                  shrink
                  style="width: 80px"
                >
                  <v-text-field
                    v-model="rangeSliderURLProduct[1]"
                    class="mt-0"
                    hide-details
                    single-line
                    type="number"
                  ></v-text-field>
                </v-flex>

                <v-flex x12 sm2>
                  <div class="text-xs-right">
                    <v-btn
                      color="primary"
                      :loading="loadingData"
                      @click.native="loadURLProductsClient"
                    >
                      {{ $t('AIBtnReload') }}
                    </v-btn>
                  </div>
                </v-flex>
                </v-layout>
                <!-- Actions pour la selection -->
                <v-layout row wrap justify-space-between>
                <v-flex xs10 sm3>
                  <v-select
                    v-model="selectActionURLProduct"
                    :items="computedActionUrl"
                    item-text="text"
                    item-value="id"
                    :disabled="!selectedURLProducts.length"
                    :label="$t('actions')"
                    @change="actionsURLProduct()"
                  >
                  </v-select>
                </v-flex>
                <v-flex xs1>
                  <v-spacer></v-spacer>
                </v-flex>
                <!--- liste de toutes les url -->
                <v-flex xs6 sm3>
                    <v-text-field
                      v-model="search"
                      append-icon="search"
                      :label="$t('search')"
                      single-line
                      hide-details
                    ></v-text-field>
                </v-flex>
                <v-flex xs6 sm2>
                  <div class="text-xs-right">
                    <v-btn
                      color="primary"
                      :loading="loadingCheckSitemap"
                      @click.native="checkURLProduct"
                    >
                      {{ $t('searchUrl') }}
                    </v-btn>
                  </div>
                </v-flex>
                <v-flex xs6 sm2>
                  <div class="text-xs-right">
                    <v-btn
                      color="primary"
                      :loading="loadingStartEmbedding"
                      :disabled="!modifKeywordsURLProduct"
                      @click.native="startEmbeddingURLProduct"
                    >
                      {{ $t('startEmbedding') }}
                    </v-btn>
                  </div>
                </v-flex>
                <v-flex xs12>
                  <v-data-table
                    v-model="selectedURLProducts"
                    :headers="headers"
                    :items="URLProducts"
                    :search="search"
                    item-key="url"
                    select-all
                    :loading="loadingData"
                    class="elevation-1"
                    :rows-per-page-items="[10, 25, 50, 100, 200, 500, 1000]"
                  >
                    <template v-slot:progress><v-progress-linear color="blue" indeterminate></v-progress-linear></template>
                    <template v-slot:items="props">
                      <td >
                        <v-checkbox
                          v-model="props.selected"
                          primary
                          hide-details
                        ></v-checkbox>
                      </td>
                      <td v-if="props.item && props.item.new" class="text-xs-left">{{ props.item.url }}</td>
                      <td v-else class="text-xs-left" @click.stop="openDialogUpdateKeywordURLProduct(props.item)">{{ props.item.url }}</td>

                      <td v-if="props.item && props.item.timestamp" class="text-xs-left">{{ props.item.timestamp }}</td>
                      <td v-else class="text-xs-left"> -- </td>

                      <td v-if="props.item && props.item.error" class="text-xs-left">
                        <v-tooltip left >
                          <template slot="activator">
                            <v-icon class="infos" color="red darken-2" dark >error</v-icon>
                          </template>
                          <span>{{$t('AIErrorSave')}}</span>
                        </v-tooltip>
                      </td>
                      <td v-else class="text-xs-left"></td>

                      <td v-if="props.item && props.item.new" class="text-xs-left">
                        <v-tooltip left >
                          <template slot="activator">
                            <v-icon class="infos" color="green darken-2" dark >add_circle</v-icon>
                          </template>
                          <span>{{$t('AINewAddURL')}}</span>
                        </v-tooltip>
                      </td>
                      <td v-else class="text-xs-left"></td>

                      <td v-if="props.item && props.item.updated" class="text-xs-left">
                        <v-tooltip left >
                          <template slot="activator">
                            <v-icon class="infos" color="orange darken-2" dark >update</v-icon>
                          </template>
                          <span>{{$t('AIModifKeys')}}</span>
                        </v-tooltip>
                      </td>
                      <td v-else class="text-xs-left"></td>

                      <td v-if="props.item && props.item.new" class="text-xs-center">
                        <!-- Editer -->
                        <v-tooltip left >
                          <template slot="activator">
                            <v-icon class="infos" color="grey lighten-1" dark>info_outline</v-icon>
                          </template>
                          <span>{{$t('AIKeyNotDispo')}}</span>
                        </v-tooltip>
                      </td>
                      <td v-else class="text-xs-center">
                        <!-- Editer -->
                        <v-tooltip left >
                          <template slot="activator">
                            <v-icon class="infos" color="black lighten-1" dark @click.stop="openDialogUpdateKeywordURLProduct(props.item)" >info_outline</v-icon>
                          </template>
                          <span>{{$t('AIKeyEdit')}}</span>
                        </v-tooltip>
                      </td>
                      <td class="text-xs-center">
                        <!-- Editer -->
                        <v-tooltip left >
                          <template slot="activator">
                            <a :href=props.item.url target="blank"><v-icon class="infos" color="black lighten-1" dark>remove_red_eye</v-icon></a>
                          </template>
                          <span>{{$t('AIseePage')}}</span>
                        </v-tooltip>
                      </td>
                      <td v-if="props.item && props.item.locked" class="text-xs-center">
                        <!-- verrouiller -->
                        <v-tooltip left >
                          <template slot="activator">
                            <v-icon small class="infos" color="black lighten-1" dark>lock</v-icon>
                          </template>
                          <span>{{$t('AIlockURL')}}</span>
                        </v-tooltip>
                      </td>

                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>

        <!-- Urls utilisées pour le bot -->
        <v-expansion-panel-content
          :class="[ getPermissions ? 'active' : 'hidden' ]"
        >
          <template v-slot:header>
            <div>{{ $t('AIURLTitle')}} ({{ totalUrl }})</div>
          </template>
          <v-card>
            <v-card-text>
              <v-layout >
                <!-- Actions pour la selection -->
                <v-flex
                  shrink
                  style="width: 80px"
                >
                  <v-text-field
                    v-model="rangeSliderUrl[0]"
                    class="mt-0"
                    hide-details
                    single-line
                    type="number"
                  ></v-text-field>
                </v-flex>
                <v-flex class="px-3">
                  <v-range-slider
                    v-model="rangeSliderUrl"
                    :max="totalUrl"
                    :min="minSliderUrl"
                  ></v-range-slider>
                </v-flex>
                <v-flex
                  shrink
                  style="width: 80px"
                >
                  <v-text-field
                    v-model="rangeSliderUrl[1]"
                    class="mt-0"
                    hide-details
                    single-line
                    type="number"
                  ></v-text-field>
                </v-flex>

                <v-flex x12 sm2>
                  <div class="text-xs-right">
                    <v-btn
                      color="primary"
                      :loading="loadingData"
                      @click.native="loadUrlsClient('actif')"
                    >
                      {{ $t('AIBtnReload') }}
                    </v-btn>
                  </div>
                </v-flex>
                </v-layout>
                <!-- Actions pour la selection -->
                <v-layout row wrap justify-space-between>
                <v-flex xs10 sm3>
                  <v-select
                    v-model="selectActionUrl"
                    :items="computedActionUrl"
                    item-text="text"
                    item-value="id"
                    :disabled="!selectedUrls.length"
                    :label="$t('actions')"
                    @change="actionsUrl()"
                  >
                  </v-select>
                </v-flex>
                <v-flex xs1>
                  <v-spacer></v-spacer>
                </v-flex>
                <!--- liste de toutes les url -->
                <v-flex xs6 sm3>
                  <v-text-field
                    v-model="search"
                    append-icon="search"
                    :label="$t('search')"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 sm2>
                  <div class="text-xs-right">
                    <v-btn
                      color="primary"
                      :loading="loadingCheckSitemap"
                      @click.native="checkUrls"
                    >
                      {{ $t('searchUrl') }}
                    </v-btn>
                  </div>
                </v-flex>
                <v-flex xs6 sm2>
                  <div class="text-xs-right">
                    <v-btn
                      color="primary"
                      :loading="loadingStartEmbedding"
                      :disabled="!modifKeywords"
                      @click.native="startEmbedding"
                    >
                      {{ $t('startEmbedding') }}
                    </v-btn>
                  </div>
                </v-flex>
                <v-flex xs12>
                  <v-data-table
                    v-model="selectedUrls"
                    :headers="headers"
                    :items="urls"
                    :search="search"
                    item-key="url"
                    select-all
                    :loading="loadingData"
                    class="elevation-1"
                    :rows-per-page-items="[10, 25, 50, 100, 200, 500, 1000]"
                  >
                    <template v-slot:progress><v-progress-linear color="blue" indeterminate></v-progress-linear></template>
                    <template v-slot:items="props">
                      <td >
                        <v-checkbox
                          v-model="props.selected"
                          primary
                          hide-details
                        ></v-checkbox>
                      </td>
                      <td v-if="props.item && props.item.new" class="text-xs-left">{{ props.item.url }}</td>
                      <td v-else class="text-xs-left" @click.stop="openDialogUpdateKeyword(props.item)">{{ props.item.url }}</td>

                      <td v-if="props.item && props.item.timestamp" class="text-xs-left">{{ props.item.timestamp }}</td>
                      <td v-else class="text-xs-left"> -- </td>

                      <td v-if="props.item && props.item.error" class="text-xs-left">
                        <v-tooltip left >
                          <template slot="activator">
                            <v-icon class="infos" color="red darken-2" dark >error</v-icon>
                          </template>
                          <span>{{$t('AIErrorSave')}}</span>
                        </v-tooltip>
                      </td>
                      <td v-else class="text-xs-left"></td>

                      <td v-if="props.item && props.item.new" class="text-xs-left">
                        <v-tooltip left >
                          <template slot="activator">
                            <v-icon class="infos" color="green darken-2" dark >add_circle</v-icon>
                          </template>
                          <span>{{$t('AINewAddURL')}}</span>
                        </v-tooltip>
                      </td>
                      <td v-else class="text-xs-left"></td>

                      <td v-if="props.item && props.item.updated" class="text-xs-left">
                        <v-tooltip left >
                          <template slot="activator">
                            <v-icon class="infos" color="orange darken-2" dark >update</v-icon>
                          </template>
                          <span>{{$t('AIModifKeys')}}</span>
                        </v-tooltip>
                      </td>
                      <td v-else class="text-xs-left"></td>

                      <td v-if="props.item && props.item.new" class="text-xs-center">
                        <!-- Editer -->
                        <v-tooltip left >
                          <template slot="activator">
                            <v-icon class="infos" color="grey lighten-1" dark>info_outline</v-icon>
                          </template>
                          <span>{{$t('AIKeyNotDispo')}}</span>
                        </v-tooltip>
                      </td>
                      <td v-else class="text-xs-center">
                        <!-- Editer -->
                        <v-tooltip left >
                          <template slot="activator">
                            <v-icon class="infos" color="black lighten-1" dark @click.stop="openDialogUpdateKeyword(props.item)" >info_outline</v-icon>
                          </template>
                          <span>{{$t('AIKeyEdit')}}</span>
                        </v-tooltip>
                      </td>
                      <td class="text-xs-center">
                        <!-- Editer -->
                        <v-tooltip left >
                          <template slot="activator">
                            <a :href=props.item.url target="blank"><v-icon class="infos" color="black lighten-1" dark>remove_red_eye</v-icon></a>
                          </template>
                          <span>{{$t('AIseePage')}}</span>
                        </v-tooltip>
                      </td>
                      <td v-if="props.item && props.item.locked" class="text-xs-center">
                        <!-- verrouiller -->
                        <v-tooltip left >
                          <template slot="activator">
                            <v-icon small class="infos" color="black lighten-1" dark>lock</v-icon>
                          </template>
                          <span>{{$t('AIlockURL')}}</span>
                        </v-tooltip>
                      </td>

                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>

        <!-- Urls non utilisées -->
        <v-expansion-panel-content
          :class="[ getPermissions ? 'active' : 'hidden' ]"
        >
          <template v-slot:header>
            <div>{{ $t('AINoURLTitle')}} ({{ totalUrlInactif }})</div>
          </template>
          <v-card>
            <v-card-text>
              <v-layout row wrap justify-space-between>
                <!-- Actions pour la selection -->
                <v-flex xs10 sm3>
                  <v-select
                    v-model="selectActionSuppUrl"
                    :items="computedActionSuppUrl"
                    item-text="text"
                    item-value="id"
                    :disabled="!selectedSuppUrls.length"
                    :label="$t('actions')"
                    @change="actionsSuppUrl()"
                  >
                  </v-select>
                </v-flex>
                <v-flex xs2>
                  <v-spacer></v-spacer>
                </v-flex>
                <!--- liste de toutes les url -->
                <v-flex xs6 sm4>
                    <v-text-field
                      v-model="search"
                      append-icon="search"
                      :label="$t('search')"
                      single-line
                      hide-details
                    ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-data-table
                    v-model="selectedSuppUrls"
                    :headers="headersSupp"
                    :items="listeAllDelUrl"
                    :search="search"
                    item-key="url"
                    select-all
                    :loading="loadingDataInactif"
                    class="elevation-1"
                    :rows-per-page-items="[10, 25, 50, 100, 200]"
                  >
                    <template v-slot:progress><v-progress-linear color="blue" indeterminate></v-progress-linear></template>
                    <template v-slot:items="props">
                      <td >
                        <v-checkbox
                          v-model="props.selected"
                          primary
                          hide-details
                        ></v-checkbox>
                      </td>
                      <td class="text-xs-left">{{ props.item.url }}</td>
                      <td class="text-xs-center">
                        <!-- Editer -->
                        <v-tooltip left >
                          <template slot="activator">
                            <a :href=props.item.url target="blank"><v-icon class="infos" color="black lighten-1" dark>remove_red_eye</v-icon></a>
                          </template>
                          <span>{{$t('AIseePage')}}</span>
                        </v-tooltip>
                      </td>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>

        <!-- Documents utilisés pour le bot -->
        <v-expansion-panel-content >
          <template v-slot:header>
            <div>{{  $t('AIDocTitle') }}</div>
          </template>
          <v-card>
            <v-card-text>
              <v-layout row wrap justify-space-between>
                <!-- Actions pour la selection -->
                <v-flex xs10 sm3>
                  <v-select
                    v-model="selectActionFile"
                    :items="computedActionFile"
                    item-text="text"
                    item-value="id"
                    :disabled="!selectedFiles.length"
                    :label="$t('actions')"
                    @change="actionsFile()"
                  >
                  </v-select>
                </v-flex>
                <v-flex xs2 sm1>
                  <v-spacer></v-spacer>
                </v-flex>
                <!--- liste de toutes les url -->
                <v-flex xs6 sm5>
                  <v-text-field
                    v-model="search"
                    append-icon="search"
                    :label="$t('search')"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-flex>

                <v-flex xs6 sm2>
                  <div class="text-xs-right">
                    <v-btn
                      color="primary"
                      @click.native="importFile"
                    >
                      {{ $t('importDoc') }}
                    </v-btn>
                  </div>
                </v-flex>
                <v-flex xs1 sm1>
                  <v-spacer></v-spacer>
                </v-flex>

                <v-flex xs12>
                  <v-data-table
                    v-model="selectedFiles"
                    :headers="headersFile"
                    :items="files"
                    :search="search"
                    item-key="file"
                    select-all
                    :loading="loadingDataFiles"
                    class="elevation-1"
                    :rows-per-page-items="[10, 25, 50, 100, 200]"
                  >
                    <template v-slot:progress><v-progress-linear height="2" color="blue" indeterminate></v-progress-linear></template>
                    <template v-slot:items="props">
                      <td >
                        <v-checkbox
                          v-model="props.selected"
                          primary
                          hide-details
                        ></v-checkbox>
                      </td>
                      <td v-if="props.item.numChunk" class="text-xs-left" @click.stop="openDialogChunkFile(props.item)">{{ props.item.file }}</td>
                      <td v-else class="text-xs-left" @click.stop="openDialogFile(props.item)">{{ props.item.file }}</td>

                      <td v-if="props.item.numChunk" class="text-xs-left" @click.stop="openDialogChunkFile(props.item)">{{ props.item.numChunk }}</td>
                      <td v-else class="text-xs-left" @click.stop="openDialogFile(props.item)">résumé</td>
                      <td class="text-xs-center px-2">
                        <!-- Editer -->
                        <v-tooltip left >
                          <template slot="activator">
                            <v-icon class="infos" color="black lighten-1" dark @click.stop="openDialogChunkFile(props.item)" >info_outline</v-icon>
                          </template>
                          <span>{{$t('affSegDoc')}}</span>
                        </v-tooltip>
                      </td>
                    </template>
                  </v-data-table>
                </v-flex>

              </v-layout>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>

        <!-- FAQ -->
        <v-expansion-panel-content >
          <template v-slot:header>
            <div>FAQ ({{ faqs.length }})</div>
          </template>
          <v-card>
            <v-card-text>
              <v-layout row wrap justify-space-between>
                <!-- Actions pour la selection -->
                <v-flex xs10 sm3>
                  <v-select
                    v-model="selectActionFAQ"
                    :items="computedActionFAQ"
                    item-text="text"
                    item-value="id"
                    :disabled="!selectedFaqs.length"
                    :label="$t('actions')"
                    @change="actionsFAQ()"
                  >
                  </v-select>
                </v-flex>
                <v-flex xs1 sm1>
                  <v-spacer></v-spacer>
                </v-flex>
                <!--- liste de toutes les FAQ -->
                <v-flex xs6 sm5>
                    <v-text-field
                      v-model="search"
                      append-icon="search"
                      :label="$t('search')"
                      single-line
                      hide-details
                    ></v-text-field>
                </v-flex>
                <v-flex xs6 sm2>
                  <div class="text-xs-right">
                    <v-btn
                      color="primary"
                      @click.native="newFAQ"
                    >
                      {{ $t('addFaq')}}
                    </v-btn>
                  </div>
                </v-flex>
                <v-flex xs1 sm1>
                  <v-spacer></v-spacer>
                </v-flex>

                <v-flex xs12>
                  <v-data-table
                    v-model="selectedFaqs"
                    :headers="headersFAQ"
                    :items="faqs"
                    :search="search"
                    item-key="index"
                    select-all
                    :loading="loadingData"
                    class="elevation-1"
                    :rows-per-page-items="[10, 25, 50, 100, 200]"
                  >
                    <template v-slot:progress><v-progress-linear color="blue" indeterminate></v-progress-linear></template>
                    <template v-slot:items="props">
                      <tr>
                        <td class="text-xs-center">
                          <v-checkbox
                            v-model="props.selected"
                            primary
                            hide-details
                          ></v-checkbox>
                        </td>
                        <td class="text-xs-right" @click.stop="openDialogUpdateFAQ(props.item)">{{ props.item.index }}</td>
                        <td class="text-xs-left" @click.stop="openDialogUpdateFAQ(props.item)">{{ props.item.question }}</td>
                        <td class="text-xs-left"  @click.stop="openDialogUpdateFAQ(props.item)">{{ props.item.reponse }}</td>
                        <td class="text-xs-right">
                          <!-- Editer -->
                          <v-tooltip left >
                            <template slot="activator">
                              <v-icon class="infos" color="black lighten-1" dark @click.stop="openDialogUpdateFAQ(props.item)" >edit</v-icon>
                            </template>
                            <span>{{$t('editFAQ')}}</span>
                          </v-tooltip>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>

        <!-- Analyse de la conversation -->
        <v-expansion-panel-content
          :class="[ getPermissionsAdmin ? 'active' : 'hidden' ]"
        >
          <template v-slot:header>
            <div>{{ $t('AIAnalysTitle')}}</div>
          </template>
          <v-card>
            <v-card-title primary-title>
              <div>
                <div class="body-2 pl-3" v-html ="this.$t('AIAnalysExemple')">
                </div>
              </div>
            </v-card-title>
            <v-card-text>
              <v-layout row wrap justify-space-between>
                <!-- Actions pour la selection -->
                <v-flex xs10 sm3>
                  <v-select
                    v-model="selectActionAnalyseChat"
                    :items="computedActionAnalyseChat"
                    item-text="text"
                    item-value="id"
                    :disabled="!selectedAnalyseChat.length"
                    :label="$t('actions')"
                    @change="actionsAnalyseChat()"
                  >
                  </v-select>
                </v-flex>
                <v-flex xs2>
                  <v-spacer></v-spacer>
                </v-flex>
                <v-flex xs6 sm3>
                </v-flex>
                <v-flex xs6 sm2>
                  <v-btn
                    outline
                    color="primary"
                    @click.native="addAnalyseChat"
                  >
                    {{ $t('AIAnalysAdd') }}
                  </v-btn>
                </v-flex>
                <v-flex xs12>
                  <v-data-table
                    v-model="selectedAnalyseChat"
                    :headers="headersAnalyseChat"
                    :items="analyseChat"
                    item-key="q"
                    select-all
                    class="elevation-1"
                  >
                    <template v-slot:progress><v-progress-linear height="2" color="blue" indeterminate></v-progress-linear></template>
                    <template v-slot:items="props">
                      <td >
                        <v-checkbox
                          v-model="props.selected"
                          primary
                          hide-details
                        ></v-checkbox>
                      </td>
                      <td class="text-xs-left" @click.stop="openDialogModifAnalyseChat(props.item)">{{ props.item.q }}</td>
                      <td class="text-xs-left" @click.stop="openDialogModifAnalyseChat(props.item)">{{ props.item.a }}</td>
                      <td class="text-xs-center px-2">
                        <!-- Editer -->
                        <v-tooltip left >
                          <template slot="activator">
                            <v-icon class="infos" color="black lighten-1" dark @click.stop="openDialogModifAnalyseChat(props.item)" >info_outline</v-icon>
                          </template>
                          <span>{{$t('affSegDoc')}}</span>
                        </v-tooltip>
                      </td>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>

        <!-- Statistiques -->
        <v-expansion-panel-content
          :class="[ getPermissionsAdmin ? 'active' : 'hidden' ]"
        >
          <template v-slot:header>
            <div>{{ $t('AIStatTitle')}}</div>
          </template>
          <v-card>
            <v-card-title primary-title>
              <div>
                <div class="body-2 pl-3">
                  {{ $t('AIStatContent')}}
                </div>
              </div>
            </v-card-title>
            <v-card-text>
              <v-layout row wrap justify-space-between>
                <v-flex xs12 >
                  <v-layout row wrap>
                    <v-flex xs12 md4>

                      <v-select 
                        dense
                        :items="periods" 
                        v-model="period"
                        :label="$t('period') | cap"
                        prepend-icon="date_range"
                      ></v-select>
                    </v-flex>
                    <v-flex md2>
                    </v-flex>
                    <v-flex xs12 md3>
                      <v-dialog
                        v-model="modalStart"
                        lazy
                        full-width
                        width="290px"
                        :disabled="period != 0"
                      >
                        <v-text-field
                          slot="activator"
                          :label="$t('startDate') | cap"
                          v-model="dateStartDisplayed"
                          @blur="dateStartPicker = parseDate(dateStartDisplayed)"
                          prepend-icon="event"
                          readonly
                          :disabled="period != 0"
                        ></v-text-field>
                        <v-date-picker
                          v-model="dateStartPicker"
                          @input="dateStartDisplayed = formatDate($event); modalStart = false"
                          :first-day-of-week="1"
                          :min="allowedDatesStart.min"
                          :max="allowedDatesStart.max"
                          :locale="$i18n.locale"
                          scrollable
                          color="primary"
                        >
                        </v-date-picker>
                      </v-dialog>
                    </v-flex>
                    <v-flex xs12 md3>
                      <v-dialog
                        v-model="modalEnd"
                        lazy
                        full-width
                        width="290px"
                        :disabled="period != 0"
                      >
                        <v-text-field
                          slot="activator"
                          :label="$t('endDate') | cap"
                          v-model="dateEndDisplayed"
                          @blur="dateEndPicker = parseDate(dateEndDisplayed)"
                          prepend-icon="event"
                          readonly
                          :disabled="period != 0"
                        ></v-text-field>
                        <v-date-picker
                          v-model="dateEndPicker"
                          @input="dateEndDisplayed = formatDate($event); modalEnd = false"
                          :first-day-of-week="1"
                          :min="allowedDatesEnd.min"
                          :max="allowedDatesEnd.max"
                          :locale="$i18n.locale"
                          scrollable
                          color="primary"
                        >
                        </v-date-picker>
                      </v-dialog>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs6 sm3 md2>
                  <div class="grey--text text--darken-2">{{ $t('AIStatsTP') | cap }}</div>
                  <div class="headline teal--text">{{ nbPrompt }}</div>
                </v-flex>
                <v-flex xs6 sm3 md2>
                  <div class="grey--text text--darken-2">{{ $t('AIStatTC') | cap }}</div>
                  <div class="headline blue--text">{{ nbCompletion }}</div>
                </v-flex>
                <v-flex xs6 sm3 md2>
                  <div class="grey--text text--darken-2">{{ $t('AIStatTT') | cap }}</div>
                  <div class="headline pink--text">{{ nbTotal }}</div>
                </v-flex>
                <v-flex xs6 sm6 md2>
                  <v-select 
                    :label="$t('dataInterval') | cap"
                    :items="intervals" 
                    v-model="interval" 
                    return-object
                  ></v-select>
                </v-flex>
                <v-flex xs6 sm6 md2>
                  <v-select 
                    :label="$t('AIStatT') | cap"
                    :items="utilisations" 
                    v-model="utilisation" 
                    return-object
                  ></v-select>
                </v-flex>
                <!-- <v-flex xs6 sm3 md2>
                  <div class="grey--text text--darken-2">{{ $t('conversationRate') | cap }}</div>
                  <div class="headline primary--text">{{ conversation }} %</div>
                </v-flex> -->
              </v-layout>
              <highcharts :options="options"></highcharts>
              <v-expansion-panel>
                <v-expansion-panel-content>
                  <template v-slot:header>
                    <div><v-icon>info</v-icon> {{ $t('AIStatDetail')}}</div>
                  </template>
                  <v-card>
                    <v-card-title>
                    </v-card-title>
                    <v-card-text>
                      <v-layout row wrap>
                        <!--- liste de toutes les stats de la période -->
                        <v-flex xs6 sm3>
                            <v-text-field
                              v-model="searchTokens"
                              append-icon="search"
                              :label="this.$t('search')"
                              single-line
                              hide-details
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-data-table
                            :headers="headersTokens"
                            :items="tokens"
                            :search="searchTokens"
                            item-key="timestamp"
                            :loading="loadingStatsToken"
                            class="elevation-1"
                            :rows-per-page-items="[10, 25, 50, 100, 200]"
                          >
                            <template v-slot:progress><v-progress-linear color="blue" indeterminate></v-progress-linear></template>
                            <template v-slot:items="props">
                              <td class="text-xs-left">{{ afficheDate(props.item.timestamp) }}</td>
                              <td class="text-xs-left">{{ props.item.session_chat }}</td>
                              <td class="text-xs-left">{{ props.item.description }}</td>
                              <td class="text-xs-left">{{ props.item.model }}</td>
                              <td class="text-xs-left">{{ props.item.tokens_prompt }}</td>
                              <td class="text-xs-left">{{ props.item.tokens_completion }}</td>
                            </template>
                          </v-data-table>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>

        <!-- Traitement automatique des données. -->
        <v-expansion-panel-content
          :class="[ getPermissionsAdmin ? 'active' : 'hidden' ]"
        >
          <template v-slot:header>
            <div>{{ $t('AIDataAutoTitle') }}</div>
          </template>
          <v-card>
            <div v-if="loadingPrompt" class="text-xs-center tf_loading">
              <v-progress-circular indeterminate class="primary--text" :size="100" :width="1"></v-progress-circular>
            </div>
            <v-card-text v-else>
              <v-container>
                <v-layout row wrap>
                  <v-flex xs12>
                    <strong>{{ $t('AIDataSitemap')}}</strong>
                  </v-flex>
                  <v-flex xs12 lg6>
                    <!--- instruction du prompt de chat -->
                    <v-layout row wrap>
                      <v-flex xs12>
                        <div v-html="this.$t('AIDataExempl')"></div>
                      </v-flex>

                      <v-flex xs12>
                        <v-text-field
                          :label="this.$t('AIDataScann')"
                          v-model="pageScanne"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-flex xs12>
                          {{$t('AIDataPeriod')}}
                        </v-flex>
                        <v-slider
                          v-model="timeSelected"
                          :tick-labels="timeLabels"
                          :max="3"
                          step="1"
                          ticks="always"
                          tick-size="2"
                        ></v-slider>
                      </v-flex>

                      <!--- mise à jour auto par tache cron -->
                      <v-flex xs12 md6>
                        <v-switch
                          v-model="majCronTab"
                          :label="this.$t('AIDataMAJ')"
                        ></v-switch>
                      </v-flex>

                      <v-flex xs12 md6>
                        <v-switch
                          :disabled=!majCronTab
                          v-model="majUrlAuto"
                          :label="this.$t('AIDataSave')"
                        ></v-switch>
                      </v-flex>

                      <v-flex xs8 v-if="afficheStatusCron">
                        <v-alert
                          v-if="statusSaveCron"
                          :value="true"
                          color="success"
                          icon="check_circle"
                          outline
                        >
                        {{ infoCron }}
                        </v-alert>
                        <v-alert
                          v-else
                          :value="true"
                          color="error"
                          icon="warning"
                          outline
                        >
                        {{ infoCron }}
                        </v-alert>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>

      </v-expansion-panel>
      <div class="text-xs-right">
        <v-btn
          color="primary"
          :loading="loadingSavePrompt"
          :disabled="loadingSavePrompt || !modifPrompt"
          @click.native="savePrompt"
        >
          {{ $t('save') }}
        </v-btn>
      </div>
    </div>

    <!-- Document Delete confirmation analyse chat -->
    <v-dialog
      v-model="showDialogDeleteParsing"
      persistent
      scrollable
      max-width="490"
    >
      <wz-dialog-confirm
        :titleDialogConfirm="$t('suppPars')"
        :contentDialogConfirm="SelectedParsingSupp.name"
        :showDialogConfirmation="false"
        @closeDialogConfirm="justCloseDialogConfirmParsing"
        @justCloseDialogConfirm="justCloseDialogConfirmParsing"
        @submitDialogConfirm="submitDeleteParsing"
      ></wz-dialog-confirm>
    </v-dialog> 
    <!-- Document Delete confirmation parsing -->
    <v-dialog
      v-model="showDialogDeleteAnalyseChat"
      persistent
      scrollable
      max-width="490"
    >
      <wz-dialog-confirm
        :titleDialogConfirm="selectedAnalyseChat.length > 1 ? $t('suppAnalysChat-s') : $t('suppAnalysChat')"
        :contentDialogConfirm="listeSelectedAnalyseChat"
        :showDialogConfirmation="false"
        :loadingModifDialog="loadingModifAnalyseChat"
        @closeDialogConfirm="justCloseDialogConfirmAnalyseChat"
        @justCloseDialogConfirm="justCloseDialogConfirmAnalyseChat"
        @submitDialogConfirm="submitDeleteAnalyseChatConfirm"
      ></wz-dialog-confirm>
    </v-dialog> 
    <!-- Document Delete confirmation -->
    <v-dialog
      v-model="showDialogDeleteFile"
      persistent
      scrollable
      max-width="490"
    >
      <wz-dialog-confirm
        :titleDialogConfirm="selectedFiles.length > 1 ? $t('suppFile-s') : $t('suppFile')"
        :contentDialogConfirm="listeSelectedFile"
        :showDialogConfirmation="false"
        :loadingModifDialog="loadingModifFile"
        @closeDialogConfirm="justCloseDialogConfirmFile"
        @justCloseDialogConfirm="justCloseDialogConfirmFile"
        @submitDialogConfirm="submitDeleteFileConfirm"
      ></wz-dialog-confirm>
    </v-dialog> 

    <!-- URL actives locked confirmation -->
    <v-dialog
      v-model="showDialogLock"
      persistent
      scrollable
      max-width="490"
    >
      <wz-dialog-confirm
        :titleDialogConfirm="selectedUrls.length > 1 ? $t('lockURL-s') : $t('lockURL')"
        :contentDialogConfirm="listeSelectedUrl"
        :contentDialogRes="messageResDialog"
        :showDialogConfirmation="false"
        :loadingModifDialog="loadingModifUrl"
        :loadingRes="loadingRes"
        :startLoading="startLoading"
        :endLoading="endLoading"
        :closeDialogUniquement="closeDialogUniquement"
        @closeDialogConfirm="justCloseDialogLock"
        @justCloseDialogConfirm="justCloseDialogLock"
        @submitDialogConfirm="submitLockConfirm"
      ></wz-dialog-confirm>
    </v-dialog>

    <!-- URL produits actives locked confirmation -->
    <v-dialog
      v-model="showDialogLockURLProduct"
      persistent
      scrollable
      max-width="490"
    >
      <wz-dialog-confirm
        :titleDialogConfirm="selectedURLProducts.length > 1 ? $t('lockURL-s') : $t('lockURL')"
        :contentDialogConfirm="listeSelectedURLProduct"
        :contentDialogRes="messageResDialog"
        :showDialogConfirmation="false"
        :loadingModifDialog="loadingModifUrl"
        :loadingRes="loadingRes"
        :startLoading="startLoading"
        :endLoading="endLoading"
        :closeDialogUniquement="closeDialogUniquement"
        @closeDialogConfirm="justCloseDialogLock"
        @justCloseDialogConfirm="justCloseDialogLock"
        @submitDialogConfirm="submitLockConfirmURLProduct"
      ></wz-dialog-confirm>
    </v-dialog>

    <!-- produit actives locked confirmation -->
    <v-dialog
      v-model="showDialogLockProduct"
      persistent
      scrollable
      max-width="490"
    >
      <wz-dialog-confirm
        :titleDialogConfirm="selectedProducts.length > 1 ? $t('lockProd-s') : $t('lockProd')"
        :contentDialogConfirm="listeSelectedProduct"
        :contentDialogRes="messageResDialog"
        :showDialogConfirmation="false"
        :loadingModifDialog="loadingModifUrl"
        :loadingRes="loadingRes"
        :startLoading="startLoading"
        :endLoading="endLoading"
        :closeDialogUniquement="closeDialogUniquement"
        @closeDialogConfirm="justCloseDialogLock"
        @justCloseDialogConfirm="justCloseDialogLock"
        @submitDialogConfirm="submitLockConfirmProduct"
      ></wz-dialog-confirm>
    </v-dialog> 

    <!-- FAQs Delete confirmation -->
    <v-dialog
      v-model="showDialogDeletesFAQ"
      persistent
      scrollable
      max-width="490"
    >
      <wz-dialog-confirm
        :titleDialogConfirm="selectedFaqs.length > 1 ? $t('suppFAQ-s') : $t('suppFAQ')"
        :contentDialogConfirm="listeSelectedFAQ"
        :contentDialogRes="messageResDialog"
        :showDialogConfirmation="false"
        :loadingModifDialog="loadingModifUrl"
        :closeDialogUniquement="closeDialogUniquement"
        @closeDialogConfirm="justCloseDialogConfirmFAQ"
        @justCloseDialogConfirm="justCloseDialogConfirmFAQ"
        @submitDialogConfirm="submitDeleteConfirmFAQ"
      ></wz-dialog-confirm>
    </v-dialog> 

    <!-- URL actives Delete confirmation -->
    <v-dialog
      v-model="showDialogDelete"
      persistent
      scrollable
      max-width="490"
    >
      <wz-dialog-confirm
        :titleDialogConfirm="selectedUrls.length > 1 ? $t('suppURL-s') : $t('suppURL')"
        :contentDialogConfirm="listeSelectedUrl"
        :contentDialogRes="messageResDialog"
        :showDialogConfirmation="false"
        :loadingModifDialog="loadingModifUrl"
        :closeDialogUniquement="closeDialogUniquement"
        @closeDialogConfirm="justCloseDialogConfirm"
        @justCloseDialogConfirm="justCloseDialogConfirm"
        @submitDialogConfirm="submitDeleteConfirm"
      ></wz-dialog-confirm>
    </v-dialog> 

    <!-- Produit actives Delete confirmation -->
    <v-dialog
      v-model="showDialogDeleteProduct"
      persistent
      scrollable
      max-width="490"
    >
      <wz-dialog-confirm
        :titleDialogConfirm="selectedProducts.length > 1 ? $t('suppProd-s') : $t('suppProd')"
        :contentDialogConfirm="listeSelectedProduct"
        :contentDialogRes="messageResDialog"
        :showDialogConfirmation="false"
        :loadingModifDialog="loadingModifUrl"
        :closeDialogUniquement="closeDialogUniquement"
        @closeDialogConfirm="justCloseDialogConfirm"
        @justCloseDialogConfirm="justCloseDialogConfirm"
        @submitDialogConfirm="submitDeleteConfirmProduct"
      ></wz-dialog-confirm>
    </v-dialog> 

    <!-- Produit actives Delete confirmation -->
    <v-dialog
      v-model="showDialogDeleteURLProduct"
      persistent
      scrollable
      max-width="490"
    >
      <wz-dialog-confirm
        :titleDialogConfirm="selectedURLProducts.length > 1 ? $t('suppProd-s') : $t('suppProd')"
        :contentDialogConfirm="listeSelectedURLProduct"
        :contentDialogRes="messageResDialog"
        :showDialogConfirmation="false"
        :loadingModifDialog="loadingModifUrl"
        :closeDialogUniquement="closeDialogUniquement"
        @closeDialogConfirm="justCloseDialogConfirm"
        @justCloseDialogConfirm="justCloseDialogConfirm"
        @submitDialogConfirm="submitDeleteConfirmURLProduct"
      ></wz-dialog-confirm>
    </v-dialog> 

    <!-- URL inactives Delete confirmation -->
    <v-dialog
      v-model="showDialogDeleteSupp"
      persistent
      scrollable
      max-width="490"
    >
      <wz-dialog-confirm
        :titleDialogConfirm="selectedSuppUrls.length > 1 ? $t('suppURL-s') : $t('suppURL')"
        :contentDialogConfirm="listeSelectedSuppUrl"
        :contentDialogRes="messageResDialog"
        :showDialogConfirmation="false"
        :loadingModifDialog="loadingModifUrl"
        :closeDialogUniquement="closeDialogUniquement"
        @closeDialogConfirm="justCloseDialogConfirmSupp"
        @justCloseDialogConfirm="justCloseDialogConfirmSupp"
        @submitDialogConfirm="submitDeleteConfirmSupp"
      ></wz-dialog-confirm>
    </v-dialog> 

    <!-- Embedding confirmation -->
    <v-dialog
      v-model="showDialogEmbedding"
      persistent
      scrollable
      max-width="490"
    >
      <wz-dialog-confirm
        :titleDialogConfirm="$t('startEmbedding')"
        :contentDialogConfirm="$t('startEmbeddingText') + '<strong>' + siteSelected.LIC_KEY + '</strong>'" 
        :showDialogConfirmation="false"
        :contentDialogRes="messageResDialog"
        :startLoading="startLoading"
        :endLoading="endLoading"
        :loadingModifDialog="loadingEmbeddingUrl"
        :loadingRes="loadingRes"
        :closeDialogUniquement="closeDialogUniquement"
        @closeDialogConfirm="justCloseDialogEmdedding"
        @justCloseDialogConfirm="justCloseDialogEmdedding"
        @submitDialogConfirm="submitEmbeddingConfirm"
      ></wz-dialog-confirm>
    </v-dialog>

    <!-- Embedding confirmation urls product -->
    <v-dialog
      v-model="showDialogEmbeddingURLProduct"
      persistent
      scrollable
      max-width="490"
    >
      <wz-dialog-confirm
        :titleDialogConfirm="$t('startEmbedding')"
        :contentDialogConfirm="$t('startEmbeddingText') + '<strong>' + siteSelected.LIC_KEY + '</strong>'" 
        :showDialogConfirmation="false"
        :contentDialogRes="messageResDialog"
        :startLoading="startLoading"
        :endLoading="endLoading"
        :loadingModifDialog="loadingEmbeddingUrl"
        :loadingRes="loadingRes"
        :closeDialogUniquement="closeDialogUniquement"
        @closeDialogConfirm="justCloseDialogEmdeddingURLProduct"
        @justCloseDialogConfirm="justCloseDialogEmdeddingURLProduct"
        @submitDialogConfirm="submitEmbeddingURLProductConfirm"
      ></wz-dialog-confirm>
    </v-dialog>


    <!-- Embedding confirmation API -->
    <v-dialog
      v-model="showDialogEmbeddingAPI"
      persistent
      scrollable
      max-width="490"
    >
      <wz-dialog-confirm
        :titleDialogConfirm="$t('startEmbeddingAPI')"
        :contentDialogConfirm="$t('startEmbeddingAPIText') + '<strong>' + siteSelected.LIC_KEY + '</strong>'" 
        :showDialogConfirmation="false"
        :contentDialogRes="messageResDialog"
        :startLoading="startLoading"
        :endLoading="endLoading"
        :loadingModifDialog="loadingEmbeddingUrl"
        :loadingRes="loadingRes"
        :closeDialogUniquement="closeDialogUniquement"
        @closeDialogConfirm="justCloseDialogEmdeddingAPI"
        @justCloseDialogConfirm="justCloseDialogEmdeddingAPI"
        @submitDialogConfirm="submitEmbeddingAPIConfirm"
      ></wz-dialog-confirm>
    </v-dialog>

    <!-- dialog modif keyword -->
    <v-dialog
      v-model="showDialogModifKeyword"
      persistent
      scrollable
      max-width="490"
    >
      <wz-dialog-openai-keyword
        :type="'url'"
        :titleDialog="$t('modifKeywords')"
        :afficheDialog="showDialogModifKeyword"
        :dataDialog="keywordUrl"
        @closeDialog="justCloseDialogKeyword"
        @justCloseDialog="justCloseDialogKeyword"
        @majData="majData"
      ></wz-dialog-openai-keyword>
    </v-dialog>

    <!-- dialog modif keyword urls product-->
    <v-dialog
      v-model="showDialogModifKeywordURLProduct"
      persistent
      scrollable
      max-width="490"
    >
      <wz-dialog-openai-keyword
        :type="'urlProduct'"
        :titleDialog="$t('modifKeywords')"
        :afficheDialog="showDialogModifKeywordURLProduct"
        :dataDialog="keywordUrl"
        @closeDialog="justCloseDialogKeywordURLProduct"
        @justCloseDialog="justCloseDialogKeywordURLProduct"
        @majData="majDataURLProduct"
      ></wz-dialog-openai-keyword>
    </v-dialog>

    <!-- dialog modif keyword product -->
    <v-dialog
      v-model="showDialogModifKeywordProduct"
      persistent
      scrollable
      max-width="490"
    >
      <wz-dialog-openai-keyword-product
        :titleDialog="$t('modifKeywords')"
        :afficheDialog="showDialogModifKeywordProduct"
        :dataDialog="keywordProduct"
        @closeDialog="justCloseDialogKeywordProduct"
        @justCloseDialog="justCloseDialogKeywordProduct"
        @majData="majDataProduct"
      ></wz-dialog-openai-keyword-product>
    </v-dialog>

    <!-- dialog modif faq -->
    <v-dialog
      v-model="showDialogModifFAQ"
      persistent
      scrollable
      max-width="490"
    >
      <wz-dialog-openai-faq
        :titleDialog="addFAQ ? $t('addNewFAQ') : $t('modifFAQ')"
        :afficheDialog="showDialogModifFAQ"
        :dataDialog="addFAQ ? {} : questAnsw"
        :numFAQ=this.numFAQ
        :addFAQ=this.addFAQ
        @closeDialog="justCloseDialogFAQ"
        @justCloseDialog="justCloseDialogFAQ"
        @majFAQ="majFAQ"
      ></wz-dialog-openai-faq>
    </v-dialog>

    <!-- ajoute des mots clés à la selection d'url -->
    <v-dialog
      v-model="showDialogAddKeyword"
      persistent
      scrollable
      max-width="490"
    >
      <wz-dialog-confirm
        :titleDialogConfirm="selectedUrls.length > 1 ? $t('addKnow-s') : $t('addKnow')"
        :contentDialogConfirm="messageKeywords"
        :showDialogConfirmation="false"
        :contentDialogRes="messageResDialog"
        :startLoading="startLoading"
        :endLoading="endLoading"
        :loadingModifDialog="loadingModifUrl"
        :loadingRes="loadingRes"
        :closeDialogUniquement="closeDialogUniquement"
        @closeDialogConfirm="justCloseDialogConfirm"
        @justCloseDialogConfirm="justCloseDialogConfirm"
        @submitDialogConfirm="submitAddKeywords"
      ></wz-dialog-confirm>
    </v-dialog> 

    <!-- ajoute des mots clés à la selection api produits -->
    <v-dialog
      v-model="showDialogAddKeywordProduct"
      persistent
      scrollable
      max-width="490"
    >
      <wz-dialog-confirm
        :titleDialogConfirm="selectedProducts.length > 1 ? $t('addKnow-s') : $t('addKnow')"
        :contentDialogConfirm="messageKeywords"
        :showDialogConfirmation="false"
        :contentDialogRes="messageResDialog"
        :startLoading="startLoading"
        :endLoading="endLoading"
        :loadingModifDialog="loadingModifUrl"
        :loadingRes="loadingRes"
        :closeDialogUniquement="closeDialogUniquement"
        @closeDialogConfirm="justCloseDialogConfirm"
        @justCloseDialogConfirm="justCloseDialogConfirm"
        @submitDialogConfirm="submitAddKeywordsProducts"
      ></wz-dialog-confirm>
    </v-dialog> 

     <!-- ajoute des mots clés à la selection d'urls produit -->
     <v-dialog
      v-model="showDialogAddKeywordURLProduct"
      persistent
      scrollable
      max-width="490"
    >
      <wz-dialog-confirm
        :titleDialogConfirm="selectedURLProducts.length > 1 ? $t('addKnow-s') : $t('addKnow')"
        :contentDialogConfirm="messageKeywords"
        :showDialogConfirmation="false"
        :contentDialogRes="messageResDialog"
        :startLoading="startLoading"
        :endLoading="endLoading"
        :loadingModifDialog="loadingModifUrl"
        :loadingRes="loadingRes"
        :closeDialogUniquement="closeDialogUniquement"
        @closeDialogConfirm="justCloseDialogConfirm"
        @justCloseDialogConfirm="justCloseDialogConfirm"
        @submitDialogConfirm="submitAddKeywordsURLProducts"
      ></wz-dialog-confirm>
    </v-dialog> 

    <!-- dialog import pdf -->
    <v-dialog
      v-model="showDialogImportPDF"
      persistent
      scrollable
      max-width="490"
    >
      <wz-dialog-import-pdf
        :titleDialog="$t('importDoc')"
        :afficheDialog="showDialogImportPDF"
        @addFile="addFile"
        @justCloseDialog="justCloseDialogImportPDF"
      ></wz-dialog-import-pdf>
    </v-dialog>
    <!-- dialog segments pdf -->
    <v-dialog
      v-model="showDialogChunkPDF"
      scrollable
      max-width="80%"
    >
      <wz-dialog-file-chunk
        :titleDialog="$t('segPDF')"
        :afficheDialog="showDialogChunkPDF"
        :licKey=this.siteSelected.LIC_KEY
        :dataDialog="selectedFileChunk"
        @justCloseDialog="justCloseDialogChunkPDF"
      ></wz-dialog-file-chunk>
    </v-dialog>
    <!-- dialog resume image/pdf -->
    <v-dialog
      v-model="showDialogResume"
      scrollable
      max-width="80%"
    >
      <wz-dialog-file-resume
        :titleDialog="$t('résumé')"
        :afficheDialog="showDialogResume"
        :licKey=this.siteSelected.LIC_KEY
        :dataDialog="selectedFileChunk"
        @justCloseDialog="justCloseDialogResume"
      ></wz-dialog-file-resume>
    </v-dialog>
    <!-- dialog add analyse chat -->
    <v-dialog
      v-model="showDialogAddAnalyseChat"
      persistent
      scrollable
      max-width="490"
    >
      <wz-dialog-analyse-chat
        :titleDialog="titleAnalyseChat"
        :modifDialog="modifDialog"
        :afficheDialog="showDialogAddAnalyseChat"
        :dataDialog="selectedModifAnalyseChat"
        @addAnalyse="saveAnalyseChat"
        @modifAnalyse="modifAnalyseChat"
        @justCloseDialog="justCloseDialogAnalyseChat"
      ></wz-dialog-analyse-chat>
    </v-dialog>
    <!-- dialog add url -->
    <v-dialog
      v-model="showDialogAddUrls"
      persistent
      scrollable
      max-width="490"
    >
      <wz-dialog-add-urls
        :titleDialogConfirm="$t('searchUrl')"
        :contentDialogConfirm="$t('searchUrlTxt') + '<br>' + this.$t('AIMLicence') + ' <strong>' + siteSelected.LIC_KEY + '</strong>'" 
        :showDialogConfirmation="false"
        :contentDialogRes="messageResDialog"
        :startLoading="startLoading"
        :endLoading="endLoading"
        :loadingModifDialog="loadingSearchUrl"
        :loadingRes="loadingRes"
        :closeDialogUniquement="closeDialogUniquement"
        @closeDialogConfirm="justCloseDialogAddUrls"
        @justCloseDialogConfirm="justCloseDialogAddUrls"
        @submitDialogConfirm="submitCheckUrls"
      ></wz-dialog-add-urls>
    </v-dialog>
	<!-- dialog ameliorer prompt avec IA -->
    <v-dialog
      v-model="showDialogEnhancePrompt"
      scrollable
      max-width="80%"
    >
      <wz-dialog-enhance-prompt
        titleDialogConfirm="Améliorer le prompt avec lI.A."
        contentDialogConfirm="Utiliser l'I.A. pour améliorer (ou créer) cette partie de prompt" 
        :showDialogConfirmation="false"
        :contentDialogRes="messageResDialog"
        :currentPromptData="{ preview: prompt, personality: prompt_personality, environment: prompt_environment, objectif: prompt_objectif, communication: prompt_communication, questions: prompt_questions, rules: prompt_rules, tools: prompt_tools, custom: prompt_custom }"
        :startLoading="startLoading"
        :endLoading="endLoading"
        :loadingRes="loadingRes"
        :closeDialogUniquement="closeDialogUniquement"
        @applyEnhancedPromptSection="applyEnhancedPromptSection"
        @closeDialogConfirm="justCloseDialogEnhancePrompt"
        @justCloseDialogConfirm="justCloseDialogEnhancePrompt"
        @submitDialogConfirm="submitEnhancePrompt"
      ></wz-dialog-enhance-prompt>
    </v-dialog>
	<!-- dialog versionner le  prompt -->
    <v-dialog
      v-model="showDialogVersionPrompt"
      max-width="80%"
    >
      <wz-dialog-version-prompt
        titleDialogConfirm="Restaurer une version antérieure"
        contentDialogConfirm="Choisissez une ancienne version du prompt et restaurer cette version" 
        :showDialogConfirmation="false"
        :contentDialogRes="messageResDialog"
        :startLoading="startLoading"
        :endLoading="endLoading"
        :loadingRes="loadingRes"
        :closeDialogUniquement="closeDialogUniquement"
        :currentPromptData="{ preview: prompt, personality: prompt_personality, environment: prompt_environment, objectif: prompt_objectif, communication: prompt_communication, questions: prompt_questions, rules: prompt_rules, tools: prompt_tools, custom: prompt_custom }"
        @restorePromptSection="restorePromptSectionFromHistory"
        @closeDialogConfirm="justCloseDialogVersionPrompt"
        @justCloseDialogConfirm="justCloseDialogVersionPrompt"
        @submitDialogConfirm="submitVersionPrompt"
      ></wz-dialog-version-prompt>
    </v-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import _ from 'lodash'
import { DOMAINE } from '../../constants'
import { mapGetters, mapState } from 'vuex'
import permission from '../../mixins/permissions'
export default {
  mixins: [permission],
  data () {
    return {
      domaine: DOMAINE,
      loading: false,
      /**
       * chargement
       * @type {Boolean}
       */
      botUserId: 0,
      userJob: '',
      userName: '',
      closeDialogUniquement: false,
      showDialogAddUrls: false,
      showDialogLock: false,
      showDialogLockProduct: false,
      showDialogLockURLProduct: false,
      showDialogDeleteSupp: false,
      showDialogChunkPDF: false,
      showDialogResume: false,
      showDialogImportPDF: false,
      showDialogAddAnalyseChat: false,
      showDialogDeleteAnalyseChat: false,
      showDialogModifKeyword: false,
      showDialogModifKeywordURLProduct: false,
      showDialogModifKeywordProduct: false,
      showDialogModifFAQ: false,
      showDialogDeletesFAQ: false,
      showDialogDelete: false,
      showDialogDeleteProduct: false,
      showDialogDeleteURLProduct: false,
      showDialogAddKeywordURLProduct: false,
      showDialogDeleteFile: false,
      showDialogDeleteParsing: false,
      showDialogEmbedding: false,
      showDialogEmbeddingAPI: false,
      showDialogEmbeddingURLProduct: false,
      showDialogEnhancePrompt: false,
      showDialogVersionPrompt: false,
      loadingResumePrompt: false,
      loadingResumePromptAPI: false,
      loadingStartEmbedding: false,
      loadingEmbeddingUrl: false,
      loadingRes: false,
      loadingSearchUrl: false,
      showDialogAddKeyword: false,
      showDialogAddKeywordProduct: false,
      loadingModifFile: false,
      loadingModifUrl: false,
      loadingModifAnalyseChat: false,
      loadingModifSuppFAQ: false,
      loadingPrompt: false,
      openListeChatbot: false,
      loadingSavePrompt: false,
      loadingData: true,
      loadingDataInactif: true,
      loadingDataFiles: true,
      loadingStatsToken: true,
      loadingCheckSitemap: false,
      botStream: false,
      botStreamRef: false,
      majCronTab: false,
      majCronTabRef: false,
      majUrlAuto: false,
      majUrlAutoRef: false,
      pageScanne: '',
      pageScanneRef: '',
      // majCronTabPage: false,
      // majCronTabPageRef: false,
      // majUrlAutoPage: false,
      // majUrlAutoPageRef: false,
      // parseElement: '',
      // parseElementRef: '',
      messageAccueil: '',
      messageAccueilRef: '',
      questionAuto1: '',
      questionAuto2: '',
      questionAuto3: '',
      questionAuto4: '',
      questionAuto1Ref: '',
      questionAuto2Ref: '',
      questionAuto3Ref: '',
      questionAuto4Ref: '',
      comportment: true,
      showEx: true,
      parseUrl: '',
      parseUrlRef: '',
      prompt: '',
      prompt_personality: '',
      prompt_environment: '',
      prompt_objectif: '',
      prompt_communication: '',
      prompt_questions: '',
      prompt_rules: '',
      prompt_tools: '',
      prompt_custom: '',
      prompt_name: '',
      promptRef: '',
      prompt_personalityRef: '',
      prompt_environmentRef: '',
      prompt_objectifRef: '',
      prompt_communicationRef: '',
      prompt_questionsRef: '',
      prompt_rulesRef: '',
      prompt_toolsRef: '',
      prompt_customRef: '',
      prompt_nameRef: '',
      promptResume: '',
      promptResumeRef: '',
      promptSearch: '',
      promptSearchRef: '',
      productSelectAuto: true,
      productSelectAutoRef: true,
      functionCallOnOff: [
        true,
        false,
        true,
        true,
        true,
        true,
        true,
        true,
        true
      ],
      functionCallOnOffRef: [
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true
      ],
      functionCall: '',
      // functionCallRef: '',
      function0: '',
      function1: '',
      function2: '',
      function3: '',
      function4: '',
      function5: '',
      function6: '',
      function7: '',
      function8: '',
      function0Ref: '',
      function1Ref: '',
      function2Ref: '',
      function3Ref: '',
      function4Ref: '',
      function5Ref: '',
      function6Ref: '',
      function7Ref: '',
      function8Ref: '',
      addFonctionsNum: 0,
      fonctionsNum: '',
      parsingSelectif: [{name: 'parsing global (obligatoire)', methode: '', elements: '', default: true}],
      parsingSelectifRef: [],
      parsingsNum: '',
      SelectedParsingSupp: {},
      addParsingsNum: 0,
      dialog: '',
      dialogRef: '',
      contentResume: '',
      contentResumeKeys: '',
      infoCronPage: '',
      afficheStatusCronPage: false,
      statusSaveCronPage: 1,
      infoCron: '',
      afficheStatusCron: false,
      statusSaveCron: 1,
      APISelect: {name: 'chatCompletion'},
      APISelectRef: {name: 'chatCompletion'},
      APIListObject: [
        {name: 'response'},
        {name: 'chatCompletion'}
      ],
      modelSelect: {name: 'gpt-4o-mini', tokens: '127950'},
      modelSelectRef: {name: 'gpt-4o-mini', tokens: '127950'},
      modelListObject: [
        {name: 'gpt-3.5-turbo-0613', tokens: '4091'},
        {name: 'gpt-3.5-turbo', tokens: '16380'},
        {name: 'gpt-4-turbo', tokens: '127900'},
        {name: 'gpt-4', tokens: '8150'},
        {name: 'gpt-4o', tokens: '128000'},
        {name: 'gpt-4o-mini', tokens: '127950'},
        {name: 'mistral-small-latest', tokens: '127930'},
        {name: 'mistral-large-latest', tokens: '127931'},
        {name: 'open-mistral-nemo', tokens: '127932'},
        // {name: 'llama2'},
        // {name: 'llama2:13b'},
        {name: 'llama31-8b', tokens: '127940'},
        {name: 'gemini-1.5-pro', tokens: '127910'},
        {name: 'gemini-1.5-flash', tokens: '127911'},
        {name: 'gemini-1.5-flash-lite', tokens: '127912'},
        {name: 'gemini-2.0-flash', tokens: '127913'},
        {name: 'gemini-2.5-pro-preview-06-05', tokens: '127914'},
        {name: 'gemini-2.5-flash-preview-05-20', tokens: '127915'}
      ],
      timeLabels: [
        'Quotidien',
        'Hebdomadaire',
        'Mensuel',
        'Annuel'
      ],
      timeSelected: 1,
      timeSelectedRef: 1,
      // methodSelect: 'querySelector',
      // methodSelectRef: 'querySelector',
      keywordUrl: '',
      keywordProduct: '',
      questAnsw: {},
      methodList: [
        'querySelector',
        'querySelectorAll',
        'getElementById',
        'getElementsByTagName'
      ],
      tokens: [],
      // produts API
      selectedProduct: {},
      selectedProducts: [],
      totalProduct: 0,
      totalProductInactif: 0,
      rangeSliderProduct: [0, 200],
      minSliderProduct: 0,
      maxSliderProduct: this.totalProduct,
      products: [],
      productsSupp: [],
      // produts URL
      selectedURLProduct: {},
      selectedURLProducts: [],
      totalURLProduct: 0,
      totalURLProductInactif: 0,
      rangeSliderURLProduct: [0, 200],
      minSliderURLProduct: 0,
      maxSliderURLProduct: this.totalURLProduct,
      URLProducts: [],
      URLProductsSupp: [],
      // url standard
      selectedUrl: {},
      totalUrl: 0,
      rangeSliderUrl: [0, 200],
      minSliderUrl: 0,
      maxSliderUrl: this.totalUrl,
      urls: [],
      urlsSupp: [],
      faqs: [],
      numFAQ: 0,
      addFAQ: false,
      selectedUrls: [],
      selectedFaqs: [],
      selectedSuppUrls: [],
      selectActionUrl: [],
      selectActionProduct: [],
      selectActionURLProduct: [],
      selectActionSuppUrl: [],
      selectActionFAQ: [],
      selectActionPrompt: [],
      files: [],
      analyseChat: [],
      analyseChatRef: [],
      selectedFiles: [],
      selectActionFile: [],
      selectedAnalyseChat: [],
      selectedModifAnalyseChat: {},
      selectActionAnalyseChat: [],
      headersTokens: [
        { text: this.$t('AIData'), align: 'left', value: 'timestamp' },
        { text: this.$t('AISessionChat'), align: 'left', value: 'session_chat' },
        { text: this.$t('description'), align: 'left', value: 'description' },
        { text: this.$t('AIModele'), align: 'let', value: 'model' },
        { text: 'token prompt', align: 'left', value: 'tokens_prompt' },
        { text: 'token completion', align: 'left', value: 'tokens_completion' }
      ],
      headers: [
        { text: 'url', align: 'left', value: 'url' },
        { text: this.$t('AIDate'), align: 'left', value: 'date' },
        { text: 'error', align: 'center', value: 'error' },
        { text: 'new', align: 'center', value: 'new' },
        { text: 'update', align: 'center', value: 'updated' },
        { text: 'info', align: 'center', value: 'info' },
        { text: this.$t('AIVoir'), align: 'center', value: 'show' },
        { text: 'locked', align: 'center', value: 'locked' }
      ],
      headersProduct: [
        { text: this.$t('AIProduct'), align: 'left', value: 'product' },
        { text: this.$t('AIDate'), align: 'left', value: 'date' },
        { text: 'error', align: 'center', value: 'error' },
        { text: 'new', align: 'center', value: 'new' },
        { text: 'update', align: 'center', value: 'updated' },
        { text: 'info', align: 'center', value: 'info' },
        { text: this.$t('AIVoir'), align: 'center', value: 'show' },
        { text: 'locked', align: 'center', value: 'locked' }
      ],
      headersFAQ: [
        { text: 'index', align: 'right', value: 'index' },
        { text: this.$t('exportQuestion'), align: 'left', value: 'question' },
        { text: this.$t('reply'), align: 'left', value: 'reponse' },
        { text: 'update', align: 'right', value: 'update' }
      ],
      headersSupp: [
        { text: 'url', align: 'left', value: 'url' },
        { text: this.$t('AIVoir'), align: 'center', value: 'show' }
      ],
      headersFile: [
        { text: this.$t('AIDoc'), align: 'left', value: 'file' },
        { text: this.$t('AISeg'), align: 'left', value: 'chunk' }
      ],
      headersAnalyseChat: [
        { text: this.$t('exportQuestion'), align: 'left', value: 'q' },
        { text: this.$t('reply'), align: 'left', value: 'a' }
      ],
      search: '',
      searchTokens: '',
      bot: [], // liste des bots choisis
      selectedFileChunk: {},
      maxSearch: 10,
      minSearch: 1,
      maxToken: 2000,
      minToken: 50,
      maxTemp: 1,
      minTemp: 0,
      sliderTemp: 0.5,
      sliderTempRef: 0.5,
      sliderTokenResponse: 250,
      sliderTokenResponseRef: 250,
      sliderSearchResponse: 1,
      sliderSearchResponseRef: 1,
      modifDialog: false,
      titleAnalyseChat: this.$t('addAnalyseChat'),
      messageResDialog: '',
      startLoading: 0,
      endLoading: 0,
      MajTTL: 604800,
      MajSitemap: true,
      dateStartPicker: null,
      dateEndPicker: null,
      dateStartDisplayed: null,
      dateEndDisplayed: null,
      timestampStart: null,
      timestampEnd: null,
      modalStart: false,
      modalEnd: false,
      stats: null,
      periods: [],
      period: {},
      intervals: [
         { text: _.upperFirst(this.$t('per')) + ' ' + this.$tc('days', 1, {count: ''}), value: 1 },
         { text: _.upperFirst(this.$t('per')) + ' ' + this.$tc('months', 1, {count: ''}), value: 2 }
      ],
      interval: null,
      utilisations: [
         { text: _.upperFirst(this.$t('AIConsom')), value: 1 },
         { text: _.upperFirst(this.$t('AICost')), value: 2 }
      ],
      utilisation: {value: 1},
      options: {
        colors: [
          '#F44336', // red
          '#3F51B5', // indigo
          '#009688', // teal
          '#E91E63', // pink
          '#607D8B', // blue-grey
          '#9C27B0', // purple
          '#2196F3', // blue
          '#FF5722', // deep-orange
          '#795548', // brown
          '#4CAF50', // green
          '#8BC34A', // light-green
          '#673AB7', // deep-purple
          '#CDDC39', // lime
          '#03A9F4', // light-blue
          '#FFC107', // amber
          '#FF9800', // orange
          '#FFEB3B', // yellow
          '#00BCD4', // cyan
          '#9E9E9E'  // grey
        ],
        chart: {
          height: 300
        },
        title: {
          text: '',
          x: -20 // center
        },
        tooltip: {
          shared: true,
          borderColor: '#cccccc',
          crosshairs: true
        },
        xAxis: {
          categories: [] // à remplir par l'appel ajax
        },
        yAxis: [
          {
            allowDecimals: false,
            title: { text: '' },
            opposite: false
          },
          { // petites valeurs entières
            allowDecimals: false,
            labels: {
              format: '{value}',
              style: {
                // color: 'rgba(233, 30, 99, 1)'
              }
            },
            title: {
              text: 'tokens',
              style: {
                // color: 'rgba(233, 30, 99, 1)'
              }
            },
            opposite: true
          }
        ],
        series: [
          {
            name: 'tokens prompt (chat)',
            type: 'area',
            // color: 'rgba(0, 150, 136, 0.8)', // teal
            marker: {symbol: 'circle', enabled: false},
            visible: true,
            yAxis: 0,
            data: [] // à remplir par l'appel ajax
          },
          {
            name: 'tokens completion (chat)',
            type: 'area',
            // color: 'rgba(33, 150, 243, 0.8)', // blue
            marker: {symbol: 'circle', enabled: false},
            visible: true,
            yAxis: 0,
            data: [] // à remplir par l'appel ajax
          },
          {
            name: 'tokens prompt (analyze)',
            type: 'area',
            // color: 'rgba(33, 150, 243, 0.8)', // blue
            marker: {symbol: 'circle', enabled: false},
            visible: true,
            yAxis: 0,
            data: [] // à remplir par l'appel ajax
          },
          {
            name: 'tokens completion (analyze)',
            type: 'area',
            // color: 'rgba(33, 150, 243, 0.8)', // blue
            marker: {symbol: 'circle', enabled: false},
            visible: true,
            yAxis: 0,
            data: [] // à remplir par l'appel ajax
          },
          {
            name: 'tokens prompt (tokenize)',
            type: 'area',
            // color: 'rgba(33, 150, 243, 0.8)', // blue
            marker: {symbol: 'circle', enabled: false},
            visible: true,
            yAxis: 0,
            data: [] // à remplir par l'appel ajax
          },
          {
            name: 'tokens completion (tokenize)',
            type: 'area',
            // color: 'rgba(33, 150, 243, 0.8)', // blue
            marker: {symbol: 'circle', enabled: false},
            visible: true,
            yAxis: 0,
            data: [] // à remplir par l'appel ajax
          },
          {
            name: 'tokens prompt (embedding)',
            type: 'area',
            // color: 'rgba(33, 150, 243, 0.8)', // blue
            marker: {symbol: 'circle', enabled: false},
            visible: true,
            yAxis: 0,
            data: [] // à remplir par l'appel ajax
          },
          {
            name: 'tokens completion (embedding)',
            type: 'area',
            // color: 'rgba(33, 150, 243, 0.8)', // blue
            marker: {symbol: 'circle', enabled: false},
            visible: true,
            yAxis: 0,
            data: [] // à remplir par l'appel ajax
          }
          // {
          //   name: _.upperFirst(this.$tc('chats', 2, { count: '' })),
          //   type: 'column',
          //   color: 'rgba(233, 30, 99, 0.8)', // pink
          //   marker: {symbol: 'circle', enabled: false},
          //   visible: true,
          //   yAxis: 1,
          //   data: [] // à remplir par l'appel ajax
          // }
        ],
        exporting: {
          enabled: true
        },
        navigation: {
          buttonOptions: {
            verticalAlign: 'bottom',
            y: -15,
            x: -20
          }
        },
        credits: {
          enabled: false
        }
      },
      responseToken: [
        {tokensPrompt: 400},
        {tokensCompletion: 200},
        {tokensTotal: 600}
      ]
    }
  },
  computed: {
    ...mapGetters('_User', [ 'user' ]),
    ...mapState('_Sites', ['sites', 'siteSelected']),
    ...mapGetters('_Stats', ['tokenParams']),

    timestampStartPicker () {
      let date = moment(this.dateStartPicker, 'YYYY-MM-DD')
      // console.log(date.format('DD/MM/YYYY')); // affiche '22/12/2022'
      return date.format('x')
    },
    timestampEndPicker () {
      let date = moment(this.dateEndPicker, 'YYYY-MM-DD')
      // ajoute 23h59 pour aller en fin de journée
      return Math.floor(date.format('x')) + 86359999
    },
    isGptModel () {
      return this.modelSelect &&
      typeof this.modelSelect.name === 'string' &&
      this.modelSelect.name.toLowerCase().includes('gpt')
    },
    nbPrompt () {
      // console.log('nbPrompt', this.utilisation.value)
      if (this.utilisation.value === 2) { // cout de token
        let cout = _.sumBy(this.responseToken, 'tokensPrompt')
        return '$' + cout.toFixed(3)
      } else {
        return _.sumBy(this.responseToken, 'tokensPrompt')
      }
    },
    nbCompletion () {
      if (this.utilisation.value === 2) { // cout de token
        let cout = _.sumBy(this.responseToken, 'tokensCompletion')
        return '$' + cout.toFixed(3)
      } else {
        return _.sumBy(this.responseToken, 'tokensCompletion')
      }
    },
    nbTotal () {
      if (this.utilisation.value === 2) { // cout de token
        let cout = _.sumBy(this.responseToken, 'tokensTotal')
        return '$' + cout.toFixed(3)
      } else {
        return _.sumBy(this.responseToken, 'tokensTotal')
      }
    },
    // maxDatesStart: () => this.parseDate(this.dateEndPicker),
    // minDatesStart: () => this.parseDate(this.formatDate(new Date(moment().subtract(1, 'month')))),
    allowedDatesStart () {
      return {
        max: this.parseDate(this.dateEndPicker),
        min: this.parseDate(this.formatDate(new Date(moment().subtract(1, 'month'))))
      }
    },
    // maxDatesEnd: () => this.parseDate(this.formatDate(new Date(moment().local().endOf('day')))),
    // minDatesEnd: () => this.parseDate(this.dateStartPicker),
    allowedDatesEnd () {
      return {
        max: this.parseDate(this.formatDate(new Date(moment().local().endOf('day')))),
        min: this.parseDate(this.dateStartPicker)
      }
    },
    nbDays () {
      return moment(this.dateEndPicker, 'YYYY[-]MM[-]DD').diff(moment(this.dateStartPicker), 'days') + 1
    },
    modifPrompt () {
      // console.log('this.parsingSelectifRef :', this.parsingSelectifRef)
      // console.log('this.parsingSelectif :', this.parsingSelectif)
      if (
        this.APISelectRef.name !== this.APISelect.name ||
        this.modelSelectRef.name !== this.modelSelect.name ||
        this.promptRef !== this.prompt ||
        this.prompt_personalityRef !== this.prompt_personality ||
        this.prompt_environmentRef !== this.prompt_environment ||
        this.prompt_objectifRef !== this.prompt_objectif ||
        this.prompt_communicationRef !== this.prompt_communication ||
        this.prompt_questionsRef !== this.prompt_questions ||
        this.prompt_rulesRef !== this.prompt_rules ||
        this.prompt_toolsRef !== this.prompt_tools ||
        this.prompt_customRef !== this.prompt_custom ||
        this.prompt_nameRef !== this.prompt_name ||
        this.promptResumeRef !== this.promptResume ||
        this.promptSearchRef !== this.promptSearch ||
        this.productSelectAutoRef !== this.productSelectAuto ||
        // this.functionCallRef !== this.functionCall ||
        JSON.stringify(this.parsingSelectifRef) !== JSON.stringify(this.parsingSelectif) ||
        this.dialogRef !== this.dialog ||
        // this.parseElementRef !== this.parseElement ||
        this.parseUrlRef !== this.parseUrl ||
        this.messageAccueilRef !== this.messageAccueil ||
        this.questionAuto1Ref !== this.questionAuto1 ||
        this.questionAuto2Ref !== this.questionAuto2 ||
        this.questionAuto3Ref !== this.questionAuto3 ||
        this.questionAuto4Ref !== this.questionAuto4 ||
        this.sliderSearchResponseRef !== this.sliderSearchResponse ||
        this.sliderTokenResponseRef !== this.sliderTokenResponse ||
        this.sliderTempRef !== this.sliderTemp ||
        this.majUrlAutoRef !== this.majUrlAuto ||
        this.function0Ref !== this.function0 ||
        this.function1Ref !== this.function1 ||
        this.function2Ref !== this.function2 ||
        this.function3Ref !== this.function3 ||
        this.function4Ref !== this.function4 ||
        this.function5Ref !== this.function5 ||
        this.function6Ref !== this.function6 ||
        this.function7Ref !== this.function7 ||
        this.function8Ref !== this.function8 ||
        JSON.stringify(this.functionCallOnOffRef) !== JSON.stringify(this.functionCallOnOff) ||
        this.majCronTabRef !== this.majCronTab ||
        this.timeSelectedRef !== this.timeSelected ||
        // this.majCronTabPageRef !== this.majCronTabPage ||
        this.pageScanne !== this.pageScanneRef ||
        this.botStreamRef !== this.botStream
      ) {
        return true
      } else {
        return false
      }
    },
    // affiche le bouton embedding uniquement si des mots clés ont été modifés
    modifKeywords () {
      let update = 0
      // console.log('modif update url', this.urls)
      for (const index in this.urls) {
        // console.log('modif update url', this.urls[index])
        // console.log('updated', this.urls[index].updated)
        if (this.urls[index].updated) {
          update++
        }
      }
      if (update) {
        return true
      } else {
        return false
      }
    },

    /**
     * Checks if any products have been updated.
     *
     * Iterates over the products array and increments the update counter
     * if a product's 'updated' property is true.
     *
     * Returns true if there are any updates, otherwise returns false.
     *
     * @returns {boolean} - True if there are any updates, otherwise false.
     */
    modifKeywordsProduct () {
      let update = 0
      // console.log('modif update url', this.products)
      for (const index in this.products) {
        // console.log('modif update url', this.products[index])
        // console.log('updated', this.products[index].updated)
        if (this.products[index].updated) {
          update++
        }
      }
      // return true if there are any updates, otherwise return false
      return update > 0
    },

    /**
     * Checks if any products have been updated.
     *
     * Iterates over the products array and increments the update counter
     * if a url product's 'updated' property is true.
     *
     * Returns true if there are any updates, otherwise returns false.
     *
     * @returns {boolean} - True if there are any updates, otherwise false.
     */
    modifKeywordsURLProduct () {
      let update = 0
      // console.log('modif update url', this.products)
      for (const index in this.URLProducts) {
        // console.log('modif update url', this.products[index])
        // console.log('updated', this.products[index].updated)
        if (this.URLProducts[index].updated) {
          update++
        }
      }
      // return true if there are any updates, otherwise return false
      return update > 0
    },

    computedActionUrl () {
      let actions = [
        {text: this.$t('supSelect'), id: 'sup'},
        {text: this.$t('AILockSelect'), id: 'lock'},
        {text: this.$t('AIAddKnow'), id: 'keywords'}
      ]
      return actions
    },
    computedActionProduct () {
      let actions = [
        {text: this.$t('supSelect'), id: 'sup'},
        {text: this.$t('AILockSelect'), id: 'lock'},
        {text: this.$t('AIAddKnow'), id: 'keywords'}
      ]
      return actions
    },
    computedActionFAQ () {
      let actions = [
        {text: this.$t('supSelect'), id: 'sup'}
      ]
      return actions
    },
    computedActionSuppUrl () {
      let actions = [
        {text: this.$t('supSelect'), id: 'sup'}
      ]
      return actions
    },
    // text du contenue de la fenetre de dialog de confirmation de delete url actives
    listeSelectedUrl () {
      let messageDelUrl = this.$t('supFAQ2')
      if (this.selectedUrls.length) {
        messageDelUrl += '<p><ol>'
        this.selectedUrls.forEach(res => {
          messageDelUrl += '<li>' + res.url + '</li>'
        })
        messageDelUrl += '</ol></p>'
      }
      return messageDelUrl
    },

    // liste de toutes les urls supprimées
    listeAllDelUrl () {
      let allDelUrls = []
      if (this.urlsSupp.length) {
        this.urlsSupp.forEach(res => {
          allDelUrls.push(res)
        })
      }
      if (this.URLProductsSupp.length) {
        this.URLProductsSupp.forEach(res => {
          allDelUrls.push(res)
        })
      }
      return allDelUrls
    },
    totalUrlInactif () {
      return this.urlsSupp.length + this.URLProductsSupp.length
    },

    // text du contenue de la fenetre de dialog de confirmation de delete api products
    listeSelectedProduct () {
      let messageDelProduct = this.$t('supFAQ2')
      if (this.selectedProducts.length) {
        messageDelProduct += '<p><ol>'
        this.selectedProducts.forEach(res => {
          messageDelProduct += '<li>' + res.product + '</li>'
        })
        messageDelProduct += '</ol></p>'
      }
      return messageDelProduct
    },

    listeSelectedURLProduct () {
      let messageDelProduct = this.$t('supFAQ2')
      if (this.selectedURLProducts.length) {
        messageDelProduct += '<p><ol>'
        this.selectedURLProducts.forEach(res => {
          messageDelProduct += '<li>' + res.url + '</li>'
        })
        messageDelProduct += '</ol></p>'
      }
      return messageDelProduct
    },

    // text du contenue de la fenetre de dialog de confirmation de delete url actives
    listeSelectedFAQ () {
      let messageDelFAQ = this.$t('supFAQ2')
      if (this.selectedFaqs.length) {
        messageDelFAQ += '<p><ol>'
        this.selectedFaqs.forEach(res => {
          messageDelFAQ += '<li>' + res.question + '</li>'
        })
        messageDelFAQ += '</ol></p>'
      }
      return messageDelFAQ
    },

    // text du contenue de la fenetre de dialog de confirmation de delete url actives
    messageKeywords () {
      let messageDelUrl = this.$t('knowInfo')
      if (this.selectedUrls.length) {
        messageDelUrl += '<p><ol>'
        this.selectedUrls.forEach(res => {
          messageDelUrl += '<li>' + res.url + '</li>'
        })
        messageDelUrl += '</ol></p>'
      }
      return messageDelUrl
    },
    // text du contenue de la fenetre de dialog de confirmation de delete url inactives
    listeSelectedSuppUrl () {
      let messageDelUrl = this.$t('supFAQ2')
      if (this.selectedSuppUrls.length) {
        messageDelUrl += '<p><ol>'
        this.selectedSuppUrls.forEach(res => {
          messageDelUrl += '<li>' + res.url + '</li>'
        })
        messageDelUrl += '</ol></p>'
      }
      return messageDelUrl
    },
    computedActionFile () {
      let actions = [
        {text: this.$t('supSelect'), id: 'sup'}
      ]
      // console.log('actions', actions)
      return actions
    },
    computedActionAnalyseChat () {
      let actions = [
        {text: this.$t('supSelect'), id: 'sup'}
      ]
      // console.log('actions', actions)
      return actions
    },
    // text du contenue de la fenetre de dialog de confirmation de delete url
    listeSelectedFile () {
      let messageDelFile = this.$t('supFAQ2')
      if (this.selectedFiles.length) {
        messageDelFile += '<p><ol>'
        this.selectedFiles.forEach(res => {
          messageDelFile += '<li>' + res.file + '</li>'
        })
        messageDelFile += '</ol></p>'
      }
      return messageDelFile
    },

    // text du contenue de la fenetre de dialog de confirmation de delete analyse chat
    listeSelectedAnalyseChat () {
      let messageDelFile = this.$t('supFAQ2')
      if (this.selectedAnalyseChat.length) {
        messageDelFile += '<p><ol>'
        this.selectedAnalyseChat.forEach(res => {
          messageDelFile += '<li>' + res.q + '</li>'
        })
        messageDelFile += '</ol></p>'
      }
      return messageDelFile
    },
    // url du bon serveur (prod / dev)
    serveurAI () {
      if (window.location.origin.indexOf('localhost') > -1) {
        return 'https://lb-sw-generator-dev-v2.watcheebox.net/'
      } else if (window.location.origin.indexOf('backoffice-preprod') > -1) {
        return 'https://lb-sw-generator-preprod-v2.watcheebox.net/'
      } else if (window.location.origin.indexOf('backoffice') > -1) {
        return 'https://lb-sw-generator.watcheebox.net/'
      } else {
        return 'https://lb-sw-generator.watcheebox.net/'
      }
    },
    fonctions () {
      if (this.functionCall) {
        // console.log('JSON.parse(this.functionCall)', JSON.parse(this.functionCall))
        const functions = JSON.parse(this.functionCall)
        for (var index in functions) {
          // console.log('index', index)
          if (index === '0') {
            // console.log('index 2', index)
            this.function0 = JSON.stringify(functions[index], null, '\t')
            this.function0Ref = JSON.stringify(functions[index], null, '\t')
          }
          if (index === '1') {
            this.function1 = JSON.stringify(functions[index], null, '\t')
            this.function1Ref = JSON.stringify(functions[index], null, '\t')
          }
          if (index === '2') {
            this.function2 = JSON.stringify(functions[index], null, '\t')
            this.function2Ref = JSON.stringify(functions[index], null, '\t')
          }
          if (index === '3') {
            this.function3 = JSON.stringify(functions[index], null, '\t')
            this.function3Ref = JSON.stringify(functions[index], null, '\t')
          }
          if (index === '4') {
            this.function4 = JSON.stringify(functions[index], null, '\t')
            this.function4Ref = JSON.stringify(functions[index], null, '\t')
          }
          if (index === '5') {
            this.function5 = JSON.stringify(functions[index], null, '\t')
            this.function5Ref = JSON.stringify(functions[index], null, '\t')
          }
          if (index === '6') {
            this.function6 = JSON.stringify(functions[index], null, '\t')
            this.function6Ref = JSON.stringify(functions[index], null, '\t')
          }
          if (index === '7') {
            this.function7 = JSON.stringify(functions[index], null, '\t')
            this.function7Ref = JSON.stringify(functions[index], null, '\t')
          }
          if (index === '8') {
            this.function8 = JSON.stringify(functions[index], null, '\t')
            this.function8Ref = JSON.stringify(functions[index], null, '\t')
          }
        }
        this.addFonctionsNum = functions.length
        this.fonctionsNum = functions.length
        // console.log('functions', functions)
        return functions
      } else {
        return []
      }
    },

    // methode par defaut
    methodSelect () {
      for (const parsing of this.parsingSelectif) {
        if (parsing.default) {
          return parsing.methode
        }
      }
    },
    // elements à scanner par defaut
    parseElement () {
      for (const parsing of this.parsingSelectif) {
        if (parsing.default) {
          return parsing.elements
        }
      }
    }
    // selectedUrl () {
    //   return {url: this.urls[0].url}
    // }
     // si la tache cron est activé pour cette licence
    // tacheCron () {
    //   if (window.location.origin.indexOf('localhost') > -1) {
    //     return 'https://openai-generator-dev.watcheebox.net/'
    //   } else if (window.location.origin.indexOf('beta') > -1) {
    //     return 'https://openai-generator-ppr.watcheebox.net/'
    //   } else {
    //     return 'https://openai-generator.watcheebox.net/'
    //   }
    // }
  },
  mounted () {
    // définition de l'intervalle à afficher dans le graphique
    this.interval = this.intervals[0]
    // définition de l'utilisation des tokens
    this.utilisation = this.utilisations[0]
  },
  created () {
    if (localStorage.getItem('startListUrl')) {
      this.rangeSliderUrl[0] = localStorage.getItem('startListUrl')
    }

    if (localStorage.getItem('endListUrl')) {
      this.rangeSliderUrl[1] = localStorage.getItem('endListUrl')
    }

    if (localStorage.getItem('startListProduct')) {
      this.rangeSliderProduct[0] = localStorage.getItem('startListProduct')
    }

    if (localStorage.getItem('endListProduct')) {
      this.rangeSliderProduct[1] = localStorage.getItem('endListProduct')
    }

    this.selectBot()

    // recupère la liste des urls du client dans redis
    this.loadUrlsClient('actif')
    // recupère la liste des produits du client dans redis
    this.loadProductsClient('actif')
    // recupère la liste des url produits du client dans redis
    this.loadURLProductsClient('actif')
    // recupère la liste des documents du client dans redis
    this.loadFilesClient(this.siteSelected.LIC_KEY)
    // recupère la liste des FAQ du client dans redis
    this.loadFaqsClient()

    // recupère la liste des urls supprimées du client dans redis
    this.loadUrlsClient('inactif')
    this.loadProductsClient('inactif') // liste produit api
    this.loadURLProductsClient('inactif') // liste produit url
    this.initPeriod()
    this.periods = [
      { text: _.upperFirst(this.$tc('custom', 2)), value: 0 },
      { text: _.upperFirst(this.$t('yesterday')), value: 1 },
      { text: _.upperFirst(this.$t('thisWeek')), value: 2 },
      { text: _.upperFirst(this.$t('thisMonth')), value: 3 },
      { text: _.upperFirst(this.$t('last7Days')), value: 4 },
      { text: _.upperFirst(this.$t('last30Days')), value: 5 },
      { text: _.upperFirst(this.$t('lastWeek')), value: 6 }
    ]
    this.getStatsOpenAI()
  },
  methods: {
    selectBot () {
      console.log('this.bot', this.bot)
      if (this.user.botSelected.length) {
        this.bot = this.user.botSelected
      } else {
        // par default c'est le premier de la list
        this.bot.splice(0, 1, this.user.bots[0])
      }
      this.botUserId = this.bot[0].USR_ID
      this.userJob = this.bot[0].USR_JOB
      this.userName = this.bot[0].USR_FIRST_NAME + ' ' + this.bot[0].USR_LAST_NAME

      // commenté le 05.03.26 car deux configs php sont ainsi chargées, or seule celle de updateSite suffit ->a tester en monobot et monosite
      // this.getPrompt(this.bot[0].USR_ID)
    },
    updateSite (site) {
      // console.log('updateSite : ', site)
      this.botUserId = JSON.parse(site.DSK_BOT_USER).user_id
      this.userJob = JSON.parse(site.DSK_BOT_USER).user_job
      this.userName = JSON.parse(site.DSK_BOT_USER).user_name

      this.getPrompt(JSON.parse(site.DSK_BOT_USER).user_id, site.LIC_KEY)
    },
    reInitBots () {
      // console.log('iniwatson', this.bot)
      // si on change de bot, il faut effacer l'id du repertoire de la base de connaissance
      this.$store.commit('_Sites/SET_BASE_CONNAISSANCE', '')
      this.bot = this.user.botSelected
      this.loading = false
      this.getPrompt(this.bot[0].USR_ID) // affiche le prompt du nouveau bot selectionné
    },
    closeListe () {
      // console.log('close liste chatbot')
      this.openListeChatbot = false
    },
    changeMethod () {
      // console.log('change method')
    },
    changeModel () {
      // console.log('change model)
    },
    afficheDate (data) {
      return moment(data).format('YYYY[-]MM[-]DD[ ]HH[h]mm[:]ss')
    },

    /**
     * lance toutes les requêtes des stats
     */
    getAll () {
      this.getStatsOpenAI()
    },
    getStatsOpenAI () {
      this.loadingStatsToken = true
      // let parametres = '&dateStart=' + this.timestampStart
      // parametres += '&dateEnd=' + this.timestampEnd
      // parametres += '&licence=' + this.siteSelected.LIC_KEY
      let parametres = this.tokenParams + '&licence=' + this.siteSelected.LIC_KEY
      // console.log('getStatsOpenAI : ', parametres)
      // console.log('parametres', parametres)
      this.axios.get('get/statsTokensLicence.php?' + parametres)
      .then(response => {
        // console.log('getStatsOpenAI response', response)
        this.tokens = response.data
        this.loadingStatsToken = false
        this.stats = response.data
        this.updateSeries()
        // this.totalTempsAllChats = response.data.totalTempsAllChats // en secondes
        // this.tempsOccupationPartielle = response.data.tempsOccupationPartielle // en secondes
        // this.tempsOccupationBusy = response.data.tempsOccupationBusy // en secondes
        // this.moyenChatMax = response.data.moyenChatMax
        // this.moyenChatHeure = response.data.chatParHeure
      })
      .catch((error) => {
        console.log('error chargement des stats : ', error)
        this.loadingStatsToken = false
      })
    },
    // formatage des données stats pour aller dans les 'series'
    updateSeries () {
      // console.log('this.dateEndPicker', this.dateEndPicker)
      var tokensPrompt = 0
      var tokensCompletion = 0
      var days = []
      var addDay = moment.duration(1, 'd') // ajoute 1 jour pour coller à la date de fin
      let dateEnd = moment(this.dateEndPicker, 'YYYY[-]MM[-]DD').add(addDay).format('ddd D MMM YY')
      var period = {
        start: moment(this.dateStartPicker, 'YYYY[-]MM[-]DD'),
        end: moment(dateEnd, 'ddd D MMM YY')
      }
      var i = 0
      while (i < moment(period.end).diff(period.start, 'days')) {
        var date = moment(period.start).add(i, 'days').format('Y-M-D')
        var time = Number(moment(period.start).format('X')) // timestamp en seconde
        days.push(
          {
            time: time,
            tokens_prompt_chat: 0,
            tokens_completion_chat: 0,
            tokens_prompt_analyse: 0,
            tokens_completion_analyse: 0,
            tokens_prompt_tokenize: 0,
            tokens_completion_tokenize: 0,
            tokens_prompt_embedding: 0,
            tokens_completion_embedding: 0,
            date: date
          }
        )
        i++
      }
      // vide les tableau contenant les dates et les infos précédentes
      this.options.xAxis.categories = []
      this.options.series[0].data = []
      this.options.series[1].data = []
      this.options.series[2].data = []
      this.options.series[3].data = []
      this.options.series[4].data = []
      this.options.series[5].data = []
      this.options.series[6].data = []
      this.options.series[7].data = []
      // this.options.series[2].data = []
      // pour chaqies date du tableau
      // console.log('this.stats', this.stats)
      if (this.stats) {
        for (const stat of this.stats) {
          if (this.utilisation.value === 1) { // consommation de token
            // console.log('stat.tokens_prompt', stat.tokens_prompt)
            tokensPrompt += stat.tokens_prompt
            tokensCompletion += stat.tokens_completion
            // console.log(moment(stat.timestamp).format('Y-M-D'))
            for (const day of days) {
              if (moment(stat.timestamp).format('Y-M-D') === day.date) {
                // tokens utilisés pour le chat
                if (stat.description === 'completionChat' || stat.description === 'completion') {
                  day.tokens_prompt_chat += stat.tokens_prompt
                  day.tokens_completion_chat += stat.tokens_completion
                }
                // tokens utilisés pour l'analyse de chat
                if (stat.description === 'analyse chat') {
                  day.tokens_prompt_analyse += stat.tokens_prompt
                  day.tokens_completion_analyse += stat.tokens_completion
                }
                // tokens pour generation des mots clés
                if (stat.description === 'tokenize content') {
                  day.tokens_prompt_tokenize += stat.tokens_prompt
                  day.tokens_completion_tokenize += stat.tokens_completion
                }
                // tokens utilisés pour la génération d'un embedding
                if (stat.description === 'Embedding') {
                  day.tokens_prompt_embedding += stat.tokens_prompt
                  day.tokens_completion_embedding += stat.tokens_completion
                }
              }
            }
            // cout des tokens
          } else {
            // tokensPrompt += stat.tokens_prompt
            // tokensCompletion += stat.tokens_completion
            // console.log(moment(stat.timestamp).format('Y-M-D'))
            for (const day of days) {
              if (moment(stat.timestamp).format('Y-M-D') === day.date) {
                // tokens utilisés pour le chat
                // gpt-3.5-turbo-0613 prompt  = $0.0015 / 1k tokens
                // gpt-3.5-turbo-0613 completion = $0.002 / 1k tokens
                if (stat.description === 'completionChat') {
                  if (stat.model === 'gpt-3.5-turbo' || stat.model === 'gpt-3.5-turbo-0125' || stat.model === 'gpt-3.5-turbo-0613' || stat.model === 'gpt-3.5-turbo-1106') {
                    day.tokens_prompt_chat += ((stat.tokens_prompt / 1000) * 0.0005)
                    day.tokens_completion_chat += ((stat.tokens_completion / 1000) * 0.0015)
                  } else if (stat.model === 'gpt-4-turbo' || stat.model === 'gpt-4-0613') {
                    day.tokens_prompt_chat += ((stat.tokens_prompt / 1000) * 0.01)
                    day.tokens_completion_chat += ((stat.tokens_completion / 1000) * 0.03)
                  } else if (stat.model === 'gpt-4o') {
                    day.tokens_prompt_chat += ((stat.tokens_prompt / 1000) * 0.0025)
                    day.tokens_completion_chat += ((stat.tokens_completion / 1000) * 0.010)
                  } else if (stat.model === 'gpt-4o-mini') {
                    day.tokens_prompt_chat += ((stat.tokens_prompt / 1000) * 0.00015)
                    day.tokens_completion_chat += ((stat.tokens_completion / 1000) * 0.0006)
                  }
                }
                // text-davinci-003 prompt  = $0.0015 / 1k tokens
                // text-davinci-003 completion = $0.002 / 1k tokens
                if (stat.description === 'completion') {
                  if (stat.model === 'gpt-3.5-turbo' || stat.model === 'gpt-3.5-turbo-0125' || stat.model === 'text-davinci-003' || stat.model === 'gpt-3.5-turbo-0613' || stat.model === 'gpt-3.5-turbo-1106') {
                    day.tokens_prompt_chat += ((stat.tokens_prompt / 1000) * 0.0005)
                    day.tokens_completion_chat += ((stat.tokens_completion / 1000) * 0.0015)
                  } else if (stat.model === 'gpt-4-turbo' || stat.model === 'gpt-4-0613') {
                    day.tokens_prompt_chat += ((stat.tokens_prompt / 1000) * 0.01)
                    day.tokens_completion_chat += ((stat.tokens_completion / 1000) * 0.03)
                  } else if (stat.model === 'gpt-4o') {
                    day.tokens_prompt_chat += ((stat.tokens_prompt / 1000) * 0.0025)
                    day.tokens_completion_chat += ((stat.tokens_completion / 1000) * 0.010)
                  } else if (stat.model === 'gpt-4o-mini') {
                    day.tokens_prompt_chat += ((stat.tokens_prompt / 1000) * 0.00015)
                    day.tokens_completion_chat += ((stat.tokens_completion / 1000) * 0.0006)
                  }
                }
                // tokens utilisés pour l'analyse de chat
                // gpt-3.5-turbo-0613 prompt = $0.0015 / 1k tokens
                // gpt-3.5-turbo-0613 completion = $0.002 / 1k tokens
                if (stat.description === 'analyse chat') {
                  day.tokens_prompt_analyse += ((stat.tokens_prompt / 1000) * 0.0005)
                  day.tokens_completion_analyse += ((stat.tokens_completion / 1000) * 0.0015)
                }
                // tokens pour generation des mots clés
                // text-curie-001 prompt = $0.002 / 1k tokens
                // text-curie-001 completion = $0.002 / 1k tokens
                if (stat.description === 'tokenize content') {
                  day.tokens_prompt_tokenize += ((stat.tokens_prompt / 1000) * 0.0005)
                  day.tokens_completion_tokenize += ((stat.tokens_completion / 1000) * 0.0015)
                }
                // tokens utilisés pour la génération d'un embedding
                // text-embedding-ada-002-v2 prompt = $0.0001 / 1k tokens
                // text-embedding-ada-002-v2 completion = $0.0001 / 1k tokens
                if (stat.description === 'Embedding') {
                  day.tokens_prompt_embedding += ((stat.tokens_prompt / 1000) * 0.0001)
                  day.tokens_completion_embedding += ((stat.tokens_completion / 1000) * 0.0001)
                }
              }
            }
          }
        }
      }
      if (this.interval.value === 1) { // par jour
        this.options.series[0].type = 'area'
        this.options.series[1].type = 'area'
        this.options.series[2].type = 'area'
        this.options.series[3].type = 'area'
        this.options.series[4].type = 'area'
        this.options.series[5].type = 'area'
        this.options.series[6].type = 'area'
        this.options.series[7].type = 'area'
        _.forEach(days, day => {
          this.options.xAxis.categories.push(moment(day.date).format('ddd D MMM YY'))
          if (this.utilisation.value === 2) { // cout de token
            tokensPrompt += day.tokens_prompt_chat
            tokensPrompt += day.tokens_prompt_analyse
            tokensPrompt += day.tokens_prompt_tokenize
            tokensPrompt += day.tokens_prompt_embedding
            tokensCompletion += day.tokens_completion_chat
            tokensCompletion += day.tokens_completion_analyse
            tokensCompletion += day.tokens_completion_tokenize
            tokensCompletion += day.tokens_completion_embedding
            // console.log('day.tokens_prompt_chat', day.tokens_prompt_chat)
            // console.log('day.tokens_prompt_chat ::', day.tokens_prompt_chat.toFixed(3))
            this.options.series[0].data.push(Number(day.tokens_prompt_chat.toFixed(3)))
            this.options.series[1].data.push(Number(day.tokens_completion_chat.toFixed(3)))
            this.options.series[2].data.push(Number(day.tokens_prompt_analyse.toFixed(3)))
            this.options.series[3].data.push(Number(day.tokens_completion_analyse.toFixed(3)))
            this.options.series[4].data.push(Number(day.tokens_prompt_tokenize.toFixed(3)))
            this.options.series[5].data.push(Number(day.tokens_completion_tokenize.toFixed(3)))
            this.options.series[6].data.push(Number(day.tokens_prompt_embedding.toFixed(3)))
            this.options.series[7].data.push(Number(day.tokens_completion_embedding.toFixed(3)))
          } else {
            this.options.series[0].data.push(day.tokens_prompt_chat)
            this.options.series[1].data.push(day.tokens_completion_chat)
            this.options.series[2].data.push(day.tokens_prompt_analyse)
            this.options.series[3].data.push(day.tokens_completion_analyse)
            this.options.series[4].data.push(day.tokens_prompt_tokenize)
            this.options.series[5].data.push(day.tokens_completion_tokenize)
            this.options.series[6].data.push(day.tokens_prompt_embedding)
            this.options.series[7].data.push(day.tokens_completion_embedding)
          }
        })
      } else { // par mois
        this.options.series[0].type = 'column'
        this.options.series[1].type = 'column'
        this.options.series[2].type = 'column'
        this.options.series[3].type = 'column'
        this.options.series[4].type = 'column'
        this.options.series[5].type = 'column'
        this.options.series[6].type = 'column'
        this.options.series[7].type = 'column'
        _.forEach(days, day => {
          // vérifie que le mois du jour parcouru n'est pas déjà présent dans le tableau des x
          let found = -1
          for (var i = 0; i < this.options.xAxis.categories.length; i++) {
            if (this.options.xAxis.categories[i] === moment(day.date).format('MMMM YYYY')) {
              found = i
            }
          }
          if (found === -1) {
            // ajout du mois dans le tableau des x
            this.options.xAxis.categories.push(moment(day.date).format('MMMM YYYY'))
            this.options.series[0].data.push(day.tokens_prompt_chat)
            this.options.series[1].data.push(day.tokens_completion_chat)
            this.options.series[2].data.push(day.tokens_prompt_analyse)
            this.options.series[3].data.push(day.tokens_completion_analyse)
            this.options.series[4].data.push(day.tokens_prompt_tokenize)
            this.options.series[5].data.push(day.tokens_completion_tokenize)
            this.options.series[6].data.push(day.tokens_prompt_embedding)
            this.options.series[7].data.push(day.tokens_completion_embedding)
          }
          // ajout des valeurs dans le mois correspondant
          this.options.series[0].data[found] += day.tokens_prompt_chat
          this.options.series[1].data[found] += day.tokens_completion_chat
          this.options.series[2].data[found] += day.tokens_prompt_analyse
          this.options.series[3].data[found] += day.tokens_completion_analyse
          this.options.series[4].data[found] += day.tokens_prompt_tokenize
          this.options.series[5].data[found] += day.tokens_completion_tokenize
          this.options.series[6].data[found] += day.tokens_prompt_embedding
          this.options.series[7].data[found] += day.tokens_completion_embedding
          if (this.utilisation.value === 2) { // cout de token
            tokensPrompt += day.tokens_prompt_chat
            tokensPrompt += day.tokens_prompt_analyse
            tokensPrompt += day.tokens_prompt_tokenize
            tokensPrompt += day.tokens_prompt_embedding
            tokensCompletion += day.tokens_completion_chat
            tokensCompletion += day.tokens_completion_analyse
            tokensCompletion += day.tokens_completion_tokenize
            tokensCompletion += day.tokens_completion_embedding
          }
        })
        if (this.utilisation.value === 2) { // cout de token
          for (const serie of this.options.series) {
            for (const index in serie.data) {
              serie.data[index] = Number(serie.data[index].toFixed(3))
            }
          }
        }
      }
      // for (const index in this.options.series[0].data) {
      //   this.options.series[0].data[index] = this.options.series[0].data[index].toFixed(3)
      // }
      // console.log(' this.options.series[0].data', this.options.series[0].data)
      // calcule le total des tokens utilisés
      this.responseToken[0].tokensPrompt = tokensPrompt
      this.responseToken[1].tokensCompletion = tokensCompletion
      this.responseToken[2].tokensTotal = tokensPrompt + tokensCompletion
      // type de graphique en fonction du nombre de jour de l'intervalle
      if (this.$parent.nbDays === 1 || this.interval.value !== 1) {
        this.options.series[0].type = 'column'
        this.options.series[1].type = 'column'
      } else {
        this.options.series[0].type = 'area'
        this.options.series[1].type = 'area'
      }
      this.timestampStartPicker
      // console.log('days', days)
    },
    initPeriod () {
      // periode // 0 = personnalisée, 1 = hier, 2 = Cette semaine etc.
      this.period = _.isNil(this.$store.state._Stats.period) ? 1 : this.$store.state._Stats.period
      this.initDates()
    },
    initDates () {
      // récupère les dates qui sont dans le store si la période n'est pas personnalisée
      let periodPerso = (this.period === 0)
      if (periodPerso) {
        // date de fin
        // par défaut la date de fin est la date du jour
        this.dateEndPicker = _.isEmpty(this.$store.state._Stats.dateEnd)
        ? new Date(moment().startOf('day'))
        : new Date(this.$store.state._Stats.dateEnd)
        // date de début
        // par défaut la date de début est une semaine avant la date du jour
        this.dateStartPicker = _.isEmpty(this.$store.state._Stats.dateEnd)
        ? new Date(moment().subtract(1, 'week'))
        : new Date(this.$store.state._Stats.dateStart)
      } else {
        this.dateEndPicker = new Date(moment())
        switch (this.period) {
          case 1: // Hier
            this.dateStartPicker = new Date(moment().subtract(1, 'day'))
            this.dateEndPicker = new Date(moment().subtract(1, 'day'))
            break
          case 2: // Cette semaine
            this.dateStartPicker = new Date(moment().startOf('week'))
            this.dateEndPicker = new Date(moment().subtract(0, 'day'))
            break
          case 3: // Ce mois-ci
            this.dateStartPicker = new Date(moment().startOf('month'))
            this.dateEndPicker = new Date(moment().subtract(0, 'day'))
            break
          case 4: // 7 derniers jours
            this.dateStartPicker = new Date(moment().subtract(7, 'day'))
            this.dateEndPicker = new Date(moment().subtract(1, 'day'))
            break
          case 5: // 30 derniers jours
            this.dateStartPicker = new Date(moment().subtract(30, 'day'))
            this.dateEndPicker = new Date(moment().subtract(1, 'day'))
            break
          case 6: // la semaine dernière
            this.dateStartPicker = new Date(moment().startOf('week').subtract(1, 'week'))
            this.dateEndPicker = new Date(moment().startOf('week').subtract(1, 'day'))
            break
          default:
            this.initPeriod()
        }
      }
      // Formatage et Parsing des dates
      this.dateStartDisplayed = this.formatDate(this.dateStartPicker)
      this.dateStartPicker = this.parseDate(this.dateStartDisplayed)
      this.timestampStart = this.formatTimestampDate(this.dateStartPicker)
      this.dateEndDisplayed = this.formatDate(this.dateEndPicker)
      this.dateEndPicker = this.parseDate(this.dateEndDisplayed)
      this.timestampEnd = this.formatTimestampDate(this.dateEndPicker)
    },
    formatTimestampDate (date) {
      // console.log('date', date)
      return !date
        ? 'Aucune date'
        : moment(date, 'YYYY[-]MM[-]DD').valueOf()
    },
    formatDate (date) {
      return !date
        ? 'Aucune date'
        : moment(date, 'YYYY[-]MM[-]DD').format('ddd LL')
    },
    parseDate (date) {
      let formatOfDate = moment(date, 'ddd LL').format('ddd LL') === date
        ? 'ddd LL'
        : 'YYYY[-]MM[-]DD'
      return !date || !moment(date, formatOfDate).isValid()
        ? null
        : moment(date, formatOfDate).format('YYYY[-]MM[-]DD')
    },

    // charge le prompt du bot
    getPrompt (userid, licKey) {
      let licencekey = this.$store.state._Sites.siteSelected.LIC_KEY
      if (licKey) {
        licencekey = licKey
      }
      this.loadingPrompt = true
      this.axios.get('get/openAI_prompt.php?userID=' + userid + '&sitekey=' + licencekey)
      .then(response => {
        this.analyseChat = response.data.analyseChat ? JSON.parse(response.data.analyseChat) : this.analyseChat
        this.analyseChatRef = response.data.analyseChat ? JSON.parse(response.data.analyseChat) : this.analyseChat
        this.sliderSearchResponse = response.data.sliderSearchResponse ? response.data.sliderSearchResponse : this.sliderSearchResponse
        this.sliderSearchResponseRef = response.data.sliderSearchResponse ? response.data.sliderSearchResponse : this.sliderSearchResponse
        this.sliderTemp = response.data.sliderTemp ? response.data.sliderTemp : this.sliderTemp
        this.sliderTempRef = response.data.sliderTemp ? response.data.sliderTemp : this.sliderTemp
        this.sliderTokenResponse = response.data.sliderTokenResponse ? response.data.sliderTokenResponse : this.sliderTokenResponse
        this.sliderTokenResponseRef = response.data.sliderTokenResponse ? response.data.sliderTokenResponse : this.sliderTokenResponse
        this.prompt = response.data.prompt ? response.data.prompt : this.prompt
        this.prompt_personality = response.data.prompt_personality ? response.data.prompt_personality : this.prompt_personality
        this.prompt_environment = response.data.prompt_environment ? response.data.prompt_environment : this.prompt_environment
        this.prompt_objectif = response.data.prompt_objectif ? response.data.prompt_objectif : this.prompt_objectif
        this.prompt_communication = response.data.prompt_communication ? response.data.prompt_communication : this.prompt_communication
        this.prompt_questions = response.data.prompt_questions ? response.data.prompt_questions : this.prompt_questions
        this.prompt_rules = response.data.prompt_rules ? response.data.prompt_rules : this.prompt_rules
        this.prompt_tools = response.data.prompt_tools ? response.data.prompt_tools : this.prompt_tools
        this.prompt_custom = response.data.prompt_custom ? response.data.prompt_custom : this.prompt_custom
        this.prompt_name = typeof response.data.prompt_name === 'string' ? response.data.prompt_name : this.prompt_name
        this.promptRef = response.data.prompt ? response.data.prompt : this.prompt
        this.prompt_personalityRef = response.data.prompt_personality ? response.data.prompt_personality : this.prompt_personality
        this.prompt_environmentRef = response.data.prompt_environment ? response.data.prompt_environment : this.prompt_environment
        this.prompt_objectifRef = response.data.prompt_objectif ? response.data.prompt_objectif : this.prompt_objectif
        this.prompt_communicationRef = response.data.prompt_communication ? response.data.prompt_communication : this.prompt_communication
        this.prompt_questionsRef = response.data.prompt_questions ? response.data.prompt_questions : this.prompt_questions
        this.prompt_rulesRef = response.data.prompt_rules ? response.data.prompt_rules : this.prompt_rules
        this.prompt_toolsRef = response.data.prompt_tools ? response.data.prompt_tools : this.prompt_tools
        this.prompt_customRef = response.data.prompt_custom ? response.data.prompt_custom : this.prompt_custom
        this.prompt_nameRef = typeof response.data.prompt_name === 'string' ? response.data.prompt_name : this.prompt_nameRef
        this.promptSearch = response.data.promptSearch ? response.data.promptSearch : this.promptSearch
        this.promptSearchRef = response.data.promptSearch ? response.data.promptSearch : this.promptSearch
        this.productSelectAuto = response.data.productSelectAuto
        this.productSelectAutoRef = response.data.productSelectAuto

        if (this.prompt !== '' && this.prompt_personality === '' && this.prompt_environment === '' && this.prompt_objectif === '' && this.prompt_communication === '' && this.prompt_questions === '' && this.prompt_rules === '' && this.prompt_tools === '' && this.prompt_custom === '') {
          this.prompt_custom = this.prompt
        }
        if (response.data.productSelectAuto === 'true') {
          this.productSelectAuto = true
          this.productSelectAutoRef = true
        } else {
          this.productSelectAuto = false
          this.productSelectAutoRef = false
        }

        this.promptResume = response.data.promptResume ? response.data.promptResume : this.promptResume
        this.promptResumeRef = response.data.promptResume ? response.data.promptResume : this.promptResume
        this.functionCall = response.data.functionCall ? response.data.functionCall : this.functionCall
        this.functionCallOnOff = response.data.functionCallOnOff ? response.data.functionCallOnOff : this.functionCallOnOff
        this.functionCallOnOffRef = _.cloneDeep(response.data.functionCallOnOff ? response.data.functionCallOnOff : this.functionCallOnOff)
        // this.functionCallRef = response.data.functionCall ? response.data.functionCall : this.functionCall
        this.parsingSelectif = JSON.parse(response.data.parsingSelectif).length ? JSON.parse(response.data.parsingSelectif) : this.parsingSelectif
        this.parsingSelectifRef = _.cloneDeep(response.data.parsingSelectif.length ? JSON.parse(response.data.parsingSelectif) : this.parsingSelectif)
        this.dialog = response.data.dialog
        this.dialogRef = response.data.dialog
        // this.parseElement = response.data.parseElement
        // this.parseElementRef = response.data.parseElement
        this.messageAccueil = response.data.messageAccueil
        this.messageAccueilRef = response.data.messageAccueil
        this.questionAuto1 = response.data.questionAuto1
        this.questionAuto2 = response.data.questionAuto2
        this.questionAuto3 = response.data.questionAuto3
        this.questionAuto4 = response.data.questionAuto4
        this.comportment = response.data.comportment
        this.showEx = response.data.showEx
        this.questionAuto1Ref = response.data.questionAuto1
        this.questionAuto2Ref = response.data.questionAuto2
        this.questionAuto3Ref = response.data.questionAuto3

        this.questionAuto4Ref = response.data.questionAuto4
        this.parseUrl = response.data.parseUrl
        this.parseUrlRef = response.data.parseUrl
        // this.methodSelect = response.data.methodSelect
        // this.methodSelectRef = response.data.methodSelect
        this.APISelect = {name: response.data.APISelect}
        this.APISelectRef = {name: response.data.APISelect}
        this.modelSelect = {name: response.data.modelSelect, tokens: response.data.modelTokens}
        this.modelSelectRef = {name: response.data.modelSelect, tokens: response.data.modelTokens}
        this.botStream = response.data.botStream
        this.botStreamRef = response.data.botStream
        this.pageScanne = response.data.pageScanne
        this.pageScanneRef = response.data.pageScanne
        this.timeSelected = response.data.timeSelected
        this.timeSelectedRef = response.data.timeSelected
        if (response.data.botStream === 'true') {
          this.botStream = true
          this.botStreamRef = true
        } else {
          this.botStream = false
          this.botStreamRef = false
        }
        if (response.data.majCronTab === 'true') {
          this.majCronTab = true
          this.majCronTabRef = true
        } else {
          this.majCronTab = false
          this.majCronTabRef = false
        }
        if (response.data.majUrlAuto === 'true') {
          this.majUrlAuto = true
          this.majUrlAutoRef = true
        } else {
          this.majUrlAuto = false
          this.majUrlAutoRef = false
        }
        // if (response.data.majCronTabPage === 'true') {
        //   this.majCronTabPage = true
        //   this.majCronTabPageRef = true
        // } else {
        //   this.majCronTabPage = false
        //   this.majCronTabPageRef = false
        // }
        // if (response.data.majUrlAutoPage === 'true') {
          // this.majUrlAutoPage = true
          // this.majUrlAutoPageRef = true
        // } else {
          // this.majUrlAutoPage = false
          // this.majUrlAutoPageRef = false
        // }
      })
      .catch(_ => {})
      .then(_ => {
        this.loadingPrompt = false
      })
    },

    // ajoute une tache cron
    async addMAJ () {
      console.log('sauvegarde MAJ auto :')
      // calcule le temps en seconde
      if (this.timeSelected === 3) {
        // annuel
        this.MajTTL = 31536000
      } else if (this.timeSelected === 2) {
        // mensuel
        this.MajTTL = 2592000
      } else if (this.timeSelected === 1) {
        // hebdomadaire
        this.MajTTL = 604800
      } else {
        // quotidien
        this.MajTTL = 86400
      }
      // si il y a une page alors page de scane sitemap.xml
      if (this.pageScanne) {
        this.MajSitemap = false
      } else {
        this.MajSitemap = true
      }
      return new Promise(async (resolve, reject) => {
        let dataToPost = {}
        dataToPost.licence = this.siteSelected.LIC_KEY
        dataToPost.site = this.parseUrl
        dataToPost.parsingSelectif = this.parsingSelectif
        dataToPost.auto = this.majUrlAuto
        dataToPost.promptResume = this.promptResume
        dataToPost.page = this.pageScanne
        dataToPost.ttl = this.MajTTL
        dataToPost.id = Date.now()
        dataToPost.sitemap = this.MajSitemap
        const response = await this.axios.post(this.serveurAI + 'addMAJ',
        dataToPost,
          {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
        )
        // console.log('getLicenceUrls retour', response.data)
        if (response.data.retour) {
          resolve({'retour': 1, 'info': response.data.info})
          console.log('Création de la tache cron : ', response.data.info)
        } else {
          reject({'retour': 0, 'info': 'erreur maj'})
          console.log('Erreur de création de la tache cron : ')
        }
      })
    },

    // efface une tache cron
    async delMAJ () {
      console.log('delMAJ ')
      return new Promise(async (resolve, reject) => {
        console.log('delMAJ resolve', resolve)
        let dataToPost = {}
        dataToPost.licence = this.siteSelected.LIC_KEY
        const response = await this.axios.post(this.serveurAI + 'delMAJ',
        dataToPost,
          {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
        )
        console.log('delMAJ response.data', response)
        if (response.data.retour) {
          resolve({'retour': 1, 'info': response.data.info})
          console.log('Suppression de la tache cron : ', response.data.info)
        } else {
          reject({'retour': 0, 'info': 'erreur maj'})
          console.log('Erreur de création de la tache cron : ')
        }
      })
    },

    // // ajoute une tache cron
    // async addCron (callback) {
    //   this.promptResume = String(this.promptResume)
    //   console.log('this.promptResume  : ', this.promptResume)
    //   const phrases = this.promptResume.split(/[\r\n]+/)
    //   // console.log('phrases  : ', phrases[0])
    //   var newParseElements = this.parseElement
    //   var newResumePrompt = phrases.join(' ')
    //   // console.log('newResumePrompt 1 : ', newResumePrompt)
    //   // var newResumePrompt = this.promptResume.replaceAll(exReg, 'toto')
    //   // var newResumePrompt = this.promptResume.replace(reg, ' ')
    //   // console.log('parseElement 2 : ', newParseElements)
    //   // il faut retirer les saut de ligne dans le promptResume sinon cela provoque une erreur da requete
    //   // console.log('add cron resumePrompt : ', newResumePrompt)
    //   let dataToPost = {}
    //   dataToPost.licence = this.siteSelected.LIC_KEY
    //   dataToPost.site = this.parseUrl
    //   dataToPost.method = this.methodSelect
    //   dataToPost.parse = newParseElements
    //   dataToPost.majAuto = this.majUrlAuto
    //   dataToPost.promptResume = newResumePrompt
    //   const response = await this.axios.post(this.serveurAI + 'addCronJob',
    //   dataToPost,
    //     {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
    //   )
    //   // console.log('getLicenceUrls retour', response.data)
    //   if (response.data.retour) {
    //     callback({'retour': 1, 'info': response.data.info})
    //     // console.log('Création de la tache cron : ', response.data.info)
    //   } else {
    //     callback({'retour': 0, 'info': response.data.info})
    //     // console.log('Erreur de création de la tache cron : ', response.data.info)
    //   }
    // },
    // efface une tache cron
    // async delCron (callback) {
    //   let dataToPost = {}
    //   dataToPost.licence = this.siteSelected.LIC_KEY
    //   const response = await this.axios.post(this.serveurAI + 'deleteCronJob',
    //   dataToPost,
    //     {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
    //   )
    //   // console.log('getLicenceUrls retour', response.data)
    //   if (response.data.retour) {
    //     this.infoCron = response.data.info
    //     callback({'retour': 1, 'info': response.data.info})
    //     // console.log('Suppression de la tache cron : ', response.data.info)
    //   } else {
    //     this.infoCron = response.data.info
    //     callback({'retour': 0, 'info': response.data.info})
    //     // console.log('Erreur de suppression de la tache cron : ', response.data.info)
    //   }
    // },

    // // ajoute une tache cron scanne page
    // async addCronPage (callback) {
    //   // console.log('addCronPage')
    //   this.promptResume = String(this.promptResume)
    //   // console.log('this.promptResume  : ', this.promptResume)
    //   const phrases = this.promptResume.split(/[\r\n]+/)
    //   // console.log('phrases  : ', phrases[0])
    //   var newParseElements = this.parseElement
    //   var newResumePrompt = phrases.join(' ')
    //   // console.log('newResumePrompt 1 : ', newResumePrompt)
    //   // var newResumePrompt = this.promptResume.replaceAll(exReg, 'toto')
    //   // var newResumePrompt = this.promptResume.replace(reg, ' ')
    //   newResumePrompt = newResumePrompt.replaceAll('#', '::43::') // le caractere # ne passe pas en wget
    //   // newResumePrompt = newResumePrompt.replaceAll(',', '%2C')
    //   // newResumePrompt = newResumePrompt.replaceAll(' ', '%20')
    //   // console.log('parseElement 2 : ', newParseElements)
    //   newParseElements = newParseElements.replaceAll('#', '::43::') // le caractere # ne passe pas en wget
    //   // newParseElements = newParseElements.replaceAll(',', '%2C')
    //   // newParseElements = newParseElements.replaceAll(' ', '%20')
    //   // il faut retirer les saut de ligne dans le promptResume sinon cela provoque une erreur da requete
    //   // console.log('add cron resumePrompt : ', newResumePrompt)
    //   let dataToPost = {}
    //   dataToPost.page = this.pageScanne
    //   dataToPost.licence = this.siteSelected.LIC_KEY
    //   dataToPost.site = this.parseUrl
    //   dataToPost.method = this.methodSelect
    //   dataToPost.parse = newParseElements
    //   dataToPost.majAuto = this.majUrlAutoPage
    //   dataToPost.promptResume = newResumePrompt
    //   const response = await this.axios.post(this.serveurAI + 'addCronJob',
    //   dataToPost,
    //     {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
    //   )
    //   // console.log('getLicenceUrls retour', response.data)
    //   if (response.data.retour) {
    //     callback({'retour': 1, 'info': response.data.info})
    //     // console.log('Création de la tache cron : ', response.data.info)
    //   } else {
    //     callback({'retour': 0, 'info': response.data.info})
    //     // console.log('Erreur de création de la tache cron : ', response.data.info)
    //   }
    // },
    // efface une tache cron scanne page
    // async delCronPage (callback) {
    //   // console.log('delCronPage')
    //   let dataToPost = {}
    //   dataToPost.page = true
    //   dataToPost.licence = this.siteSelected.LIC_KEY
    //   const response = await this.axios.post(this.serveurAI + 'deleteCronJob',
    //   dataToPost,
    //     {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
    //   )
    //   // console.log('getLicenceUrls retour', response.data)
    //   if (response.data.retour) {
    //     this.infoCron = response.data.info
    //     callback({'retour': 1, 'info': response.data.info})
    //     // console.log('Suppression de la tache cron : ', response.data.info)
    //   } else {
    //     this.infoCron = response.data.info
    //     callback({'retour': 0, 'info': response.data.info})
    //     // console.log('Erreur de suppression de la tache cron : ', response.data.info)
    //   }
    // },

    // teste le prompte de resumé sur la premiere url de la liste
    async testPromptResume () {
      // console.log('test prompt resume : ', this.selectedUrl)
      this.loadingResumePrompt = true
      var nameReq = 'test-resume'
      // Données modifiées et à renvoyer
      let dataToPost = {}
      dataToPost.licence = this.siteSelected.LIC_KEY
      dataToPost.listeUrls = [{url: this.selectedUrl}]
      dataToPost.parsingSelectif = this.parsingSelectif
      dataToPost.method = this.methodSelect
      dataToPost.parse = this.parseElement
      dataToPost.promptResume = this.promptResume
      // dataToPost.prefix = prefix
      const response = await this.axios.post(this.serveurAI + nameReq,
      dataToPost,
        {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
      )
      // console.log('test-resume response : ', response)
      if (response.data.retour) {
        this.contentResume = response.data.data
        this.contentResumeKeys = JSON.stringify(response.data.keys, null, '\t')
        this.loadingResumePrompt = false
      } else {
        this.contentResume = response.data.info
        this.contentResumeKeys = ''
        this.loadingResumePrompt = false
      }
    },

    // teste le prompte de resumé sur des produits api
    async testPromptResumeAPI () {
      this.loadingResumePromptAPI = true
      var nameReq = 'test-resume-api'
      // Données modifiées et à renvoyer
      let dataToPost = {}
      dataToPost.licence = this.siteSelected.LIC_KEY
      dataToPost.listeUrls = [{url: this.selectedProduct}]
      dataToPost.parsingSelectif = this.parsingSelectif
      dataToPost.method = this.methodSelect
      dataToPost.parse = this.parseElement
      dataToPost.promptResume = this.promptResume
      const response = await this.axios.post(this.serveurAI + nameReq,
      dataToPost,
        {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
      )
      // console.log('test-resume response : ', response)
      if (response.data.retour) {
        this.contentResume = response.data.data
        this.contentResumeKeys = JSON.stringify(response.data.keys, null, '\t')
        this.loadingResumePromptAPI = false
      } else {
        this.contentResume = response.data.info
        this.contentResumeKeys = ''
        this.loadingResumePromptAPI = false
      }
    },

    // enregidstrer le prompt du bot
    async savePrompt () {
      // console.log('this.function3', this.function3)
      // preparation des fonctionCall
      var newFunctionCall = []
      // console.log('function0', this.function0)
      if (this.function0 !== '') {
        newFunctionCall.push(JSON.parse(this.function0))
      }
      if (this.function1 !== '') {
        newFunctionCall.push(JSON.parse(this.function1))
      }
      if (this.function2 !== '') {
        newFunctionCall.push(JSON.parse(this.function2))
      }
      if (this.function3 !== '') {
        newFunctionCall.push(JSON.parse(this.function3))
      }
      if (this.function4 !== '') {
        newFunctionCall.push(JSON.parse(this.function4))
      }
      if (this.function5 !== '') {
        newFunctionCall.push(JSON.parse(this.function5))
      }
      if (this.function6 !== '') {
        newFunctionCall.push(JSON.parse(this.function6))
      }
      if (this.function7 !== '') {
        newFunctionCall.push(JSON.parse(this.function7))
      }
      if (this.function8 !== '') {
        newFunctionCall.push(JSON.parse(this.function8))
      }

      // const reg = /(\r\n|\t|\n|\r)/gm // efface les tabulation et retour à la ligne
      // newFunctionCall = JSON.stringify(newFunctionCall)
      // newFunctionCall = String(newFunctionCall.replace(reg, '  '))
      // console.log('newFunctionCall 1 : ', newFunctionCall)

      // console.log('newFunctionCall : ', newFunctionCall)
      if (!newFunctionCall) {
        newFunctionCall = []
      }
      this.functionCall = JSON.stringify(newFunctionCall)
      // console.log('this.Parsings : ', JSON.stringify(this.Parsings))
      // Données modifiées et à renvoyer
      let dataToPost = new window.FormData()
      dataToPost.append('LIC_ID', this.siteSelected.LIC_ID)
      dataToPost.append('LIC_KEY', this.siteSelected.LIC_KEY)
      dataToPost.append('ENT_ID', this.user.entId)
      dataToPost.append('userID', this.botUserId)
      dataToPost.append('userJob', this.userJob)
      dataToPost.append('userName', this.userName)
      dataToPost.append('prompt', this.prompt)
      dataToPost.append('prompt_personality', this.prompt_personality)
      dataToPost.append('prompt_environment', this.prompt_environment)
      dataToPost.append('prompt_objectif', this.prompt_objectif)
      dataToPost.append('prompt_communication', this.prompt_communication)
      dataToPost.append('prompt_questions', this.prompt_questions)
      dataToPost.append('prompt_rules', this.prompt_rules)
      dataToPost.append('prompt_tools', this.prompt_tools)
      dataToPost.append('prompt_custom', this.prompt_custom)
      dataToPost.append('prompt_name', this.prompt_name)
      dataToPost.append('promptSearch', this.promptSearch)
      dataToPost.append('productSelectAuto', this.productSelectAuto)
      dataToPost.append('promptResume', this.promptResume)
      dataToPost.append('functionCall', this.functionCall)
      dataToPost.append('functionCallOnOff', JSON.stringify(this.functionCallOnOff))
      dataToPost.append('parsingSelectif', JSON.stringify(this.parsingSelectif))
      dataToPost.append('dialog', this.dialog)
      dataToPost.append('parseUrl', this.parseUrl)
      dataToPost.append('messageAccueil', this.messageAccueil)
      dataToPost.append('questionAuto1', this.questionAuto1)
      dataToPost.append('questionAuto2', this.questionAuto2)
      dataToPost.append('questionAuto3', this.questionAuto3)
      dataToPost.append('questionAuto4', this.questionAuto4)
      dataToPost.append('comportment', this.comportment ? 1 : 0)
      dataToPost.append('showEx', this.showEx ? 1 : 0)
      dataToPost.append('parseElement', this.parseElement)
      dataToPost.append('methodSelect', this.methodSelect)
      dataToPost.append('APISelect', this.APISelect.name)
      dataToPost.append('modelSelect', this.modelSelect.name)
      dataToPost.append('modelTokens', this.modelSelect.tokens)
      dataToPost.append('sliderSearchResponse', this.sliderSearchResponse)
      dataToPost.append('sliderTokenResponse', this.sliderTokenResponse)
      dataToPost.append('sliderTemp', this.sliderTemp)
      dataToPost.append('analyseChat', JSON.stringify(this.analyseChat))
      dataToPost.append('botStream', this.botStream)
      dataToPost.append('pageScanne', this.pageScanne)
      dataToPost.append('majCronTab', this.majCronTab)
      dataToPost.append('majUrlAuto', this.majUrlAuto)
      // dataToPost.append('majCronTabPage', this.majCronTabPage)
      // dataToPost.append('majUrlAutoPage', this.majUrlAutoPage)
      dataToPost.append('whoDidThis', this.$store.state._User.id)
      dataToPost.append('timeSelected', this.timeSelected)

      this.loadingSavePrompt = true
      this.axios.post('post/openAI_prompt.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      .then(async (response) => {
        // console.log('response : ', response.data)
        // changement de crontab sitemap.xml
        // if (this.majCronTabRef !== this.majCronTab) {
        if (this.majCronTab) {
          // enregistrer dsans redis tourtes les données de sauvegarde auto
          await this.addMAJ()
          .then(async (result) => {
            if (result.retour) {
              console.log('addMAJ result :', result.retour)
              this.statusSaveCron = result.retour
              this.infoCron = 'Création de la crontab'
              // console.log('création de la crontab')
              this.majCronTabRef = this.majCronTab
              this.majUrlAutoRef = this.majUrlAuto
              this.timeSelectedRef = this.timeSelected
              this.functionCallOnOffRef = _.cloneDeep(this.functionCallOnOff)
              // this.parseElementRef = this.parseElement
              this.parseUrlRef = this.parseUrl
            } else {
              this.statusSaveCron = result.retour
              this.infoCron = 'Probleme de création de la tache cron : ' + result.info
              // console.log('Probleme de création de la tache cron : ', response.info)
            }
          })
          .catch((reject) => {
            console.log('addMAJ reject :', reject)
            console.log('Plus de sauvegarde MAJ auto :', reject)
          })
        } else {
          // efface de redis les infos de mise à jour auto
          console.log('Plus de sauvegarde MAJ auto :')
          await this.delMAJ()
          .then(async (result) => {
            if (result.retour) {
              console.log('delMAJ result :', result.retour)
              this.statusSaveCron = result.retour
              this.infoCron = 'suppression de la crontab'
              // console.log('création de la crontab')
              this.majCronTabRef = this.majCronTab
              this.majUrlAutoRef = this.majUrlAuto
              this.timeSelectedRef = this.timeSelected
              this.functionCallOnOffRef = _.cloneDeep(this.functionCallOnOff)
              // this.methodSelectRef = this.methodSelect
              // this.parseElementRef = this.parseElement
              this.parseUrlRef = this.parseUrl
            } else {
              this.statusSaveCron = result.retour
              this.infoCron = 'Probleme de suppression de la tache cron : ' + result.info
              // console.log('Probleme de création de la tache cron : ', response.info)
            }
          })
          .catch((reject) => {
            console.log('delMAJ reject :', reject)
            console.log('Plus de sauvegarde MAJ auto :', reject)
          })
        }
        // pas de changement
        // } else {
          // // mais changement de la mise à jour automatique
          // // ou changement dans la method de parsage du site
          // if (
          //   this.majUrlAutoRef !== this.majUrlAuto ||
          //   // this.methodSelectRef !== this.methodSelect ||
          //   // this.parseElementRef !== this.parseElement ||
          //   this.parseUrlRef !== this.parseUrl ||
          //   this.promptResumeRef !== this.promptResume
          // ) {
          //   // si il y a une crontab enregistrée
          //   if (this.majCronTab) {
          //     this.addCron(async (response) => {
          //       this.afficheStatusCron = true
          //       // console.log('response', response)
          //       if (response.retour) {
          //         this.statusSaveCron = response.retour
          //         this.infoCron = 'Modification de la crontab'
          //         // console.log('création de la crontab')
          //         this.majCronTabRef = this.majCronTab
          //         this.majUrlAutoRef = this.majUrlAuto
          //         // this.methodSelectRef = this.methodSelect
          //         // this.parseElementRef = this.parseElement
          //         this.parseUrlRef = this.parseUrl
          //       } else {
          //         this.statusSaveCron = response.retour
          //         this.infoCron = 'Probleme de création de la tache cron : ' + response.info
          //         // console.log('Probleme de création de la tache cron : ', response.info)
          //       }
          //     })
          //   }
          // }
        // }

        // changement de crontab scanne page
        // if (this.majCronTabPageRef !== this.majCronTabPage) {
        //   if (this.majCronTabPage) {
        //     this.addCronPage(async (response) => {
        //       this.afficheStatusCronPage = true
        //       // console.log('response', response)
        //       if (response.retour) {
        //         this.statusSaveCronPage = response.retour
        //         this.infoCronPage = 'Création de la crontab scanne page'
        //         // console.log('création de la crontab')
        //         this.majCronTabPageRef = this.majCronTabPage
        //         this.majUrlAutoPageRef = this.majUrlAutoPage
        //         // this.methodSelectRef = this.methodSelect
        //         // this.parseElementRef = this.parseElement
        //         this.parseUrlRef = this.parseUrl
        //       } else {
        //         this.statusSaveCronPage = response.retour
        //         this.infoCronPage = 'Probleme de création de la tache cron scanne page : ' + response.info
        //         // console.log('Probleme de création de la tache cron : ', response.info)
        //       }
        //     })
        //   } else {
        //     this.delCronPage(async (response) => {
        //       this.afficheStatusCronPage = true
        //       // console.log('response', response)
        //       if (response.retour) {
        //         this.statusSaveCronPage = response.retour
        //         this.infoCronPage = 'Suppression de la crontab scanne page'
        //         // console.log('suppression de la crontab')
        //         this.majCronTabPageRef = this.majCronTabPage
        //         this.majUrlAutoPageRef = this.majUrlAutoPage
        //         // this.methodSelectRef = this.methodSelect
        //         // this.parseElementRef = this.parseElement
        //         this.parseUrlRef = this.parseUrl
        //       } else {
        //         this.statusSaveCronPage = response.retour
        //         this.infoCronPage = 'Probleme de suppression de la tache cron scanne page : ' + response.info
        //         // console.log('Probleme de suppression de la tache cron : ', response.info)
        //       }
        //     })
        //   }
        // // pas de changement
        // } else {
        //   // mais changement de la mise à jour automatique
        //   // ou changement dans la method de parsage du site
        //   if (
        //     this.majUrlAutoPageRef !== this.majUrlAutoPage ||
        //     // this.methodSelectRef !== this.methodSelect ||
        //     // this.parseElementRef !== this.parseElement ||
        //     this.parseUrlRef !== this.parseUrl ||
        //     this.promptResumeRef !== this.promptResume
        //   ) {
        //     // si il y a une crontab enregistrée
        //     if (this.majCronTabPage) {
        //       this.addCronPage(async (response) => {
        //         this.afficheStatusCronPage = true
        //         // console.log('response', response)
        //         if (response.retour) {
        //           this.statusSaveCronPage = response.retour
        //           this.infoCronPage = 'Modification de la crontab scanne page'
        //           // console.log('création de la crontab')
        //           this.majCronTabPageRef = this.majCronTabPage
        //           this.majUrlAutoPageRef = this.majUrlAutoPage
        //           // this.methodSelectRef = this.methodSelect
        //           // this.parseElementRef = this.parseElement
        //           this.parseUrlRef = this.parseUrl
        //         } else {
        //           this.statusSaveCronPage = response.retour
        //           this.infoCronPage = 'Probleme de création de la tache cron scanne page : ' + response.info
        //           // console.log('Probleme de création de la tache cron : ', response.info)
        //         }
        //       })
        //     }
        //   }
        // }

        this.loadingSavePrompt = false
        if (this.loadingModifAnalyseChat) {
          this.loadingModifAnalyseChat = false
          this.showDialogDeleteAnalyseChat = false
        }
        // mise a jour des données de reference
        this.promptRef = this.prompt
        this.prompt_personalityRef = this.prompt_personality
        this.prompt_environmentRef = this.prompt_environment
        this.prompt_objectifRef = this.prompt_objectif
        this.prompt_communicationRef = this.prompt_communication
        this.prompt_questionsRef = this.prompt_questions
        this.prompt_rulesRef = this.prompt_rules
        this.prompt_toolsRef = this.prompt_tools
        this.prompt_customRef = this.prompt_custom
        this.prompt_nameRef = this.prompt_name

        this.promptSearchRef = this.promptSearch
        this.productSelectAutoRef = this.productSelectAuto
        this.promptResumeRef = this.promptResume
        // this.functionCallRef = this.functionCall
        this.messageAccueilRef = this.messageAccueil
        this.questionAuto1Ref = this.questionAuto1
        this.questionAuto2Ref = this.questionAuto2
        this.questionAuto3Ref = this.questionAuto3
        this.questionAuto4Ref = this.questionAuto4
        this.sliderSearchResponseRef = this.sliderSearchResponse
        this.sliderTokenResponseRef = this.sliderTokenResponse
        this.sliderTempRef = this.sliderTemp
        this.sliderTempRef = this.sliderTemp
        this.botStreamRef = this.botStream
        this.pageScanneRef = this.pageScanne
        this.analyseChatRef = this.analyseChat
      })
      .catch((error) => {
        console.log('error enregistrement : ', error)
        this.loadingSavePrompt = false
        if (this.loadingModifAnalyseChat) {
          this.loadingModifAnalyseChat = false
          this.showDialogDeleteAnalyseChat = false
        }
      })
    },

    // affiche la dialogBox import PDF
    importFile () {
      // console.log('import file')
      this.showDialogImportPDF = true
    },
    // ouvre le dialogue pour voir les segments du fichier
    async openDialogChunkFile (data) {
      // console.log('open dialog chunk file ', data)
      this.showDialogChunkPDF = true
      this.selectedFileChunk = data
    },

    // ouvre le dialogue pour voir le résumé du fichier
    async openDialogFile (data) {
      // console.log('open dialog chunk file ', data)
      this.showDialogResume = true
      this.selectedFileChunk = data
    },

    // ajoute le nouveau fichier PDF dans la liste
    addFile (value) {
      console.log('add file', value)
      // this.files.push(value)
      // recupère la liste des documents du client dans redis
      this.loadFilesClient(this.siteSelected.LIC_KEY)
    },

    // chargement des url du client
    async loadFilesClient (licKey) {
      // console.info('loadFilesClient')
      this.loadingDataFiles = true
      // Données modifiées et à renvoyer
      let dataToPost = {}
      dataToPost.licence = licKey
      const response = await this.axios.post(this.serveurAI + 'getLicenceFiles',
      dataToPost,
        {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
      )
      if (response && response.data.retour) {
        this.loadingDataFiles = false
        // const returnListURL = JSON.parse(response.data.data) // pase le retour
        const listeFile = Object.values(response.data.data) // rend iterable le json
        // for (const index in listeUrl) {
          // this.files.push({'url': listeUrl[index].url})
        // }
        this.files = listeFile
      } else {
        this.loadingDataFiles = false
        // si aucun retour, on vide le tableau des files
        this.files = []
      }
      // this.files.push(response.data.data)
    },

    // chargement des url du client (urls utilisées ou urls supprimées)
    // status des urls est soit "actif" ou "inactif"
    async loadUrlsClient (status) {
      // console.log('licKey', this.siteSelected.LIC_KEY)
      localStorage.setItem('startListUrl', this.rangeSliderUrl[0])
      localStorage.setItem('endListUrl', this.rangeSliderUrl[1])
      // this.rangeSliderUrl[0] = this.startListUrl
      // this.rangeSliderUrl[1] = this.endListUrl
      let licKey = this.siteSelected.LIC_KEY
      if (status === 'inactif') {
        licKey = licKey + '-' + status
      } else if (status.isTrusted) {
        console.log('trusted')
      }
      this.loadingData = true
      this.loadingDataInactif = true
      // Données modifiées et à renvoyer
      let dataToPost = {}
      dataToPost.licence = licKey // la licence client
      dataToPost.status = status // le status des urls
      dataToPost.start = this.rangeSliderUrl[0] // debut de la liste demandée
      dataToPost.end = this.rangeSliderUrl[1] // fin de la liste demandée
      const response = await this.axios.post(this.serveurAI + 'getLicenceUrls',
      dataToPost,
        {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
      )
      if (response.data.retour) {
        // const returnListURL = JSON.parse(response.data.data) // pase le retour
        const listeUrl = Object.values(response.data.data) // rend iterable le json
        // il faut convertire les timestamps en date
        for (const index in listeUrl) {
          if (listeUrl[index].timestamp) {
            listeUrl[index].timestamp = moment(listeUrl[index].timestamp).format('lll')
          }
        }
        if ((response.data.statsus && response.data.status === 'inactif') || status === 'inactif') {
          this.urlsSupp = listeUrl
        } else {
          this.totalUrl = response.data.totalUrl
          this.urls = listeUrl
        }
        this.loadingDataInactif = false
        this.loadingData = false
      } else {
        // si aucun retour, on vide le tableau d'urls
        if (status === 'inactif') {
          this.urlsSupp = []
        } else {
          this.urls = []
        }
        this.loadingDataInactif = false
        this.loadingData = false
      }
    },

    // chargement des API produits du client (produits utilisées ou produits supprimées)
    // status des produits est soit "actif" ou "inactif"
    async loadProductsClient (status) {
      // console.log('licKey', this.siteSelected.LIC_KEY)
      localStorage.setItem('startListProduct', this.rangeSliderProduct[0])
      localStorage.setItem('endListProduct', this.rangeSliderProduct[1])
      let licKey = this.siteSelected.LIC_KEY
      if (status === 'inactif') {
        licKey = licKey + '-' + status
      }
      this.loadingData = true
      this.loadingDataInactif = true
      // Données modifiées et à renvoyer
      let dataToPost = {}
      dataToPost.licence = licKey // la licence client
      dataToPost.status = status // le status des urls
      dataToPost.start = this.rangeSliderProduct[0] // debut de la liste demandée
      dataToPost.end = this.rangeSliderProduct[1] // fin de la liste demandée
      const response = await this.axios.post(this.serveurAI + 'getLicenceProducts',
      dataToPost,
        {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
      )
      if (response.data.retour) {
        console.log('getLicenceProducts-' + status)
        console.log('response.data : ', response.data)
        console.log('response.status : ', response.data.status)
        // const returnListURL = JSON.parse(response.data.data) // pase le retour
        const listeProduct = Object.values(response.data.data) // rend iterable le json
        // il faut convertire les timestamps en date
        for (const index in listeProduct) {
          if (listeProduct[index].timestamp) {
            listeProduct[index].timestamp = moment(listeProduct[index].timestamp).format('lll')
          }
        }
        if ((response.data.statsus && response.data.status === 'inactif') || status === 'inactif') {
          this.totalProductInactif = response.data.totalProduct
          this.productsSupp = listeProduct
        } else {
          this.totalProduct = response.data.totalProduct
          this.products = listeProduct
        }
        this.loadingDataInactif = false
        this.loadingData = false
      } else {
        // si aucun retour, on vide le tableau d'urls
        if (status === 'inactif') {
          this.productsSupp = []
        } else {
          this.products = []
        }
        this.loadingDataInactif = false
        this.loadingData = false
      }
    },

    // chargement des URL produits du client (produits utilisées ou produits supprimées)
    // status des produits est soit "actif" ou "inactif"
    async loadURLProductsClient (status) {
      // console.log('licKey', this.siteSelected.LIC_KEY)
      localStorage.setItem('startListURLProduct', this.rangeSliderURLProduct[0])
      localStorage.setItem('endListURLProduct', this.rangeSliderURLProduct[1])
      let licKey = this.siteSelected.LIC_KEY
      if (status === 'inactif') {
        licKey = licKey + '-' + status
      }
      this.loadingData = true
      this.loadingDataInactif = true
      // Données modifiées et à renvoyer
      let dataToPost = {}
      dataToPost.licence = licKey // la licence client
      dataToPost.status = status // le status des urls
      dataToPost.start = this.rangeSliderURLProduct[0] // debut de la liste demandée
      dataToPost.end = this.rangeSliderURLProduct[1] // fin de la liste demandée
      const response = await this.axios.post(this.serveurAI + 'getLicenceURLProducts',
      dataToPost,
        {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
      )
      if (response.data.retour) {
        console.log('getLicenceURLProducts-' + status)
        console.log('response.data : ', response.data)
        console.log('response.status : ', response.data.status)
        // const returnListURL = JSON.parse(response.data.data) // pase le retour
        const listeURLProduct = Object.values(response.data.data) // rend iterable le json
        // il faut convertire les timestamps en date
        for (const index in listeURLProduct) {
          if (listeURLProduct[index].timestamp) {
            listeURLProduct[index].timestamp = moment(listeURLProduct[index].timestamp).format('lll')
          }
        }
        if ((response.data.statsus && response.data.status === 'inactif') || status === 'inactif') {
          this.totalURLProductInactif = response.data.totalProduct
          this.URLProductsSupp = listeURLProduct
        } else {
          this.totalURLProduct = response.data.totalProduct
          this.URLProducts = listeURLProduct
        }
        this.loadingDataInactif = false
        this.loadingData = false
      } else {
        // si aucun retour, on vide le tableau d'urls
        if (status === 'inactif') {
          this.URLProductsSupp = []
        } else {
          this.URLProducts = []
        }
        this.loadingDataInactif = false
        this.loadingData = false
      }
      // console.log('load URLProducts', this.URLProducts)
    },

    // chargement des faqs du client
    async loadFaqsClient () {
      // console.log('loadFaqsClient')
      this.loadingData = true
      this.loadingDataInactif = true
      this.faqs = [] // remise à zéro du tableau des faq
      // Données modifiées et à renvoyer
      let req = {}
      req.licence = this.siteSelected.LIC_KEY// le fichier dédié au prompt scripté
      let dataToPost = {}
      dataToPost.data = req

      const response = await this.axios.post(this.serveurAI + 'getLicenceFaqs',
      dataToPost,
        {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
      )

      /* let fakereponse = {
        'retour': 1,
        'data': [
          {
            'name': '948580a42a7ace75df2befcdf0ec8a81_faq.faq-0',
            'content': 'Question : exemple en dur\r\nRéponse : réponse en dur aussi\r\n',
            'extrait': 'Question : toto\r\nRéponse : titi\r\n'
          }, {
            'name': '948580a42a7ace75df2befcdf0ec8a81_faq.faq-1',
            'content': 'Question : exemple 2\r\nRéponse : réponse 2\r\n',
            'extrait': 'Question : toto2\r\nRéponse : titi2\r\n'
          }
        ]
      } */

      if (response.data.retour) {
        const listeFaq = Object.values(response.data.data) // rend iterable le json
        // console.log('getLicenceFaqs dataToPost : ', dataToPost)
        for (const idx in listeFaq) {
          let faq = {}
          faq.name = listeFaq[idx].name
          let phrase = listeFaq[idx].content
          let indexDebutQuestion = phrase.indexOf('Question :')
          // Trouver l'index de fin de la question
          let indexFinQuestion = phrase.indexOf('\r\n', indexDebutQuestion + 'Question :'.length)
          // Extraire la partie de la question
          let question = phrase.substring(indexDebutQuestion, indexFinQuestion).trim()
          faq.question = question.replace(/Question :/g, '')
          // Trouver l'index du début de la réponse
          let indexDebutReponse = phrase.indexOf('Réponse :')
          // Trouver l'index de fin de la réponse
          let indexFinReponse = phrase.indexOf('\r\n', indexDebutReponse + 'Réponse :'.length)
          // Extraire la partie de la réponse
          let reponse = phrase.substring(indexDebutReponse, indexFinReponse).trim()
          faq.reponse = reponse.replace(/Réponse :/g, '')
          faq.index = idx
          this.faqs.push(faq)
        }
        this.numFAQ = listeFaq.length
        this.loadingDataInactif = false
        // this.chunks = response.data.data
        // this.loadingData = false
        setTimeout(() => {
          this.loadingData = false
        }, 500)
      }
    },
    // --------------------------------------------------
    // fonction pour checker les nouvelles urls
    // --------------------------------------------------
    async checkUrls () {
      this.showDialogAddUrls = true
    },
    async newFAQ () {
      // console.log('newFAQ')
      this.showDialogModifFAQ = true
      this.addFAQ = true
    },

    /**
     * recupere la liste des url en scannant
     * soit le sitemap.xml ou en parssant la totalité du site web
     * @param {String} methode .crawler-sitemap / crawler-allurl
     */
    async submitCheckUrls (methode, majAuto, page) {
      this.loadingSearchUrl = true
      // console.log('check sitemap site', this.parseUrl)
      let url = this.parseUrl
      // pour tester uniquement ---------------------
      // let url = 'https://immobilier.cushmanwakefield.fr/'
      // --------------------------------------------
      this.loadingCheckSitemap = true
      let dataToPost = {}
      dataToPost.licence = this.siteSelected.LIC_KEY
      if (page) {
        dataToPost.page = page
      }
      dataToPost.site = url
      // console.log('url', url)
      const response = await this.axios.post(this.serveurAI + methode,
      dataToPost,
        {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
      )
      console.log('methode', this.serveurAI + methode)
      console.log('response', response)
      // si retour true, alors toutes les urls modifées doivent passé en update false
      if (response.status !== 404) {
        if (response.data.retour) {
          // console.log('crawler sitemap fin', response.data.data.newUrl)
          const listeNewUrls = Object.values(response.data.data.newUrl) // rend iterable le json
          // le retour est une liste de nouvelle urls trouvées dans le site map
          // donc pas de mot clés pas encore de embeding
          // pour chaque nouvelle url
          for (const newUrl of listeNewUrls) {
            let i = this.urls.findIndex((element) => element.url === newUrl)
            if (i === -1) {
              this.urls.push({
                'url': newUrl,
                'new': true,
                'update': false
              })
            }
          }
          // pour chaque url supprimé
          const listeDelUrls = Object.values(response.data.data.suppUrl) // rend iterable le json
          for (const delUrl of listeDelUrls) {
            let i = this.urls.findIndex((element) => element.url === delUrl)
            if (i !== -1) {
              // console.log('index : ', i)
              this.urls.splice(i, 1)
            }
          }

          // console.log('crawler sitemap fin this.urls', this.urls)
          this.messageResDialog = '<h3>' + this.$t('Résultats de la recherche de nouvelles urls :') + '</h3>'
          this.messageResDialog += '<p>'
          this.messageResDialog += 'Nouvelles urls trouvées : <strong>' + listeNewUrls.length + '</strong><br>'
          this.messageResDialog += 'Urls verrouillées du sitemap: <strong>' + response.data.data.lockUrl.length + '</strong><br>'
          this.messageResDialog += 'Urls actives supprimées du sitemap: <strong>' + response.data.data.suppUrl.length + '</strong><br>'
          this.messageResDialog += '</p>'
          // si il y a une mise à jour automatique des données des nouvelles urls trouvées
          if (majAuto) {
            // console.log('majAuto activée')
            let totalTraitementUrls = 0
            this.messageResDialog += '<div>Traitement des nouvelles urls :<ol>'
            if (listeNewUrls.length) {
              for (const newUrl of listeNewUrls) {
                let dataToPost = {}
                dataToPost.licence = this.siteSelected.LIC_KEY
                dataToPost.listeUrls = [{url: newUrl}]
                dataToPost.method = this.methodSelect
                dataToPost.parsingSelectif = this.parsingSelectif
                dataToPost.model = this.methodSelect
                dataToPost.parse = this.parseElement
                dataToPost.promptResume = this.promptResume
                const response = await this.axios.post(this.serveurAI + 'tokenize-listeUrls',
                dataToPost,
                  {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
                )
                if (response.data.update) {
                  totalTraitementUrls++
                  // si pas d'erreur
                  if (response.data.status) {
                    let i = this.urls.findIndex((element) => element.url === response.data.url)
                    if (i !== -1) {
                      // indicateur de modif ou d'ajout de mots clés pour cette url
                      this.urls[i].updated = true
                      // indicateur que ce n'est plus une nouvelles url car elle a été traitée
                      this.urls[i].new = false
                      // indicateur qu'il n'y a plus d'erreur sur cette url
                      this.urls[i].error = false
                    }
                    this.messageResDialog += '<li class="font-weight-bold font-italic green--text darken-4"> ' + newUrl + '</li>'
                  // si il y a une erreur
                  } else {
                    let i = this.urls.findIndex((element) => element.url === response.data.url)
                    if (i !== -1) {
                      // indicateur d'erreur sur cette url
                      this.urls[i].error = true
                    }
                    this.messageResDialog += '<li class="font-weight-bold font-italic red--text darken-4"> ' + newUrl + '</li>'
                  }
                }
              }
              this.messageResDialog += '</ol></div>'
              // quand le traitement est pas fini
              if (totalTraitementUrls < listeNewUrls.length) {
                this.messageResDialog += '<divtraitement en cours...</div>'
              } else {
                // quand le traitement est terminé il faut lancer le embedding des urls "updated"
                this.messageResDialog += '<div>Enregistrement des nouvelles connaissances</div>'
                // avec un timer pour avoir une transition claire
                setTimeout(() => {
                  this.submitEmbeddingConfirm(async (res) => {
                    if (res.retour) {
                      // fin du traitement, affiche le boutton fermer
                      this.closeDialogUniquement = true
                    }
                  })
                }, '4000')
              }
            }
          } else {
            // fin de la mise à jour de urls, affiche le boutton fermer
            this.closeDialogUniquement = true
            if (listeNewUrls.length) {
              this.messageResDialog += '<div>Liste des nouvelles urls :<ol>'
              for (const newUrl of listeNewUrls) {
                this.messageResDialog += '<li class="font-weight-bold font-italic">' + newUrl + '</li>'
              }
              this.messageResDialog += '</ol></div>'
            }
          }
        } else {
          // console.log('crawler erreur', response.data.info)
          this.messageResDialog = '<h3>' + this.$t('Erreur de recherche :') + '</h3>'
          this.messageResDialog += '<p>'
          this.messageResDialog += 'erreur : <strong>' + response.data.info + '</strong><br>'
          this.messageResDialog += '</p>'
        }
        this.loadingCheckSitemap = false
        this.loadingSearchUrl = false
      } else {
        // console.log('impossible de check le sitemap (404)')
        this.loadingCheckSitemap = false
        this.loadingSearchUrl = false
        this.messageResDialog = '<h3>' + this.$t('Impossible de trouver le sitemap :') + '</h3>'
        this.messageResDialog += '<p>'
        this.messageResDialog += 'erreur : <strong>' + response.data.info + '</strong><br>'
        this.messageResDialog += '</p>'
      }
    },

    // ferme la femetre de versioning du prompt
    submitEnhancePrompt () {
      this.showDialogEnhancePrompt = false
    },
    applyEnhancedPromptSection (field, value) {
      switch (field) {
        case 'personality':
          this.prompt_personality = value
          break
        case 'environment':
          this.prompt_environment = value
          break
        case 'objectif':
          this.prompt_objectif = value
          break
        case 'communication':
          this.prompt_communication = value
          break
        case 'questions':
          this.prompt_questions = value
          break
        case 'rules':
          this.prompt_rules = value
          break
        case 'tools':
          this.prompt_tools = value
          break
        case 'custom':
          this.prompt_custom = value
          break
        default:
          break
      }
    },
    // ferme la femetre de versioning du prompt
    submitVersionPrompt () {
      this.showDialogVersionPrompt = false
    },
    restorePromptSectionFromHistory (field, value) {
      switch (field) {
        case 'personality':
          this.prompt_personality = value
          break
        case 'environment':
          this.prompt_environment = value
          break
        case 'objectif':
          this.prompt_objectif = value
          break
        case 'communication':
          this.prompt_communication = value
          break
        case 'questions':
          this.prompt_questions = value
          break
        case 'rules':
          this.prompt_rules = value
          break
        case 'tools':
          this.prompt_tools = value
          break
        case 'custom':
          this.prompt_custom = value
          break
        default:
          break
      }
    },

    // start l'embedding des uls
    startEmbedding (userid) {
      this.showDialogEmbedding = true
    },

    // start l'embedding des produits
    startEmbeddingAPI (userid) {
      this.showDialogEmbeddingAPI = true
    },
    // start l'embedding des urls produits
    startEmbeddingURLProduct (userid) {
      this.showDialogEmbeddingURLProduct = true
    },
    // lance le embedding des url qui ont "updated" à true
    async submitEmbeddingConfirm (callback) {
      this.loadingEmbeddingUrl = true
      this.loadingRes = true
      this.startLoading = 0
      var totalTraitementUrls = 0
      var totalTraitementOK = 0
      var totalTraitementKO = 0
      var errorListUrls = []
      var newListeEmbedding = []
      // console.log(' this.urls', this.urls)
      // recupere uniquement les url qui on eu les mot clés updatées
      for (const index in this.urls) {
        if (this.urls[index].updated) {
          newListeEmbedding.push(this.urls[index].url)
        }
      }
      this.endLoading = newListeEmbedding.length
      // puiq pour chaque url upadated on execute un demande d'enregistrement embedding en base
      for (const url of newListeEmbedding) {
        console.log(' url ', url)
        let dataToPost = {}
        dataToPost.licence = this.siteSelected.LIC_KEY
        dataToPost.url = [url]
        const response = await this.axios.post(this.serveurAI + 'embedding-url',
        dataToPost,
          {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
        )
        // si retour true, alors toutes les urls modifées doivent passé en update false
        if (response.data.retour) {
          this.startLoading++
          totalTraitementUrls++
          // si pas d'erreur
          if (response.data.url) {
            totalTraitementOK++
            // recherche dans les url pour mettre en updated false si elle existe
            let i = this.urls.findIndex((element) => element.url === response.data.url)
            if (i !== -1) {
              // indicateur de modif ou d'ajout de mots clés pour cette url
              this.urls[i].updated = false
              // indicateur que ce n'est plus une nouvelles url car elle a été traitée
              this.urls[i].new = false
              // indicateur qu'il n'y a plus d'erreur sur cette url
              this.urls[i].error = false
            }
          }
        } else {
          if (response.data.url) {
            totalTraitementKO++
            errorListUrls.push(response.data.url) // push l'url
            let i = this.urls.findIndex((element) => element.url === response.data.url)
            if (i !== -1) {
              // indicateur qu'il n'y a plus d'erreur sur cette url
              this.urls[i].error = true
            }
          // si il y a une erreur
          }
        }

        // this.loadingRes = false
        this.loadingModifUrl = false
        this.closeDialogUniquement = true
        this.messageResDialog = '<p class="loadingNum text-xs-center">' + this.$t('AISaveProc') + ' ' + totalTraitementUrls + '/' + this.endLoading + '</p>'
        this.messageResDialog += '<h3>' + this.$t('AIResData') + '</h3>'
        this.messageResDialog += '<p>'
        this.messageResDialog += this.$t('AIResDataOK') + ' <strong>' + totalTraitementOK + '/' + this.endLoading + '</strong><br>'
        this.messageResDialog += this.$t('AIResDataKO') + ' <strong>' + totalTraitementKO + '/' + this.endLoading + '</strong>'
        this.messageResDialog += '</p>'
        this.messageResDialog += '<div>' + this.$t('AIListKnowKO') + '<ol>'
        for (const url of errorListUrls) {
          this.messageResDialog += '<li class="font-weight-bold font-italic">' + url + '</li>'
        }
        this.messageResDialog += '</ol></div>'
        if (totalTraitementUrls === this.endLoading) {
          // Mise à jour de la liste des urls en erreur
          let dataMAJ = {}
          dataMAJ.licence = this.siteSelected.LIC_KEY
          dataMAJ.selectedUrls = this.selectedUrls
          dataMAJ.errorListUrls = errorListUrls
          this.majErrorListeUrls(dataMAJ)
          callback({retour: 1})
        }
      }
    },

    // lance le embedding des url produits qui ont "updated" à true
    async submitEmbeddingURLProductConfirm (callback) {
      this.loadingEmbeddingUrl = true
      this.loadingRes = true
      this.startLoading = 0
      var totalTraitementUrls = 0
      var totalTraitementOK = 0
      var totalTraitementKO = 0
      var errorListUrls = []
      var newListeEmbedding = []
      // console.log(' this.urls', this.urls)
      // recupere uniquement les url qui on eu les mot clés updatées
      for (const index in this.URLProducts) {
        if (this.URLProducts[index].updated) {
          newListeEmbedding.push(this.URLProducts[index].url)
        }
      }
      this.endLoading = newListeEmbedding.length
      // puiq pour chaque url upadated on execute un demande d'enregistrement embedding en base
      for (const url of newListeEmbedding) {
        console.log(' url product ', url)
        let dataToPost = {}
        dataToPost.licence = this.siteSelected.LIC_KEY
        dataToPost.url = [url]
        const response = await this.axios.post(this.serveurAI + 'embedding-url',
        dataToPost,
          {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
        )
        // si retour true, alors toutes les urls modifées doivent passé en update false
        if (response.data.retour) {
          this.startLoading++
          totalTraitementUrls++
          // si pas d'erreur
          if (response.data.url) {
            totalTraitementOK++
            // recherche dans les url pour mettre en updated false si elle existe
            let i = this.URLProducts.findIndex((element) => element.url === response.data.url)
            if (i !== -1) {
              // indicateur de modif ou d'ajout de mots clés pour cette url
              this.URLProducts[i].updated = false
              // indicateur que ce n'est plus une nouvelles url car elle a été traitée
              this.URLProducts[i].new = false
              // indicateur qu'il n'y a plus d'erreur sur cette url
              this.URLProducts[i].error = false
            }
          }
        } else {
          if (response.data.url) {
            totalTraitementKO++
            errorListUrls.push(response.data.url) // push l'url
            let i = this.URLProducts.findIndex((element) => element.url === response.data.url)
            if (i !== -1) {
              // indicateur qu'il n'y a plus d'erreur sur cette url
              this.URLProducts[i].error = true
            }
          // si il y a une erreur
          }
        }

        // this.loadingRes = false
        this.loadingModifUrl = false
        this.closeDialogUniquement = true
        this.messageResDialog = '<p class="loadingNum text-xs-center">' + this.$t('AISaveProc') + ' ' + totalTraitementUrls + '/' + this.endLoading + '</p>'
        this.messageResDialog += '<h3>' + this.$t('AIResData') + '</h3>'
        this.messageResDialog += '<p>'
        this.messageResDialog += this.$t('AIResDataOK') + ' <strong>' + totalTraitementOK + '/' + this.endLoading + '</strong><br>'
        this.messageResDialog += this.$t('AIResDataKO') + ' <strong>' + totalTraitementKO + '/' + this.endLoading + '</strong>'
        this.messageResDialog += '</p>'
        this.messageResDialog += '<div>' + this.$t('AIListKnowKO') + '<ol>'
        for (const url of errorListUrls) {
          this.messageResDialog += '<li class="font-weight-bold font-italic">' + url + '</li>'
        }
        this.messageResDialog += '</ol></div>'
        if (totalTraitementUrls === this.endLoading) {
          // Mise à jour de la liste des urls en erreur
          let dataMAJ = {}
          dataMAJ.licence = this.siteSelected.LIC_KEY
          dataMAJ.selectedUrls = this.selectedURLProducts
          dataMAJ.errorListUrls = errorListUrls
          this.majErrorListeUrls(dataMAJ)
          callback({retour: 1})
        }
      }
    },

    // lance le embedding des produits qui ont "updated" à true
    async submitEmbeddingAPIConfirm (callback) {
      this.loadingEmbeddingUrl = true
      this.loadingRes = true
      this.startLoading = 0
      var totalTraitementUrls = 0
      var totalTraitementOK = 0
      var totalTraitementKO = 0
      var errorListProducts = []
      var newListeEmbedding = []
      console.log(' this.products', this.products)
      // recupere uniquement les produits qui on eu les mot clés updatées
      for (const index in this.products) {
        if (this.products[index].updated) {
          newListeEmbedding.push(this.products[index].product)
        }
      }
      this.endLoading = newListeEmbedding.length
      // puiq pour chaque url upadated on execute un demande d'enregistrement embedding en base
      for (const product of newListeEmbedding) {
        let dataToPost = {}
        dataToPost.licence = this.siteSelected.LIC_KEY
        dataToPost.product = [product]
        const response = await this.axios.post(this.serveurAI + 'embedding-api',
        dataToPost,
          {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
        )
        // si retour true, alors toutes les urls modifées doivent passé en update false
        if (response.data.retour) {
          this.startLoading++
          totalTraitementUrls++
          // si pas d'erreur
          if (response.data.product) {
            totalTraitementOK++
            // recherche dans les url pour mettre en updated false si elle existe
            let i = this.products.findIndex((element) => element.product === response.data.product)
            if (i !== -1) {
              // indicateur de modif ou d'ajout de mots clés pour cette url
              this.products[i].updated = false
              // indicateur que ce n'est plus une nouvelles url car elle a été traitée
              this.products[i].new = false
              // indicateur qu'il n'y a plus d'erreur sur cette url
              this.products[i].error = false
            }
          }
        } else {
          if (response.data.product) {
            totalTraitementKO++
            errorListProducts.push(response.data.product) // push l'url
            let i = this.products.findIndex((element) => element.product === response.data.product)
            if (i !== -1) {
              // indicateur qu'il n'y a plus d'erreur sur cette url
              this.products[i].error = true
            }
          // si il y a une erreur
          }
        }

        // this.loadingRes = false
        this.loadingModifUrl = false
        this.closeDialogUniquement = true
        this.messageResDialog = '<p class="loadingNum text-xs-center">' + this.$t('AISaveProc') + ' ' + totalTraitementUrls + '/' + this.endLoading + '</p>'
        this.messageResDialog += '<h3>' + this.$t('AIResData') + '</h3>'
        this.messageResDialog += '<p>'
        this.messageResDialog += this.$t('AIResDataOK') + ' <strong>' + totalTraitementOK + '/' + this.endLoading + '</strong><br>'
        this.messageResDialog += this.$t('AIResDataKO') + ' <strong>' + totalTraitementKO + '/' + this.endLoading + '</strong>'
        this.messageResDialog += '</p>'
        this.messageResDialog += '<div>' + this.$t('AIListKnowKO') + '<ol>'
        for (const prod of errorListProducts) {
          this.messageResDialog += '<li class="font-weight-bold font-italic">' + prod + '</li>'
        }
        this.messageResDialog += '</ol></div>'
        if (totalTraitementUrls === this.endLoading) {
          // Mise à jour de la liste des urls en erreur
          let dataMAJ = {}
          dataMAJ.licence = this.siteSelected.LIC_KEY
          dataMAJ.selectedProducts = this.selectedProducts
          dataMAJ.errorListProducts = errorListProducts
          this.majErrorListeUrls(dataMAJ)
          callback({retour: 1})
        }
      }
    },

    // selection de l'action dans le menu déroulant pour les documents
    actionsFile () {
      if (this.selectActionFile === 'sup') {
        this.showDialogDeleteFile = true
      } else {
      }
    },

    // selection de l'action dans le menu déroulant pour les url
    actionsUrl () {
      if (this.selectActionUrl === 'sup') {
        this.showDialogDelete = true
      } else if (this.selectActionUrl === 'keywords') {
        this.showDialogAddKeyword = true
      } else if (this.selectActionUrl === 'lock') {
        this.showDialogLock = true
      } else {
      }
    },

    // selection de l'action dans le menu déroulant pour les urls produit
    actionsURLProduct () {
      if (this.selectActionURLProduct === 'sup') {
        this.showDialogDeleteURLProduct = true
      } else if (this.selectActionURLProduct === 'keywords') {
        this.showDialogAddKeywordURLProduct = true
      } else if (this.selectActionURLProduct === 'lock') {
        this.showDialogLockURLProduct = true
      } else {
      }
    },

    // selection de l'action dans le menu déroulant pour les api produit
    actionsProduct () {
      if (this.selectActionProduct === 'sup') {
        this.showDialogDeleteProduct = true
      } else if (this.selectActionProduct === 'keywords') {
        this.showDialogAddKeywordProduct = true
      } else if (this.selectActionProduct === 'lock') {
        this.showDialogLockProduct = true
      } else {
      }
    },

    // selection de l'action dans le menu déroulant pour les url
    actionsFAQ () {
      if (this.selectActionFAQ === 'sup') {
        this.showDialogDeletesFAQ = true
      } else {
      }
    },
    // selection de l'action dans le menu déroulant pour les url supprimmées
    actionsSuppUrl () {
      if (this.selectActionSuppUrl === 'sup') {
        this.showDialogDeleteSupp = true
      } else {
      }
    },

    justCloseDialogAddUrls () {
      this.showDialogAddUrls = false
      this.showDialogDelete = false
      this.showDialogProduct = false
      this.selectActionUrl = null
      this.selectActionProduct = null
      this.selectActionURLProduct = null
      this.selectedUrls = []
      this.selectedURLProducts = []
      this.selectedFaqs = []
      this.selectedFiles = []
      this.selectedProducts = []
      this.messageResDialog = ''
      this.closeDialogUniquement = false
      this.loadingRes = false
      this.loadingEmbeddingUrl = false
    },
    justCloseDialogAddFAQ () {
      this.showDialogAddUrls = false
      this.showDialogDelete = false
      this.showDialogProduct = false
      this.selectActionUrl = null
      this.selectActionProduct = null
      this.selectActionURLProduct = null
      this.selectedUrls = []
      this.selectedURLProducts = []
      this.selectedFaqs = []
      this.selectedFiles = []
      this.selectedProducts = []
      this.messageResDialog = ''
      this.closeDialogUniquement = false
      this.loadingRes = false
      this.loadingEmbeddingUrl = false
    },
    justCloseDialogEmdedding () {
      this.showDialogEmbedding = false
      this.messageResDialog = ''
      this.closeDialogUniquement = false
      this.loadingRes = false
      this.loadingEmbeddingUrl = false
    },
    justCloseDialogEmdeddingAPI () {
      this.showDialogEmbeddingAPI = false
      this.messageResDialog = ''
      this.closeDialogUniquement = false
      this.loadingRes = false
      this.loadingEmbeddingUrl = false
    },
    justCloseDialogEmdeddingURLProduct () {
      this.showDialogEmbeddingURLProduct = false
      this.messageResDialog = ''
      this.closeDialogUniquement = false
      this.loadingRes = false
      this.loadingEmbeddingUrl = false
    },
    justCloseDialogEnhancePrompt () {
      this.showDialogEnhancePrompt = false
      this.messageResDialog = ''
      this.closeDialogUniquement = false
      this.loadingRes = false
      this.loadingEmbeddingUrl = false
    },
    justCloseDialogVersionPrompt () {
      this.showDialogVersionPrompt = false
      this.messageResDialog = ''
      this.closeDialogUniquement = false
      this.loadingRes = false
      this.loadingEmbeddingUrl = false
    },
    justCloseDialogLock () {
      this.showDialogAddKeyword = false
      this.showDialogAddKeywordProduct = false
      this.showDialogAddKeywordURLProduct = false
      this.showDialogLock = false
      this.showDialogLockURLProduct = false
      this.showDialogLockProduct = false
      this.selectActionUrl = null
      this.selectActionProduct = null
      this.selectActionURLProduct = null
      this.selectedUrls = []
      this.selectedURLProducts = []
      this.selectedFaqs = []
      this.selectedFiles = []
      this.selectedProducts = []
      this.messageResDialog = ''
      this.closeDialogUniquement = false
      this.loadingRes = false
      this.loadingEmbeddingUrl = false
    },
    justCloseDialogConfirm () {
      this.showDialogAddKeyword = false
      this.showDialogAddKeywordProduct = false
      this.showDialogAddKeywordURLProduct = false
      this.showDialogDelete = false
      this.showDialogDeleteProduct = false
      this.showDialogDeleteURLProduct = false
      this.showDialogProduct = false
      this.selectActionUrl = null
      this.selectActionProduct = null
      this.selectActionURLProduct = null
      this.selectedUrls = []
      this.selectedURLProducts = []
      this.selectedFaqs = []
      this.selectedFiles = []
      this.selectedProducts = []
      this.messageResDialog = ''
      this.closeDialogUniquement = false
      this.loadingRes = false
      this.loadingEmbeddingUrl = false
    },
    justCloseDialogConfirmSupp () {
      this.showDialogDeleteSupp = false
      this.selectActionSuppUrl = null
      this.selectedSuppUrls = []
      this.messageResDialog = ''
      this.closeDialogUniquement = false
      this.loadingRes = false
      this.loadingEmbeddingUrl = false
    },
    justCloseDialogConfirmFile () {
      this.showDialogDeleteFile = false
      this.selectActionFile = null
      this.selectedFiles = []
      this.messageResDialog = ''
      this.closeDialogUniquement = false
      this.loadingRes = false
      this.loadingEmbeddingUrl = false
    },
    justCloseDialogConfirmFAQ () {
      this.showDialogDeletesFAQ = false
      this.selectActionFAQ = null
      this.selectedFaqs = []
      this.messageResDialog = ''
      this.closeDialogUniquement = false
      this.loadingRes = false
      this.loadingEmbeddingUrl = false
    },

    // ------------------------- analyse chat ---------------------------
    saveAnalyseChat (data) {
      this.analyseChat.push(data)
      this.savePrompt()
      this.showDialogAddAnalyseChat = false
    },
    modifAnalyseChat (data) {
      for (const index in this.analyseChat) {
        if (this.analyseChat[index].q === data.old.q) {
          this.analyseChat[index].q = data.new.q
          this.analyseChat[index].a = data.new.a
        }
      }
      // this.analyseChat.push(data)
      this.savePrompt()
      this.showDialogAddAnalyseChat = false
    },
    // selection de l'action dans le menu déroulant pour les analyse de chat
    actionsAnalyseChat () {
      if (this.selectActionAnalyseChat === 'sup') {
        this.showDialogDeleteAnalyseChat = true
      } else {
      }
    },
    justCloseDialogAnalyseChat () {
      this.showDialogAddAnalyseChat = false
      this.selectedModifAnalyseChat = {}
    },
    justCloseDialogConfirmAnalyseChat () {
      this.showDialogDeleteAnalyseChat = false
      this.selectActionAnalyseChat = null
      this.selectedAnalyseChat = []
    },
    submitDeleteAnalyseChatConfirm () {
      this.loadingModifAnalyseChat = true
      // suppression live des analyse de chat
      let newListeAnalyseChat = this.analyseChat
      for (const selectedAnalyse of this.selectedAnalyseChat) {
        this.analyseChat.forEach(function (q, index) {
          if (selectedAnalyse === q) {
            newListeAnalyseChat.splice(index, 1)
          }
        })
      }
      this.analyseChat = newListeAnalyseChat
      this.savePrompt()
      this.selectedModifAnalyseChat = {}
    },
    // ouvre le dialogue pour modifier les parametres d'analyse de chat
    async openDialogModifAnalyseChat (data) {
      this.showDialogAddAnalyseChat = true
      this.selectedModifAnalyseChat = data
      this.modifDialog = true
      this.titleAnalyseChat = this.$t('modifAnalyseChat')
    },
    // affiche la dialogBox ajout analyse
    addAnalyseChat () {
      this.showDialogAddAnalyseChat = true
      this.modifDialog = false
      this.titleAnalyseChat = this.$t('addAnalyseChat')
    },
    // -------------------------------------------------------------------

    majData (data) {
      for (const index in this.urls) {
        if (this.urls[index].url === data.url) {
          this.urls[index].updated = true
          this.urls[index].error = false
          this.urls[index].new = false
          this.urls[index].locked = data.locked
        }
      }
    },

    majDataURLProduct (data) {
      for (const index in this.URLProducts) {
        if (this.URLProducts[index].url === data.url) {
          this.URLProducts[index].updated = true
          this.URLProducts[index].error = false
          this.URLProducts[index].new = false
          this.URLProducts[index].locked = data.locked
        }
      }
    },

    majDataProduct (data) {
      for (const index in this.products) {
        if (this.products[index].product === data.product) {
          this.products[index].updated = true
          this.products[index].error = false
          this.products[index].new = false
          this.products[index].locked = data.locked
        }
      }
    },

    // -------------------------------------------------------------------
    // update ou ajoute une FAQ à la liste
    // -------------------------------------------------------------------
    majFAQ (data) {
      // console.log('maj faq', data)
      if (data.addFAQ) {
        let faq = {}
        faq.name = data.nameChunk
        faq.question = data.question
        faq.reponse = data.reponse
        faq.index = data.numFAQ
        this.faqs.push(faq)
      } else {
        for (const index in this.faqs) {
          if (this.faqs[index].name === data.nameChunk) {
            this.faqs[index].question = data.question
            this.faqs[index].reponse = data.reponse
          }
        }
      }
      this.numFAQ = this.faqs.length
    },

    // -------------------------------------------------------------------
    // Mise à jour de la liste apres suppression d'une FAQ
    // -------------------------------------------------------------------
    majSuppFAQ (data) {
      // console.log('maj supp  faq', data)
      let newListe = []
      let index = 0
      for (const name of data) {
        let idx = this.faqs.findIndex((element) => element.name === name.oldKey)
        if (idx !== -1) {
          // console.log('il faut changer le nom de cette cles : ', name.oldKey)
          this.faqs[idx].name = name.newKey
          this.faqs[idx].index = index
          newListe.push(this.faqs[idx])
          index++
        } else {
          // console.log('pas dans la liste des faqs')
        }
      }
      // console.log('newliste faqs : ', newListe)
      this.faqs = newListe
      this.numFAQ = this.faqs.length
    },

    // -------------------------------------------------------------------
    // suppression d'une licence et de tous ses elements rattachés
    // -------------------------------------------------------------------
    async submitDeleteLicenceConfirm () {
      // Données modifiées et à renvoyer
      let dataToPost = {}
      // dataToPost.licence = this.siteSelected.LIC_KEY // la licence selectionnée
      dataToPost.licence = '948580a42a7ace75df2befcdf0ec8a81'
      const response = await this.axios.post(this.serveurAI + 'delLicence',
      dataToPost,
        {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
      )
      // si la suppression dans redis est OK
      if (response.data.retour) {
        // suppression live des urls du tablrau urls de vue
        console.log('submitDeleteLicenceConfirm res : ', response.data)
      } else {
        console.log('submitDeleteLicenceConfirm res error : ', response.data)
      }
    },

    // -------------------------------------------------------------------
    // suppression de la liste des url actives selectionnées
    // -------------------------------------------------------------------
    async submitDeleteConfirm () {
      this.loadingModifUrl = true
      // Données modifiées et à renvoyer
      let dataToPost = {}
      dataToPost.licence = this.siteSelected.LIC_KEY
      dataToPost.listeDeleteUrls = this.selectedUrls
      const response = await this.axios.post(this.serveurAI + 'delLicenceUrls',
      dataToPost,
        {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
      )
      // si la suppression dans redis est OK
      if (response.data.retour) {
        // suppression live des urls du tablrau urls de vue
        let listDel = this.urlsSupp
        let newListeUrls = this.urls
        for (const selectedUrl of this.selectedUrls) {
          // mise à jour de la liste des urls
          let i = this.urls.findIndex((element) => element.url === selectedUrl.url)
          if (i !== -1) {
            // retire de la luste si il existe
            newListeUrls.splice(i, 1)
          }
          // mise à jour de la liste des urls supprimées
          let a = this.urlsSupp.findIndex((element) => element.url === selectedUrl.url)
          if (a === -1) {
            // ajoute dans la liste si il n'est pas present
            listDel.push({url: selectedUrl.url})
          }
        }
        this.urlsSupp = listDel
        this.urls = newListeUrls
        this.messageResDialog = '<h3>' + this.$t('AIRepResDell') + '</h3>'
        this.closeDialogUniquement = true
        this.loadingModifUrl = false
      } else {
        this.messageResDialog = '<h3>' + this.$t('AIRepErreurDelFAQ') + '</h3>'
        this.messageResDialog += '<div>' + response.data.info + '</div>'
        this.closeDialogUniquement = true
        this.loadingModifUrl = false
      }
    },

    // -------------------------------------------------------------------
    // suppression de la liste des produits actives selectionnées
    // -------------------------------------------------------------------
    async submitDeleteConfirmProduct () {
      console.log('selectedProducts', this.selectedProducts)
      this.loadingModifUrl = true
      // Données modifiées et à renvoyer
      let dataToPost = {}
      dataToPost.licence = this.siteSelected.LIC_KEY
      dataToPost.listeDeleteProducts = this.selectedProducts
      const response = await this.axios.post(this.serveurAI + 'delLicenceProducts',
      dataToPost,
        {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
      )
      // si la suppression dans redis est OK
      if (response.data.retour) {
        // suppression live des urls du tablrau urls de vue
        let listDel = this.productsSupp
        let newListeProducts = this.products
        for (const selectedProduct of this.selectedProducts) {
          // mise à jour de la liste des urls
          let i = this.products.findIndex((element) => element.product === selectedProduct.product)
          if (i !== -1) {
            // retire de la luste si il existe
            newListeProducts.splice(i, 1)
          }
          // mise à jour de la liste des urls supprimées
          let a = this.productsSupp.findIndex((element) => element.product === selectedProduct.product)
          if (a === -1) {
            // ajoute dans la liste si il n'est pas present
            listDel.push({product: selectedProduct.product})
          }
        }
        this.productsSupp = listDel
        this.products = newListeProducts
        this.messageResDialog = '<h3>' + this.$t('AIRepResDell') + '</h3>'
        this.closeDialogUniquement = true
        this.loadingModifUrl = false
      } else {
        this.messageResDialog = '<h3>' + this.$t('AIRepErreurDelFAQ') + '</h3>'
        this.messageResDialog += '<div>' + response.data.info + '</div>'
        this.closeDialogUniquement = true
        this.loadingModifUrl = false
      }
    },

    // -------------------------------------------------------------------
    // suppression de la liste des urls produits actives selectionnées
    // -------------------------------------------------------------------
    async submitDeleteConfirmURLProduct () {
      console.log('submitDeleteConfirmURLProduct selectedURLProducts', this.selectedURLProducts)
      this.loadingModifUrl = true
      // Données modifiées et à renvoyer
      let dataToPost = {}
      dataToPost.licence = this.siteSelected.LIC_KEY
      dataToPost.listeDeleteUrls = this.selectedURLProducts
      const response = await this.axios.post(this.serveurAI + 'delLicenceURLProducts',
      dataToPost,
        {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
      )
      // si la suppression dans redis est OK
      if (response.data.retour) {
        // suppression live des urls du tablrau urls de vue
        console.log('submitDeleteConfirmURLProduct this.URLProductsSupp', this.URLProductsSupp)
        let listDel = this.URLProductsSupp
        let newListeProducts = this.URLProducts
        for (const selectedURLProduct of this.selectedURLProducts) {
          // mise à jour de la liste des urls
          let i = this.URLProducts.findIndex((element) => element.url === selectedURLProduct.url)
          if (i !== -1) {
            // retire de la luste si il existe
            newListeProducts.splice(i, 1)
          }
          // mise à jour de la liste des urls supprimées
          let a = this.URLProductsSupp.findIndex((element) => element.url === selectedURLProduct.url)
          if (a === -1) {
            // ajoute dans la liste si il n'est pas present
            listDel.push({url: selectedURLProduct.url})
          }
        }
        this.URLProductsSupp = listDel
        this.URLProducts = newListeProducts
        this.messageResDialog = '<h3>' + this.$t('AIRepResDell') + '</h3>'
        this.closeDialogUniquement = true
        this.loadingModifUrl = false
      } else {
        this.messageResDialog = '<h3>' + this.$t('AIRepErreurDelFAQ') + '</h3>'
        this.messageResDialog += '<div>' + response.data.info + '</div>'
        this.closeDialogUniquement = true
        this.loadingModifUrl = false
      }
    },

    // -------------------------------------------------------------------
    // suppression de la liste des url inactives selectionnées
    // -------------------------------------------------------------------
    async submitDeleteConfirmFAQ () {
      // console.log('this.selectedFaqs', this.selectedFaqs)
      this.loadingModifSuppFAQ = true
      // Données modifiées et à renvoyer
      let req = {}
      req.licence = this.siteSelected.LIC_KEY// le fichier dédié au prompt scripté
      req.listeDeleteFAQ = this.selectedFaqs
      let dataToPost = {}
      dataToPost.data = req
      const response = await this.axios.post(this.serveurAI + 'delChunkFile',
      dataToPost,
        {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
      )
      // si la suppression dans redis est OK
      if (response.data.retour) {
        this.messageResDialog = '<h3>' + this.$t('AIRepResDellFAQ') + '</h3>'
        this.closeDialogUniquement = true
        this.loadingModifSuppFAQ = false
        this.majSuppFAQ(response.data.data)
      } else {
        this.messageResDialog = '<h3>' + this.$t('AIRepErreurDelFAQ') + '</h3>'
        this.messageResDialog += '<div>' + response.data.info + '</div>'
        this.closeDialogUniquement = true
        this.loadingModifSuppFAQ = false
      }
    },

    // -------------------------------------------------------------------
    // suppression de la liste des url inactives selectionnées
    // -------------------------------------------------------------------
    async submitDeleteConfirmSupp () {
      this.loadingModifSuppUrl = true
      // Données modifiées et à renvoyer
      let dataToPost = {}
      dataToPost.type = 'suupUrlInactif' // indique qu'il faut vider les url inactives
      dataToPost.licence = this.siteSelected.LIC_KEY + '-inactif'
      dataToPost.listeDeleteUrls = this.selectedSuppUrls
      const response = await this.axios.post(this.serveurAI + 'delLicenceUrlsSupp',
      dataToPost,
        {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
      )

      // si la suppression dans redis est OK
      if (response.data.retour) {
        // pour les urls
        let listDel = this.urlsSupp
        // pour les urls produit
        let listDelURLProduct = this.URLProductsSupp
        // suppression live des urls du tableau urls de vue et aussi de URLProducts à finir
        for (const selectedUrl of this.selectedSuppUrls) {
          // pour les urls
          this.urlsSupp.forEach(function (url, index) {
            if (selectedUrl === url) {
              listDel.splice(index, 1)
            }
          })
          // pour les urls produit
          this.URLProductsSupp.forEach(function (url, index) {
            if (selectedUrl === url) {
              listDelURLProduct.splice(index, 1)
            }
          })
        }
        this.urlsSupp = listDel
        this.URLProductsSupp = listDelURLProduct

        this.messageResDialog = '<h3>' + this.$t('AIRepResDell') + '</h3>'
        this.closeDialogUniquement = true
        this.loadingModifSuppUrl = false
      } else {
        this.messageResDialog = '<h3>' + this.$t('AIRepErreurDelFAQ') + '</h3>'
        this.messageResDialog += '<div>' + response.data.info + '</div>'
        this.closeDialogUniquement = true
        this.loadingModifSuppUrl = false
      }
    },

    // -------------------------------------------------------------------
    // ajoute des mots clès aux urls selectionnées
    // -------------------------------------------------------------------
    async submitAddKeywords () {
      this.loadingModifUrl = true
      this.loadingRes = true
      this.endLoading = this.selectedUrls.length
      this.startLoading = 0
      let totalSelectedUrls = this.selectedUrls.length
      let totalTraitementUrls = 0
      let totalTraitementOK = 0
      let totalTraitementKO = 0
      let errorListUrls = []
      this.messageResDialog = this.$t('AIKnowProc') + ' ' + totalTraitementUrls + '/' + totalSelectedUrls
      var nameReq = 'tokenize-listeUrls'
      // let prefix = ''
      // uniquement pour le dev
      // ou salaun
      // if (
      //   this.siteSelected.LIC_KEY === '948580a42a7ace75df2befcdf0ec8a81' || this.siteSelected.LIC_KEY === 'b3b0ec8748446e2f486bcc415315ccb7'
      // ) {
      //   nameReq = 'tokenize-listeUrls-api'
      //   // prefix = 'salaun_'
      // }
      console.log('ajout des mots clés', this.selectedUrls)
      for (const selected of this.selectedUrls) {
        console.log('slected url : ', selected)
        // Données modifiées et à renvoyer
        let dataToPost = {}
        dataToPost.licence = this.siteSelected.LIC_KEY
        dataToPost.listeUrls = [selected]
        dataToPost.parsingSelectif = this.parsingSelectif
        dataToPost.method = this.methodSelect
        dataToPost.parse = this.parseElement
        dataToPost.promptResume = this.promptResume
        // dataToPost.prefix = prefix
        const response = await this.axios.post(this.serveurAI + nameReq,
        dataToPost,
          {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
        )
        console.log('tokenize-listeUrls : ', response.data)
        if (response.data.update) {
          this.startLoading++
          // console.log('startLoading', this.startLoading)
          totalTraitementUrls++
          // si pas d'erreur
          if (response.data.status) {
            totalTraitementOK++
            let i = this.urls.findIndex((element) => element.url === response.data.url)
            if (i !== -1) {
              // indicateur de modif ou d'ajout de mots clés pour cette url
              this.urls[i].updated = true
              // indicateur que ce n'est plus une nouvelles url car elle a été traitée
              this.urls[i].new = false
              // indicateur qu'il n'y a plus d'erreur sur cette url
              this.urls[i].error = false
              // date de la mise à jour
              this.urls[i].timestamp = moment(Date.now()).format('lll')
            }
          // si il y a une erreur
          } else {
            totalTraitementKO++
            errorListUrls.push(response.data.url) // push l'url
            let i = this.urls.findIndex((element) => element.url === response.data.url)
            if (i !== -1) {
              // indicateur d'erreur sur cette url
              this.urls[i].error = true
            }
          }
          console.log('this.urls : ', this.urls)
        }

        // this.loadingRes = false
        this.loadingModifUrl = false
        this.closeDialogUniquement = true
        this.messageResDialog = '<p class="loadingNum text-xs-center">' + this.$t('AIKnowProc') + ' ' + totalTraitementUrls + '/' + totalSelectedUrls + '</p>'
        this.messageResDialog += '<h3>' + this.$t('AIResKnow') + '</h3>'
        this.messageResDialog += '<p>'
        this.messageResDialog += this.$t('AIResKnowOK') + ' <strong>' + totalTraitementOK + '/' + totalSelectedUrls + '</strong><br>'
        this.messageResDialog += this.$t('AIResKnowKO') + ' <strong>' + totalTraitementKO + '/' + totalSelectedUrls + '</strong>'
        this.messageResDialog += '</p>'
        this.messageResDialog += '<div>' + this.$t('AIListKnowKO') + '<ol>'
        for (const url of errorListUrls) {
          this.messageResDialog += '<li class="font-weight-bold font-italic">' + url + '</li>'
        }
        this.messageResDialog += '</ol></div>'
        console.log(totalTraitementUrls + ' === ' + this.endLoading)
        if (totalTraitementUrls === this.endLoading) {
          // Mise à jour de la liste des urls en erreur
          let dataMAJ = {}
          dataMAJ.licence = this.siteSelected.LIC_KEY
          dataMAJ.selectedUrls = this.selectedUrls
          dataMAJ.errorListUrls = errorListUrls
          // console.log('majErrorListeUrls')
          this.majErrorListeUrls(dataMAJ)
        }
      }
    },

    // -------------------------------------------------------------------
    // ajoute des mots clès aux produits selectionnées
    // -------------------------------------------------------------------
    async submitAddKeywordsProducts () {
      this.loadingModifUrl = true
      this.loadingRes = true
      this.endLoading = this.selectedProducts.length
      this.startLoading = 0
      let totalSelectedProducts = this.selectedProducts.length
      let totalTraitementProducts = 0
      let totalTraitementOK = 0
      let totalTraitementKO = 0
      let errorListProducts = []
      this.messageResDialog = this.$t('AIKnowProc') + ' ' + totalTraitementProducts + '/' + totalSelectedProducts
      var nameReq = 'tokenize-listeProducts-api'
      // let prefix = ''
      // uniquement pour le dev
      // ou salaun
      if (
        this.siteSelected.LIC_KEY === '948580a42a7ace75df2befcdf0ec8a81' || this.siteSelected.LIC_KEY === 'b3b0ec8748446e2f486bcc415315ccb7'
      ) {
        nameReq = 'tokenize-listeProducts-api'
        // prefix = 'salaun_'
      }
      // console.log('ajout des mots clés', this.selectedProducts)
      for (const selected of this.selectedProducts) {
        // console.log('slected url : ', selected)
        // Données modifiées et à renvoyer
        let dataToPost = {}
        dataToPost.licence = this.siteSelected.LIC_KEY
        dataToPost.listeProducts = [selected]
        dataToPost.parsingSelectif = this.parsingSelectif
        dataToPost.method = this.methodSelect
        dataToPost.parse = this.parseElement
        dataToPost.promptResume = this.promptResume
        // dataToPost.prefix = prefix
        const response = await this.axios.post(this.serveurAI + nameReq,
        dataToPost,
          {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
        )
        // console.log('tokenize-listeUrls : ', response.data)
        if (response.data.update) {
          this.startLoading++
          // console.log('startLoading', this.startLoading)
          totalTraitementProducts++
          // si pas d'erreur
          if (response.data.status) {
            totalTraitementOK++
            let i = this.products.findIndex((element) => element.product === response.data.product)
            if (i !== -1) {
              // indicateur de modif ou d'ajout de mots clés pour cette url
              this.products[i].updated = true
              // indicateur que ce n'est plus une nouvelles url car elle a été traitée
              this.products[i].new = false
              // indicateur qu'il n'y a plus d'erreur sur cette url
              this.products[i].error = false
              // date de la mise à jour
              this.products[i].timestamp = moment(Date.now()).format('lll')
            }
          // si il y a une erreur
          } else {
            totalTraitementKO++
            errorListProducts.push(response.data.product) // push l'url
            let i = this.products.findIndex((element) => element.product === response.data.product)
            if (i !== -1) {
              // indicateur d'erreur sur cette url
              this.products[i].error = true
            }
          }
        }

        // this.loadingRes = false
        this.loadingModifUrl = false
        this.closeDialogUniquement = true
        this.messageResDialog = '<p class="loadingNum text-xs-center">' + this.$t('AIKnowProc') + ' ' + totalTraitementProducts + '/' + totalSelectedProducts + '</p>'
        this.messageResDialog += '<h3>' + this.$t('AIResKnow') + '</h3>'
        this.messageResDialog += '<p>'
        this.messageResDialog += this.$t('AIResKnowOK') + ' <strong>' + totalTraitementOK + '/' + totalSelectedProducts + '</strong><br>'
        this.messageResDialog += this.$t('AIResKnowKO') + ' <strong>' + totalTraitementKO + '/' + totalSelectedProducts + '</strong>'
        this.messageResDialog += '</p>'
        this.messageResDialog += '<div>' + this.$t('AIListKnowKO') + '<ol>'
        for (const product of errorListProducts) {
          this.messageResDialog += '<li class="font-weight-bold font-italic">' + product + '</li>'
        }
        this.messageResDialog += '</ol></div>'
        // console.log(totalTraitementProducts + ' === ' + this.endLoading)
        if (totalTraitementProducts === this.endLoading) {
          // Mise à jour de la liste des produits en erreur
          let dataMAJ = {}
          dataMAJ.licence = this.siteSelected.LIC_KEY
          dataMAJ.selectedProducts = this.selectedProducts
          dataMAJ.errorListProducts = errorListProducts
          // this.majErrorListeProducts(dataMAJ)
        }
      }
    },

    // -------------------------------------------------------------------
    // ajoute des mots clès aux urls produits selectionnées
    // -------------------------------------------------------------------
    async submitAddKeywordsURLProducts () {
      this.loadingModifUrl = true
      this.loadingRes = true
      this.endLoading = this.selectedURLProducts.length
      this.startLoading = 0
      let totalSelectedProducts = this.selectedURLProducts.length
      let totalTraitementUrls = 0
      let totalTraitementOK = 0
      let totalTraitementKO = 0
      let errorListProducts = []
      this.messageResDialog = this.$t('AIKnowProc') + ' ' + totalTraitementUrls + '/' + totalSelectedProducts
      var nameReq = 'tokenize-listeUrls'
      console.log('ajout des mots clés', this.selectedURLProducts)
      for (const selected of this.selectedURLProducts) {
        console.log('slected url : ', selected)
        // Données modifiées et à renvoyer
        let dataToPost = {}
        dataToPost.licence = this.siteSelected.LIC_KEY
        dataToPost.listeUrls = [selected]
        dataToPost.parsingSelectif = this.parsingSelectif
        dataToPost.method = this.methodSelect
        dataToPost.parse = this.parseElement
        dataToPost.promptResume = this.promptResume
        // dataToPost.prefix = prefix
        const response = await this.axios.post(this.serveurAI + nameReq,
        dataToPost,
          {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
        )
        console.log('tokenize-listeUrls : ', response.data)
        if (response.data.update) {
          this.startLoading++
          // console.log('startLoading', this.startLoading)
          totalTraitementUrls++
          // si pas d'erreur
          if (response.data.status) {
            totalTraitementOK++
            let i = this.URLProducts.findIndex((element) => element.url === response.data.url)
            if (i !== -1) {
              // indicateur de modif ou d'ajout de mots clés pour cette url
              this.URLProducts[i].updated = true
              // indicateur que ce n'est plus une nouvelles url car elle a été traitée
              this.URLProducts[i].new = false
              // indicateur qu'il n'y a plus d'erreur sur cette url
              this.URLProducts[i].error = false
              // date de la mise à jour
              this.URLProducts[i].timestamp = moment(Date.now()).format('lll')
            }
          // si il y a une erreur
          } else {
            totalTraitementKO++
            errorListProducts.push(response.data.url) // push l'url
            let i = this.URLProducts.findIndex((element) => element.url === response.data.url)
            if (i !== -1) {
              // indicateur d'erreur sur cette url
              this.URLProducts[i].error = true
            }
          }
          console.log('this.URLProducts : ', this.URLProducts)
        }

        // this.loadingRes = false
        this.loadingModifUrl = false
        this.closeDialogUniquement = true
        this.messageResDialog = '<p class="loadingNum text-xs-center">' + this.$t('AIKnowProc') + ' ' + totalTraitementUrls + '/' + totalSelectedProducts + '</p>'
        this.messageResDialog += '<h3>' + this.$t('AIResKnow') + '</h3>'
        this.messageResDialog += '<p>'
        this.messageResDialog += this.$t('AIResKnowOK') + ' <strong>' + totalTraitementOK + '/' + totalSelectedProducts + '</strong><br>'
        this.messageResDialog += this.$t('AIResKnowKO') + ' <strong>' + totalTraitementKO + '/' + totalSelectedProducts + '</strong>'
        this.messageResDialog += '</p>'
        this.messageResDialog += '<div>' + this.$t('AIListKnowKO') + '<ol>'
        for (const product of errorListProducts) {
          this.messageResDialog += '<li class="font-weight-bold font-italic">' + product + '</li>'
        }
        this.messageResDialog += '</ol></div>'
        // console.log(totalTraitementUrls + ' === ' + this.endLoading)
        if (totalTraitementUrls === this.endLoading) {
          // Mise à jour de la liste des produits en erreur
          let dataMAJ = {}
          dataMAJ.licence = this.siteSelected.LIC_KEY
          dataMAJ.selectedProducts = this.selectedURLProducts
          dataMAJ.errorListProducts = errorListProducts
          this.majErrorListeUrls(dataMAJ)
        }
      }
    },

    // -------------------------------------------------------------------
    // suppression de la liste de fichiers selectionnés
    // -------------------------------------------------------------------
    async majErrorListeUrls (data) {
      let dataToPost = data
      // dataToPost.licence = this.siteSelected.LIC_KEY
      // dataToPost.listeUrls = [selected]
      // dataToPost.method = this.methodSelect
      // dataToPost.parse = this.parseElement
      const response = await this.axios.post(this.serveurAI + 'MajListeErrorUrls',
      dataToPost,
        {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
      )
      console.log('MajListeErrorUrls : ', response.data)
    },

    // -------------------------------------------------------------------
    // verrouille les urls selectionnées
    // -------------------------------------------------------------------
    async submitLockConfirm () {
      this.loadingModifUrl = true
      this.loadingRes = true
      this.endLoading = this.selectedUrls.length
      this.startLoading = 0
      let totalSelectedUrls = this.selectedUrls.length
      let totalTraitementUrls = 0
      // let totalTraitementOK = 0
      // let totalTraitementKO = 0
      // let errorListUrls = []
      this.messageResDialog = this.$t('AIKnowProc') + ' ' + totalTraitementUrls + '/' + totalSelectedUrls
      for (const selected of this.selectedUrls) {
        // Données modifiées et à renvoyer
        let dataToPost = {}
        dataToPost.licence = this.siteSelected.LIC_KEY
        dataToPost.listeUrls = [selected]
        dataToPost.method = this.methodSelect
        dataToPost.parse = this.parseElement
        dataToPost.promptResume = this.promptResume
        const response = await this.axios.post(this.serveurAI + 'locked-listeUrls',
        dataToPost,
          {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
        )
        if (response.data.retour) {
          totalTraitementUrls++
          this.startLoading++
          let i = this.urls.findIndex((element) => element.url === response.data.url)
          if (i !== -1) {
            // indicateur d'erreur sur cette url
            this.urls[i].locked = true
          }
        }
        this.closeDialogUniquement = true
        this.messageResDialog = '<p class="loadingNum text-xs-center">' + this.$t('AIURLProc') + ' ' + totalTraitementUrls + '/' + totalSelectedUrls + '</p>'
        if (totalTraitementUrls === this.endLoading) {
          this.messageResDialog += '<h3>' + this.$t('AIProcEnd') + ' ' + totalTraitementUrls + '</h3>'
          this.loadingModifUrl = false
        }
      }
    },

    // -------------------------------------------------------------------
    // verrouille les produits selectionnées
    // -------------------------------------------------------------------
    async submitLockConfirmProduct () {
      this.loadingModifUrl = true
      this.loadingRes = true
      this.endLoading = this.selectedProducts.length
      this.startLoading = 0
      let totalSelectedProducts = this.selectedProducts.length
      let totalTraitementProducts = 0
      // let totalTraitementOK = 0
      // let totalTraitementKO = 0
      // let errorListUrls = []
      this.messageResDialog = this.$t('AIKnowProc') + ' ' + totalTraitementProducts + '/' + totalSelectedProducts
      for (const selected of this.selectedProducts) {
        // Données modifiées et à renvoyer
        let dataToPost = {}
        dataToPost.licence = this.siteSelected.LIC_KEY
        dataToPost.listeProducts = [selected]
        dataToPost.method = this.methodSelect
        dataToPost.parse = this.parseElement
        dataToPost.promptResume = this.promptResume
        const response = await this.axios.post(this.serveurAI + 'locked-listeProducts',
        dataToPost,
          {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
        )
        if (response.data.retour) {
          totalTraitementProducts++
          this.startLoading++
          let i = this.products.findIndex((element) => element.product === response.data.product)
          if (i !== -1) {
            // indicateur d'erreur sur cette url
            this.products[i].locked = true
          }
        }
        this.closeDialogUniquement = true
        this.messageResDialog = '<p class="loadingNum text-xs-center">' + this.$t('AIURLProc') + ' ' + totalTraitementProducts + '/' + totalSelectedProducts + '</p>'
        if (totalTraitementProducts === this.endLoading) {
          this.messageResDialog += '<h3>' + this.$t('AIProcEnd') + ' ' + totalTraitementProducts + '</h3>'
          this.loadingModifUrl = false
        }
      }
    },

    // -------------------------------------------------------------------
    // verrouille les urls produits selectionnées
    // -------------------------------------------------------------------
    async submitLockConfirmURLProduct () {
      this.loadingModifUrl = true
      this.loadingRes = true
      this.endLoading = this.selectedURLProducts.length
      this.startLoading = 0
      let totalSelectedProducts = this.selectedURLProducts.length
      let totalTraitementProducts = 0
      // let totalTraitementOK = 0
      // let totalTraitementKO = 0
      // let errorListUrls = []
      this.messageResDialog = this.$t('AIKnowProc') + ' ' + totalTraitementProducts + '/' + totalSelectedProducts
      for (const selected of this.selectedURLProducts) {
        // Données modifiées et à renvoyer
        let dataToPost = {}
        dataToPost.licence = this.siteSelected.LIC_KEY
        dataToPost.listeUrls = [selected]
        dataToPost.method = this.methodSelect
        dataToPost.parse = this.parseElement
        dataToPost.promptResume = this.promptResume
        const response = await this.axios.post(this.serveurAI + 'locked-listeUrls',
        dataToPost,
          {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
        )
        if (response.data.retour) {
          totalTraitementProducts++
          this.startLoading++
          let i = this.URLProducts.findIndex((element) => element.product === response.data.product)
          if (i !== -1) {
            // indicateur d'erreur sur cette url
            this.URLProducts[i].locked = true
          }
        }
        this.closeDialogUniquement = true
        this.messageResDialog = '<p class="loadingNum text-xs-center">' + this.$t('AIURLProc') + ' ' + totalTraitementProducts + '/' + totalSelectedProducts + '</p>'
        if (totalTraitementProducts === this.endLoading) {
          this.messageResDialog += '<h3>' + this.$t('AIProcEnd') + ' ' + totalTraitementProducts + '</h3>'
          this.loadingModifUrl = false
        }
      }
    },

    // -------------------------------------------------------------------
    // suppression de la liste de fichiers selectionnés
    // -------------------------------------------------------------------
    async submitDeleteFileConfirm () {
      this.loadingModifFile = true
      // suppression live des fichiers du tablrau files de vue
      let newListeFiles = this.files
      for (const selectedFile of this.selectedFiles) {
        // console.log('selectedFile', selectedFile)
        this.files.forEach(function (file, index) {
          // console.log('%d: %s', i, url)
          if (selectedFile === file) {
            // console.log('ca match file', index)
            newListeFiles.splice(index, 1)
          }
        })
      }
      this.files = newListeFiles
      // Données modifiées et à renvoyer
      let dataToPost = {}
      dataToPost.licence = this.siteSelected.LIC_KEY
      dataToPost.listeDeleteFiles = this.selectedFiles
      this.axios.post(this.serveurAI + 'delLicenceFiles',
      dataToPost,
        {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
      )
      // efface la dialogBox
      this.showDialogDeleteFile = false
      this.selectActionFile = null
      this.loadingModifFile = false
    },

    // ouvre le dialogue de modification les mots clés de la page
    async openDialogUpdateKeyword (data) {
      this.showDialogModifKeyword = true
      this.keywordUrl = data.url
    },
    // ouvre le dialogue de modification les mots clés de l'url du produit
    async openDialogUpdateKeywordURLProduct (data) {
      this.showDialogModifKeywordURLProduct = true
      this.keywordUrl = data.url
    },
    // ouvre le dialogue de modification les mots clés du produit
    async openDialogUpdateKeywordProduct (data) {
      console.log('openDialogUpdateKeywordProduct ', data)
      this.showDialogModifKeywordProduct = true
      this.keywordProduct = data.product
    },
    async openDialogUpdateFAQ (data) {
      this.showDialogModifFAQ = true
      this.questAnsw = data
      this.addFAQ = false
    },
    justCloseDialogKeyword () {
      this.showDialogModifKeyword = false
    },
    justCloseDialogKeywordURLProduct () {
      this.showDialogModifKeywordURLProduct = false
    },
    justCloseDialogKeywordProduct () {
      this.showDialogModifKeywordProduct = false
    },
    justCloseDialogFAQ () {
      this.showDialogModifFAQ = false
    },
    justCloseDialogImportPDF () {
      this.showDialogImportPDF = false
      // il faut rechercher la liste des fichier
    },
    justCloseDialogChunkPDF () {
      this.showDialogChunkPDF = false
    },
    justCloseDialogResume () {
      this.showDialogResume = false
    },
    // ajoute une fonction
    addFunction () {
      if (this.fonctionsNum < 9) {
        this.addFonctionsNum++
      }
    },
    // ajoute une fonction
    addParsing () {
      this.parsingSelectif.push({name: '', methode: '', elements: '', default: false})
    },
    // ouvre le dialogue de modification les FAQ
    async getChunkFiles (data) {
      this.loadingData = true
      let dataToPost = {}
      dataToPost.data = data
      // console.log('getChunkFiles dataToPost : ', dataToPost)
      const response = await this.axios.post(this.serveurAI + 'getChunkFiles',
      dataToPost,
        {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
      )
      if (response.data.retour) {
        // console.log('response : ', response.data.data)

        this.chunks = response.data.data
        // this.loadingData = false
        setTimeout(() => {
          this.loadingData = false
        }, 500)
      }
    },
    // test le status de la bride pour afficher le menu
    testBrideStatus (name) {
      // console.log('name', name)
      let brides = this.$store.state._User.brides
      // console.log('brides', brides)
      if (brides) {
        let resultat = brides.find(brides => brides.brideName === name)
        if (resultat) {
          if (resultat.status === '0') {
            return true
          } else {
            return false
          }
        }
      }
    },
    delParsing (e) {
      console.log('delete parsing ', e)
      this.SelectedParsingSupp = e
      this.showDialogDeleteParsing = true
    },
    justCloseDialogConfirmParsing () {
      this.showDialogDeleteParsing = false
      this.selectActionParsing = null
      this.SelectedParsingSupp = {}
    },
    submitDeleteParsing () {
      console.log('del pars', this.SelectedParsingSupp)
      if (this.SelectedParsingSupp.name) {
        for (const index in this.parsingSelectif) {
          if (this.parsingSelectif[index] === this.SelectedParsingSupp) {
            console.log('il y a bien un parsing à supprimer', this.parsingSelectif[index].name + ' - ' + index)
            this.parsingSelectif.splice(index, 1)
          }
        }
      }
      this.justCloseDialogConfirmParsing()
    },
    switchComportment () {
      this.comportment ? this.comportment = true : this.comportment = false
    },
    switchExemple () {
      this.showEx ? this.showEx = true : this.showEx = false
    },
    enhance (section) {
      this.showDialogEnhancePrompt = true
    },
    version (section) {
      this.showDialogVersionPrompt = true
    }
  },
  watch: {
    '$store.state._Sites.siteSelected': function (val, oldVal) {
      // recupère la liste des urls du client dans redis
      this.loadUrlsClient('actif')
      // recupère la liste des produits du client dans redis
      this.loadProductsClient('actif')
      // recupère la liste des urls produits du client dans redis
      this.loadURLProductsClient('actif')
      // recupère la liste des documents du client dans redis
      this.loadFilesClient(this.siteSelected.LIC_KEY)
      // recupère la liste des FAQ du client dans redis
      this.loadFaqsClient()
    },
    dateStartPicker (val, oldVal) {
      // update de la date de début à 00:00:00
      this.$store.commit('_Stats/SET_DATE_START', moment(val, 'YYYY-MM-DD').hours(0).minutes(0).seconds(0).format())
    },
    dateEndPicker (val, oldVal) {
      // update de la date de fin à 23:59:59
      this.$store.commit('_Stats/SET_DATE_END', moment(val, 'YYYY-MM-DD').hours(23).minutes(59).seconds(59).format())
    },
    tokenParams (v) {
      this.getAll()
    },
    period (val, oldVal) {
      // update des dates affichées
      this.initDates()
      // update de la période date dans le store
      this.$store.commit('_Stats/SET_PERIOD', val)
    },
    // au changement d'intervalle, il faut actualiser les series du graphique
    interval: function (val, oldVal) {
      this.updateSeries()
    },
    // au changement d'intervalle, il faut actualiser les series du graphique
    utilisation: function (val, oldVal) {
      // console.log('utilisation interval :', val)
      this.updateSeries()
    }
  }
}
</script>

<style scoped>
  .layout > .flex {
    padding-left: 8px;
    padding-right: 8px;
  }
  .hidden {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/botbuilder/openAIConfig.vue